import*as React from'react';import React__default,{useEffect,forwardRef,Component,useState,useContext,useLayoutEffect,useRef,useMemo,createFactory,useCallback,Children,isValidElement,createContext}from'react';import _extends from'@babel/runtime/helpers/extends';import _slicedToArray from'@babel/runtime/helpers/slicedToArray';import _objectWithoutProperties from'@babel/runtime/helpers/objectWithoutProperties';import mergeRefs from'react-merge-refs';import useStyles,{inline}from'substyle';import _classCallCheck from'@babel/runtime/helpers/classCallCheck';import _createClass from'@babel/runtime/helpers/createClass';import _assertThisInitialized from'@babel/runtime/helpers/assertThisInitialized';import _inherits from'@babel/runtime/helpers/inherits';import _possibleConstructorReturn from'@babel/runtime/helpers/possibleConstructorReturn';import _getPrototypeOf from'@babel/runtime/helpers/getPrototypeOf';import _defineProperty from'@babel/runtime/helpers/defineProperty';import _omit from'lodash/omit';import {setDisplayName,wrapDisplayName,withHandlers,compose,mapProps,lifecycle,withStateHandlers,pure,withProps,withPropsOnChange,withState}from'recompose';import _toConsumableArray from'@babel/runtime/helpers/toConsumableArray';import _some from'lodash/fp/some';import _findIndex from'lodash/fp/findIndex';import VirtualList from'react-tiny-virtual-list';import _isNil from'lodash/isNil';import _find from'lodash/find';import _omit$1 from'lodash/fp/omit';import _mapValues from'lodash/mapValues';import invariant from'invariant';import ReactDom,{findDOMNode,createPortal}from'react-dom';import Stick,{PortalContext}from'react-stick';import isURL from'validator/lib/isURL';import isEmail from'validator/lib/isEmail';import normalizeEmail from'validator/lib/normalizeEmail';import {endOfMonth,isValid,format,isSameMonth,isSameDay as isSameDay$1}from'date-fns';import _typeof from'@babel/runtime/helpers/typeof';import _curry from'lodash/curry';import _isNumber from'lodash/isNumber';import _memoize from'lodash/memoize';import _identity from'lodash/identity';import _reduce from'lodash/reduce';import {Transition}from'react-transition-group';import _uniqueId from'lodash/uniqueId';import PropTypes from'prop-types';import AutosizeTextarea from'react-textarea-autosize';import _isString from'lodash/isString';import _forEach from'lodash/forEach';import'matchmedia-polyfill';import'matchmedia-polyfill/matchMedia.addListener';import useMedia from'use-media';import Color from'color';import _noop from'lodash/noop';import {createFocusTrap}from'focus-trap';function deprecateExport(Component, message) {
  return function (props) {
    useEffect(function () {
      console.warn(message);
    }, []);
    return /*#__PURE__*/React__default.createElement(Component, props);
  };
}var _excluded$L = ["value", "onChange", "style", "inputRef", "className", "classNames", "autoComplete", "disabled", "title"];
var Input = function Input(_ref, ref) {
  var value = _ref.value,
    _onChange = _ref.onChange,
    style = _ref.style,
    inputRef = _ref.inputRef,
    className = _ref.className,
    classNames = _ref.classNames,
    _ref$autoComplete = _ref.autoComplete,
    autoComplete = _ref$autoComplete === void 0 ? 'off' : _ref$autoComplete,
    disabled = _ref.disabled,
    title = _ref.title,
    rest = _objectWithoutProperties(_ref, _excluded$L);
  var styles = useStyles(defaultStyle$8, {
    style: style,
    className: className,
    classNames: classNames
  });
  var inputTitle = title !== null && title !== void 0 ? title : disabled ? value : undefined;
  return /*#__PURE__*/React__default.createElement("input", _extends({}, rest, styles, {
    disabled: disabled,
    title: inputTitle,
    value: value === null ? '' : value,
    onChange: function onChange(event) {
      var target = event.target;
      if (typeof target.value !== 'string') {
        return;
      }
      if (_onChange) {
        _onChange(target.value, event);
      }
    },
    ref: mergeRefs([ref, inputRef]),
    autoComplete: autoComplete
  }));
};
var defaultStyle$8 = {
  display: 'block',
  width: '100%',
  ':invalid': {
    boxShadow: 'none' // a red glow is added by firefox
  }
};

var Input$1 = /*#__PURE__*/forwardRef(Input);var _excluded$K = ["value"];
function _createSuper$c(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$c(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct$c() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function createGetMappers(createMappers, memoizer) {
  if (typeof createMappers !== 'function') {
    var mappers = createMappers;
    var mapperFunc = function mapperFunc() {
      return mappers;
    };
    return mapperFunc;
  }
  if (memoizer) {
    return _memoize(createMappers, memoizer);
  }
  return createMappers;
}
function createValueMapper(createMappers, memoizer) {
  var getMappers = createGetMappers(createMappers, memoizer);
  var updateInternalValue = function updateInternalValue(_ref, props) {
    var hasFocus = _ref.hasFocus,
      internalValue = _ref.internalValue;
    var value = props.value;
    var _getMappers = getMappers(props),
      mapDownFocus = _getMappers.mapDownFocus,
      mapDown = _getMappers.mapDown,
      mapUp = _getMappers.mapUp;
    if (hasFocus) {
      var mappedUp = mapUp(internalValue);
      var bothEmpty = _isNil(mappedUp) && _isNil(value);

      // apply only if value from outside differs to the mapped up current internal value
      if (mapUp(internalValue) !== value && !bothEmpty) {
        return {
          internalValue: (mapDownFocus || mapDown)(value)
        };
      }
    } else {
      return {
        internalValue: mapDown(value)
      };
    }
    return {};
  };
  return function (WrappedComponent) {
    return /*#__PURE__*/function (_Component) {
      _inherits(ValueMapper, _Component);
      var _super = _createSuper$c(ValueMapper);
      function ValueMapper(props) {
        var _this;
        _classCallCheck(this, ValueMapper);
        _this = _super.call(this, props);
        _defineProperty(_assertThisInitialized(_this), "handleChange", function (newValue) {
          var _this$props = _this.props,
            value = _this$props.value,
            onChange = _this$props.onChange;
          var internalValue = _this.state.internalValue;
          var _getMappers2 = getMappers(_this.props),
            mapUp = _getMappers2.mapUp,
            _getMappers2$sanitize = _getMappers2.sanitize,
            sanitize = _getMappers2$sanitize === void 0 ? _identity : _getMappers2$sanitize;
          var cleanValue = sanitize(newValue);
          if (cleanValue !== internalValue) {
            _this.setState({
              internalValue: cleanValue
            });
            var nextValue = mapUp(cleanValue);
            if (value !== nextValue && typeof onChange === 'function') {
              onChange(nextValue);
            }
          }
        });
        _defineProperty(_assertThisInitialized(_this), "handleFocus", function (ev) {
          var _this$props2 = _this.props,
            onFocus = _this$props2.onFocus,
            value = _this$props2.value;
          var _getMappers3 = getMappers(_this.props),
            mapDownFocus = _getMappers3.mapDownFocus,
            mapDown = _getMappers3.mapDown;
          _this.setState({
            hasFocus: true,
            internalValue: (mapDownFocus || mapDown)(value)
          });
          if (typeof onFocus === 'function') onFocus(ev);
        });
        _defineProperty(_assertThisInitialized(_this), "handleBlur", function (ev) {
          var _this$props3 = _this.props,
            onBlur = _this$props3.onBlur,
            value = _this$props3.value;
          var _getMappers4 = getMappers(_this.props),
            mapDown = _getMappers4.mapDown;
          _this.setState({
            hasFocus: false,
            internalValue: mapDown(value)
          });
          if (typeof onBlur === 'function') onBlur(ev);
        });
        var _value = props.value;
        var _getMappers5 = getMappers(props),
          _mapDown = _getMappers5.mapDown;
        _this.state = {
          hasFocus: false,
          internalValue: _mapDown(_value)
        };
        return _this;
      }
      _createClass(ValueMapper, [{
        key: "componentDidUpdate",
        value: function componentDidUpdate(prevProps) {
          if (this.props.value === prevProps.value) {
            return;
          }

          // if a new value is passed from outside, apply it
          this.setState(updateInternalValue);
        }
      }, {
        key: "render",
        value: function render() {
          var _this$props4 = this.props,
            value = _this$props4.value,
            rest = _objectWithoutProperties(_this$props4, _excluded$K);
          var _this$state = this.state,
            hasFocus = _this$state.hasFocus,
            internalValue = _this$state.internalValue;
          return /*#__PURE__*/React__default.createElement(WrappedComponent, _extends({}, _omit(rest, 'onChange'), {
            onChange: this.handleChange,
            onFocus: this.handleFocus,
            onBlur: this.handleBlur,
            value: hasFocus ? internalValue : getMappers(this.props).mapDown(value)
          }));
        }
      }]);
      return ValueMapper;
    }(Component);
  };
}function sequence() {
  for (var _len = arguments.length, functions = new Array(_len), _key = 0; _key < _len; _key++) {
    functions[_key] = arguments[_key];
  }
  return function () {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    functions.forEach(function (func) {
      return func && func.apply(void 0, args);
    });
  };
}function isNumber(number) {
  return _isNumber(number) && !isNaN(number);
}var isIE10OrLower = typeof navigator !== 'undefined' && /MSIE/i.test(navigator.userAgent);
var isIE11OrLower = isIE10OrLower || !!navigator.userAgent.match(/Trident.*rv:11\./);var detectBrowser=/*#__PURE__*/Object.freeze({__proto__:null,isIE10OrLower:isIE10OrLower,isIE11OrLower:isIE11OrLower});function formatUri$1(uri) {
  if (uri == null) {
    return null;
  }
  if (isURL(uri, {
    require_protocol: true,
    require_tld: false,
    require_valid_protocol: false
  })) {
    return uri;
  }
  if (isURL("http://".concat(uri))) {
    // prepend http:// as the default protocol
    return "http://".concat(uri);
  }
  if (isURL(uri, {
    protocols: ['file'],
    require_host: false,
    require_valid_protocol: true
  })) {
    return uri;
  }
  return null;
}var DEFAULT_OPTION = {
  caseSensitive: false,
  highlightFn: function highlightFn(str) {
    return str;
  }
};
var getCompareValue = function getCompareValue(option, value) {
  return option.caseSensitive ? value : value.toLowerCase();
};
function fuzzySearch(searchStr, displayNameOrKeyword) {
  var option = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DEFAULT_OPTION;
  if (displayNameOrKeyword == null) {
    return {
      match: false,
      result: []
    };
  }
  var searchStrLength = searchStr.length;
  var displayNameLength = displayNameOrKeyword.length;
  var compareSearchStr = getCompareValue(option, searchStr);
  var compareNameOrKeyword = getCompareValue(option, displayNameOrKeyword);
  var highlightFn = option.highlightFn || DEFAULT_OPTION.highlightFn;
  var patternIndex = 0;
  var result = [];
  var currentChar = '';
  var grouppedChars = '';
  for (var stringIndex = 0; stringIndex < displayNameLength; stringIndex++) {
    currentChar = displayNameOrKeyword[stringIndex];
    if (compareNameOrKeyword[stringIndex] === compareSearchStr[patternIndex]) {
      grouppedChars += currentChar;
      patternIndex += 1;
    } else if (grouppedChars) {
      result[result.length] = highlightFn(grouppedChars, result.length);
      grouppedChars = '';
    }
    if (!grouppedChars) {
      result[result.length] = currentChar;
    }
  }

  // in case last word has to be highlighted
  if (grouppedChars) {
    result[result.length] = highlightFn(grouppedChars, result.length);
  }
  return {
    match: searchStrLength > 0 && patternIndex === searchStrLength,
    result: result
  };
}var warn = function warn() {};
if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test') {
  warn = function warn() {
    if (typeof console !== 'undefined') {
      var _console;
      (_console = console).warn.apply(_console, arguments);
    }
  };
}
var warn$1 = warn;function usePortal(visible) {
  var _useState = useState(function () {
      var modalRoot = document.createElement('div');
      modalRoot.setAttribute('data-modal-root', '');
      return modalRoot;
    }),
    _useState2 = _slicedToArray(_useState, 1),
    rootElement = _useState2[0];
  var portalHost = useContext(PortalContext) || document.body;
  useLayoutEffect(function () {
    if (visible) {
      portalHost.appendChild(rootElement);
      return function () {
        portalHost.removeChild(rootElement);
      };
    }
  }, [rootElement, visible, portalHost]);
  return rootElement;
}var _excluded$J = ["style", "className", "classNames"];
function createDefaultStyle(defaultStyle, getModifiers, shouldUpdate) {
  var enhance = function enhance(WrappedComponent) {
    var DefaultStyleEnhancer = /*#__PURE__*/React__default.forwardRef(function (_ref, ref) {
      var style = _ref.style,
        className = _ref.className,
        classNames = _ref.classNames,
        rest = _objectWithoutProperties(_ref, _excluded$J);
      var lastUpdateProps = useRef({});
      if (typeof defaultStyle === 'function') {
        var resolvedShouldUpdate = shouldUpdate ? shouldUpdate(rest, lastUpdateProps.current) : true;
        if (resolvedShouldUpdate) {
          lastUpdateProps.current = rest;
        }
      }
      var resolvedDefaultStyle = useMemo(function () {
        return typeof defaultStyle === 'function' ? defaultStyle(rest) : defaultStyle;
      }, /* eslint-disable-next-line react-hooks/exhaustive-deps */
      [defaultStyle, lastUpdateProps.current]);
      var styles = useStyles(resolvedDefaultStyle, {
        style: style,
        className: className,
        classNames: classNames
      }, getModifiers && getModifiers(rest));
      return /*#__PURE__*/React__default.createElement(WrappedComponent, _extends({}, rest, {
        style: styles,
        ref: ref
      }));
    });
    setDisplayName(wrapDisplayName(WrappedComponent, 'defaultStyle'))(DefaultStyleEnhancer);
    return DefaultStyleEnhancer;
  };
  return enhance;
}// Provides an `onBlur` handler that is called with the blur event's `relatedTarget`
// as second argument. The cool thing is that the relatedTarget is provided reliably
// in all browsers.

var extractRelatedTarget = function extractRelatedTarget(event) {
  return event.relatedTarget || event.explicitOriginalTarget ||
  // Firefox
  document.activeElement;
}; // IE

var onBlurWithRelatedTarget = withHandlers({
  onBlur: function onBlur(_ref) {
    var _onBlur = _ref.onBlur;
    return function (event) {
      return _onBlur && _onBlur(event, extractRelatedTarget(event.nativeEvent));
    };
  }
});
var onBlurWithRelatedTargetIE = compose(withHandlers(function () {
  var element;
  var lastRelatedTarget;
  var handleBlur = function handleBlur(nativeEvent) {
    lastRelatedTarget = extractRelatedTarget(nativeEvent);
  };
  return {
    inputRef: function inputRef(_ref2) {
      var _inputRef = _ref2.inputRef;
      return sequence(_inputRef, function (nextElement) {
        if (element) {
          element.removeEventListener('focusout', handleBlur);
        }
        if (nextElement) {
          nextElement.addEventListener('focusout', handleBlur);
        }
        element = nextElement;
      });
    },
    onBlur: function onBlur(_ref3) {
      var _onBlur2 = _ref3.onBlur;
      return function (event) {
        return _onBlur2 && _onBlur2(event, lastRelatedTarget);
      };
    }
  };
}));
var onBlurWithRelatedTarget$1 = isIE11OrLower ? onBlurWithRelatedTargetIE : onBlurWithRelatedTarget;var _excluded$I = ["onFocus", "onBlur", "stickInline", "style"];
function _createSuper$b(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$b(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct$b() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var AbstractInputWithWidget = /*#__PURE__*/function (_Component) {
  _inherits(AbstractInputWithWidget, _Component);
  var _super = _createSuper$b(AbstractInputWithWidget);
  function AbstractInputWithWidget() {
    var _this;
    _classCallCheck(this, AbstractInputWithWidget);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "input", void 0);
    _defineProperty(_assertThisInitialized(_this), "widget", void 0);
    return _this;
  }
  return _createClass(AbstractInputWithWidget);
}(Component);
var styled$r = createDefaultStyle({
  input: {},
  widget: {
    backgroundColor: 'white'
  }
});

// HOC for making combo inputs. Takes 2 components:
//  - Widget A component to render in a dropdown attached to the input
//  - Input The input control, which when focused will trigger the dropdown to show
//
var stickWidgetToInput = function stickWidgetToInput(Widget, Input) {
  var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _config$proxyEvents = config.proxyEvents,
    proxyEvents = _config$proxyEvents === void 0 ? {} : _config$proxyEvents,
    _config$stickProps = config.stickProps,
    stickProps = _config$stickProps === void 0 ? Object.freeze({}) : _config$stickProps;
  var InputFinal = onBlurWithRelatedTarget$1(Input);
  var InputWithWidget = /*#__PURE__*/function (_AbstractInputWithWid) {
    _inherits(InputWithWidget, _AbstractInputWithWid);
    var _super2 = _createSuper$b(InputWithWidget);
    function InputWithWidget(props) {
      var _this2;
      _classCallCheck(this, InputWithWidget);
      _this2 = _super2.call(this, props);
      _defineProperty(_assertThisInitialized(_this2), "expand", function () {
        if (_this2.state.isExpanded === false) {
          _this2.setState({
            isExpanded: true
          }, function () {
            if (_this2.props.onExpand) {
              _this2.props.onExpand();
            }
          });
        }
      });
      _defineProperty(_assertThisInitialized(_this2), "collapse", function () {
        if (_this2.state.isExpanded === true) {
          _this2.setState({
            isExpanded: false
          }, function () {
            if (_this2.props.onCollapse) {
              _this2.props.onCollapse();
            }
          });
        }
      });
      _defineProperty(_assertThisInitialized(_this2), "handleRequestHide", function () {
        var onRequestHideWidget = _this2.props.onRequestHideWidget;
        _this2.collapse();
        if (onRequestHideWidget) {
          onRequestHideWidget();
        }
      });
      _defineProperty(_assertThisInitialized(_this2), "setWidgetRef", function (ref) {
        _this2.widget = ref;
      });
      _defineProperty(_assertThisInitialized(_this2), "handleBlur", function (event, relatedTarget) {
        if (shouldCollapse(_this2.widget, relatedTarget)) {
          _this2.collapse();
        }
      });
      _this2.state = {
        isExpanded: !props.disabled && !!props.autoFocus
      };
      return _this2;
    }
    _createClass(InputWithWidget, [{
      key: "render",
      value: function render() {
        var isExpanded = this.state.isExpanded;
        var _this$props = this.props,
          onFocus = _this$props.onFocus,
          onBlur = _this$props.onBlur,
          stickInline = _this$props.stickInline,
          style = _this$props.style,
          rest = _objectWithoutProperties(_this$props, _excluded$I);
        var node = isExpanded ? this.renderWidget() : null;
        return /*#__PURE__*/React__default.createElement(Stick, _extends({}, typeof stickProps === 'function' ? stickProps(this.props) : stickProps, {
          style: style,
          inline: stickInline,
          node: node,
          onClickOutside: this.handleRequestHide
        }), /*#__PURE__*/React__default.createElement(InputFinal, _extends({
          isExpanded: isExpanded,
          onFocus: sequence(this.expand, onFocus),
          onBlur: sequence(this.handleBlur, onBlur)
        }, _omit(rest, 'onExpand', 'onCollapse', 'onRequestHideWidget'), mapProxyEventsObjectToHandlers(proxyEvents, this), {
          style: style('input')
        })));
      }
    }, {
      key: "renderWidget",
      value: function renderWidget() {
        return /*#__PURE__*/React__default.createElement(Widget, _extends({}, _omit(this.props, 'stickInline', 'onExpand', 'onCollapse', 'onBlur', 'onFocus'), {
          onRequestHideWidget: this.handleRequestHide,
          style: this.props.style('widget'),
          ref: this.setWidgetRef
        }));
      }
    }]);
    return InputWithWidget;
  }(AbstractInputWithWidget);
  return styled$r(InputWithWidget);
};
var mapProxyEventsObjectToHandlers = function mapProxyEventsObjectToHandlers(proxyEvents, instance) {
  return _mapValues(proxyEvents, function (handlerName, eventName) {
    invariant(eventName !== 'onFocus' && eventName !== 'onBlur', '`onFocus` and `onBlur` events are not supported in event proxying');
    return function (ev) {
      // call own handler
      if (instance.props[eventName]) {
        instance.props[eventName](ev);
      }
      var widget = instance.widget;
      if (widget == null) {
        // no proxying if the widget is not rendered
        return;
      }
      if (widget[handlerName] == null) {
        invariant(false, "No handler for ".concat(eventName, " present"));
      }
      var handler = widget[handlerName];
      invariant(typeof handler === 'function', "Expected a function for the `".concat(eventName, "` event proxy target, but found ") + "`".concat(handler.toString(), "` under the widgets `").concat(handlerName, "` property"));

      // call remote proxy handler
      handler.call(widget, ev);
    };
  });
};
var shouldCollapse = function shouldCollapse(widget, relatedTarget) {
  if (!relatedTarget) {
    return true;
  }
  if (!widget) {
    return false;
  }
  var widgetNode = findDOMNode(widget);
  if (!widgetNode) {
    return false;
  }
  return !widgetNode.contains(relatedTarget);
};
var stickWidgetToInput$1 = stickWidgetToInput;var _excluded$H = ["style"];
var disableIf = function disableIf(mapPropsToBool) {
  return function (WrappedComponent) {
    var Component = function Component(_ref) {
      var style = _ref.style,
        rest = _objectWithoutProperties(_ref, _excluded$H);
      var disabled = mapPropsToBool(rest);
      var modifiedStyle = style({
        '&disabled': disabled
      });
      return /*#__PURE__*/React__default.createElement("fieldset", _extends({
        disabled: disabled
      }, modifiedStyle), /*#__PURE__*/React__default.createElement(WrappedComponent, _extends({}, rest, {
        style: modifiedStyle('wrapped')
      })));
    };
    return styled$q(Component);
  };
};
var styled$q = createDefaultStyle({
  position: 'relative',
  padding: 0,
  margin: 0,
  borderWidth: 0,
  pointerEvents: 'none'
});
var disableIf$1 = disableIf;function ownKeys$s(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$s(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$s(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$s(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper$a(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$a(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct$a() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function defaultKey(key) {
  return 'default' + key.charAt(0).toUpperCase() + key.substr(1);
}
function uncontrollable() {
  var controlledValues = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    value: 'onChange'
  };
  return function (Component) {
    var _class;
    var displayName = Component.displayName || Component.name || 'Component';
    var controlledProps = Object.keys(controlledValues);
    var isFunctionalComponent = typeof Component === 'function';
    return _class = /*#__PURE__*/function (_React$Component) {
      _inherits(_class, _React$Component);
      var _super = _createSuper$a(_class);
      function _class(props) {
        var _this;
        _classCallCheck(this, _class);
        _this = _super.call(this, props);
        _defineProperty(_assertThisInitialized(_this), "_values", void 0);
        _defineProperty(_assertThisInitialized(_this), "_needsUpdate", void 0);
        _defineProperty(_assertThisInitialized(_this), "unmounted", void 0);
        _defineProperty(_assertThisInitialized(_this), "inner", void 0);
        _this._values = {};
        controlledProps.forEach(function (key) {
          _this._values[key] = props[defaultKey(key)];
        });
        return _this;
      }

      // If a prop switches from controlled to Uncontrolled
      // reset its value to the defaultValue
      _createClass(_class, [{
        key: "componentDidUpdate",
        value: function componentDidUpdate(prevProps) {
          var _this2 = this;
          // if the update already happened then don't fire it twice
          this._needsUpdate = false;
          controlledProps.forEach(function (key) {
            if (_this2.props[key] === undefined && prevProps[key] !== undefined) {
              _this2._values[key] = prevProps[defaultKey(key)];
            }
          });
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          this.unmounted = true;
        }
      }, {
        key: "getControlledInstance",
        value: function getControlledInstance() {
          return this.inner;
        }
      }, {
        key: "render",
        value: function render() {
          var _this3 = this;
          var props = _omit(this.props, controlledProps.map(defaultKey));
          var finalControlledProps = _reduce(controlledValues, function (newProps, handlerName, propName) {
            var _objectSpread4;
            var prop = props[propName];
            var handler = setAndNotify.bind(_this3, propName);
            if (prop !== undefined) {
              var _objectSpread2;
              return _objectSpread$s(_objectSpread$s({}, newProps), {}, (_objectSpread2 = {}, _defineProperty(_objectSpread2, propName, prop), _defineProperty(_objectSpread2, handlerName, handler), _objectSpread2));
            }
            if (_this3._values[propName] !== undefined) {
              var _objectSpread3;
              return _objectSpread$s(_objectSpread$s({}, newProps), {}, (_objectSpread3 = {}, _defineProperty(_objectSpread3, propName, _this3._values[propName]), _defineProperty(_objectSpread3, handlerName, handler), _objectSpread3));
            }
            return _objectSpread$s(_objectSpread$s({}, newProps), {}, (_objectSpread4 = {}, _defineProperty(_objectSpread4, propName, null), _defineProperty(_objectSpread4, handlerName, handler), _objectSpread4));
          }, {});
          var newProps = _objectSpread$s(_objectSpread$s(_objectSpread$s({}, props), finalControlledProps), {}, {
            ref: isFunctionalComponent ? null : function (node) {
              return _this3.inner = node;
            }
          });
          return /*#__PURE__*/React__default.createElement(Component, newProps);
        }
      }]);
      return _class;
    }(React__default.Component), _defineProperty(_class, "displayName", "Uncontrolled(".concat(displayName, ")")), _defineProperty(_class, "ControlledComponent", Component), _class;
    function set(component, propName, handler, value, args) {
      component._needsUpdate = true;
      component._values[propName] = value;
      if (handler) handler.call.apply(handler, [component, value].concat(_toConsumableArray(args)));
      ReactDom.unstable_batchedUpdates(function () {
        if (!component.unmounted && component._needsUpdate) {
          component._needsUpdate = false;
          if (!component.unmounted) component.forceUpdate();
        }
      });
    }
    function setAndNotify(propName, value) {
      var handler = this.props[controlledValues[propName]];
      for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
        args[_key - 2] = arguments[_key];
      }
      set(this, propName, handler, value, args);
    }
  };
}

// implementation is based on https://github.com/jquense/uncontrollable
// The MIT License (MIT)

// Copyright (c) 2015 Jason Quense

// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:

// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.

// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
// SOFTWARE.
var _excluded$G = ["value", "defaultValue", "onChange"];
/**
  HOC that removes the need to always provide an `onChange` handler together with `value`.
  If no `onChange` handler is provided this component will ensure edit capabilities by
  keeping the `value` in an internal state.
  It differs from uncontrollable in that it still allows `value` updates from the outside.
**/
var semicontrollable = function semicontrollable() {
  return function createSemicontrollable(WrappedComponent) {
    function Semicontrollable(_ref) {
      var value = _ref.value,
        defaultValue = _ref.defaultValue,
        _onChange = _ref.onChange,
        rest = _objectWithoutProperties(_ref, _excluded$G);
      var _useState = useState(value !== null && value !== void 0 ? value : defaultValue),
        _useState2 = _slicedToArray(_useState, 2),
        bufferedValue = _useState2[0],
        setBufferedValue = _useState2[1];
      useEffect(function () {
        setBufferedValue(value !== null && value !== void 0 ? value : defaultValue);
      }, [value, defaultValue]);
      return /*#__PURE__*/React__default.createElement(WrappedComponent, _extends({}, rest, {
        defaultValue: bufferedValue === undefined ? defaultValue : undefined,
        value: bufferedValue,
        onChange: function onChange(newValue) {
          setBufferedValue(newValue);
          if (_onChange) {
            for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
              args[_key - 1] = arguments[_key];
            }
            _onChange.apply(void 0, [newValue].concat(args));
          }
        }
      }));
    }
    return Semicontrollable;
  };
};
var semicontrollable$1 = semicontrollable;function ownKeys$r(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$r(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$r(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$r(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper$9(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$9(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct$9() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

// Injects props for getting and setting a value stored as an instance member. Useful when
// setting a value does not need to trigger a re-render and when that value update should be
// instantaneous instead of batched.
var accessInstanceMember = function accessInstanceMember(getterName, setterName, initialValue) {
  return function (BaseComponent) {
    console.warn('`accessInstanceMember` is deprecated and will be removed in next major release. ' + "Use recompose's `withHandlers` instead.");
    var factory = /*#__PURE__*/createFactory(BaseComponent);
    var AccessInstanceMember = /*#__PURE__*/function (_Component) {
      _inherits(AccessInstanceMember, _Component);
      var _super = _createSuper$9(AccessInstanceMember);
      function AccessInstanceMember() {
        var _this;
        _classCallCheck(this, AccessInstanceMember);
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        _this = _super.call.apply(_super, [this].concat(args));
        _defineProperty(_assertThisInitialized(_this), "value", typeof initialValue === 'function' ? initialValue(_this.props) : initialValue);
        _defineProperty(_assertThisInitialized(_this), "getValue", function () {
          return _this.value;
        });
        _defineProperty(_assertThisInitialized(_this), "setValue", function (newValue) {
          _this.value = newValue;
        });
        return _this;
      }
      _createClass(AccessInstanceMember, [{
        key: "render",
        value: function render() {
          var _objectSpread2;
          return factory(_objectSpread$r(_objectSpread$r({}, this.props), {}, (_objectSpread2 = {}, _defineProperty(_objectSpread2, getterName, this.getValue), _defineProperty(_objectSpread2, setterName, this.setValue), _objectSpread2)));
        }
      }]);
      return AccessInstanceMember;
    }(Component);
    if (process.env.NODE_ENV !== 'production') {
      return setDisplayName(wrapDisplayName(BaseComponent, 'accessInstanceMember'))(AccessInstanceMember);
    }
    return AccessInstanceMember;
  };
};
var accessInstanceMember$1 = accessInstanceMember;function createApplyDiscard(WrappedComponent) {
  function ApplyDiscard(props) {
    var ref = useRef();
    useLayoutEffect(function () {
      var element = ref.current;
      if (element instanceof HTMLElement) {
        element.addEventListener('keydown', handleKeyDown);
        return function () {
          element.removeEventListener('keydown', handleKeyDown);
        };
      }
    });
    return /*#__PURE__*/React__default.createElement(WrappedComponent, _extends({
      ref: ref
    }, props));
  }
  return ApplyDiscard;
}
function handleKeyDown(evt) {
  switch (evt.keyCode) {
    case 13: // enter
    case 27:
      // esc
      setTimeout(function () {
        var target = evt.target;
        if (target instanceof window.HTMLInputElement) {
          target.blur();
        }
      }, 0);
      break;
  }
}function createNullableText(WrappedComponent) {
  return createValueMapper({
    mapDown: function mapDown(value) {
      return value == null ? '' : value;
    },
    mapUp: function mapUp(value) {
      return value === '' ? null : value;
    }
  })(WrappedComponent);
}function _createSuper$8(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$8(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct$8() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function createSyncBlur(WrappedComponent) {
  var SyncBlur = /*#__PURE__*/function (_Component) {
    _inherits(SyncBlur, _Component);
    var _super = _createSuper$8(SyncBlur);
    function SyncBlur() {
      _classCallCheck(this, SyncBlur);
      return _super.apply(this, arguments);
    }
    _createClass(SyncBlur, [{
      key: "render",
      value: function render() {
        var _this = this;
        return /*#__PURE__*/React__default.createElement(WrappedComponent, _extends({}, this.props, {
          onSyncBlur: function onSyncBlur() {
            return handleSyncBlur(_this);
          }
        }));
      }
    }]);
    return SyncBlur;
  }(Component);
  return SyncBlur;
}
function handleSyncBlur(component) {
  var domElement = findDOMNode(component);
  domElement.getElementsByTagName('input')[0].blur();
}function _createSuper$7(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$7(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct$7() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function createSyncFocus(WrappedComponent) {
  var SyncFocus = /*#__PURE__*/function (_Component) {
    _inherits(SyncFocus, _Component);
    var _super = _createSuper$7(SyncFocus);
    function SyncFocus() {
      _classCallCheck(this, SyncFocus);
      return _super.apply(this, arguments);
    }
    _createClass(SyncFocus, [{
      key: "render",
      value: function render() {
        var _this = this;
        return /*#__PURE__*/React__default.createElement(WrappedComponent, _extends({}, this.props, {
          onSyncFocus: function onSyncFocus() {
            return handleSyncFocus(_this);
          }
        }));
      }
    }]);
    return SyncFocus;
  }(Component);
  return SyncFocus;
}
function handleSyncFocus(component) {
  var domElement = findDOMNode(component);
  domElement.getElementsByTagName('input')[0](component).focus();
}function _createSuper$6(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$6(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct$6() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function hideClearInIE(WrappedComponent) {
  if (navigator.appName !== 'Microsoft Internet Explorer') {
    return WrappedComponent;
  }
  var IEHideClear = /*#__PURE__*/function (_Component) {
    _inherits(IEHideClear, _Component);
    var _super = _createSuper$6(IEHideClear);
    function IEHideClear() {
      _classCallCheck(this, IEHideClear);
      return _super.apply(this, arguments);
    }
    _createClass(IEHideClear, [{
      key: "render",
      value: function render() {
        return /*#__PURE__*/React__default.createElement(WrappedComponent, this.props);
      }
    }, {
      key: "componentDidMount",
      value: function componentDidMount() {
        var component = ReactDom.findDOMNode(this); // TODO
        if (!component.id) {
          component.id = "s-".concat(uuid());
        }
        var CLASS_NAME = 'ie-hide-clear';
        var style = component.querySelector("style.".concat(CLASS_NAME));
        if (!style) {
          style = document.createElement('style');
          style.className = CLASS_NAME;
          style.innerHTML = "#".concat(component.id, " input::-ms-clear{ display: none; }");
          component.appendChild(style);
        }
      }
    }]);
    return IEHideClear;
  }(Component);
  return IEHideClear;
}
function uuid() {
  /*
   * RFC4122 compliant uuid generator
   * http://www.ietf.org/rfc/rfc4122.txt
   */
  var d = new Date().getTime();
  var id = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    return (c === 'x' ? r : r & 0x3 | 0x8).toString(16);
  });
  return id.substring(0, 8);
}var omitProps = compose(mapProps, _omit$1);var _excluded$F = ["onComplete", "onChange", "getValue", "setValue"];
function ownKeys$q(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$q(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$q(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$q(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

// wraps onChange to store latest value in an instance member
// wraps onComplete passing in the latest value to the user-provided callback
var wrapOnComplete = compose(withHandlers(function (_ref) {
  var value = _ref.value,
    defaultValue = _ref.defaultValue;
  var storedValue = value === undefined ? defaultValue : value;
  return {
    getValue: function getValue() {
      return function () {
        return storedValue;
      };
    },
    setValue: function setValue() {
      return function (newValue) {
        storedValue = newValue;
      };
    }
  };
}), lifecycle({
  componentDidUpdate: function componentDidUpdate(_ref2) {
    var prevValue = _ref2.value;
    if (prevValue !== this.props.value) {
      this.props.setValue(this.props.value);
    }
  }
}), mapProps(function (_ref3) {
  var onComplete = _ref3.onComplete,
    onChange = _ref3.onChange,
    getValue = _ref3.getValue,
    setValue = _ref3.setValue,
    rest = _objectWithoutProperties(_ref3, _excluded$F);
  return _objectSpread$q({
    onComplete: onComplete && function () {
      onComplete(getValue());
    },
    onChange: sequence(setValue, onChange)
  }, rest);
}));
var wrapOnComplete$1 = wrapOnComplete;var enhance$7 = compose(wrapOnComplete$1, withHandlers(function () {
  var _hasFocus = false;
  return {
    hasFocus: function hasFocus() {
      return function () {
        return _hasFocus;
      };
    },
    setHasFocus: function setHasFocus() {
      return function (newValue) {
        _hasFocus = newValue;
      };
    }
  };
}), lifecycle({
  componentWillUnmount: function componentWillUnmount() {
    if (this.props.hasFocus() && this.props.onComplete) {
      // make sure onComplete is triggered when unmounting before blurring
      this.props.onComplete();
    }
  }
}), withHandlers({
  onFocus: function onFocus(_ref) {
    _ref.onComplete;
      var _onFocus = _ref.onFocus,
      setHasFocus = _ref.setHasFocus;
    return sequence(function () {
      return setHasFocus(true);
    }, _onFocus);
  },
  onBlur: function onBlur(_ref2) {
    var onComplete = _ref2.onComplete,
      _onBlur = _ref2.onBlur,
      setHasFocus = _ref2.setHasFocus;
    return sequence(function () {
      return setHasFocus(false);
    }, onComplete, _onBlur);
  }
}), omitProps(['hasFocus', 'setHasFocus']));
var enhance$8 = enhance$7;var triggerOnCompleteOnEnter = compose(wrapOnComplete$1, withHandlers({
  onKeyDown: function onKeyDown(_ref) {
    var onComplete = _ref.onComplete,
      _onKeyDown = _ref.onKeyDown;
    return sequence(_onKeyDown, onComplete && function (event) {
      if (event.key === 'Enter') {
        onComplete();
      }
    });
  }
}));
var triggerOnCompleteOnEnter$1 = triggerOnCompleteOnEnter;var _excluded$E = ["onChange", "onComplete"];
function triggerOnCompleteOnChange(WrappedComponent) {
  return function (_ref) {
    var _onChange = _ref.onChange,
      onComplete = _ref.onComplete,
      props = _objectWithoutProperties(_ref, _excluded$E);
    return /*#__PURE__*/React__default.createElement(WrappedComponent, _extends({}, props, {
      onChange: function onChange(value) {
        if (_onChange) {
          _onChange(value);
        }
        if (onComplete) {
          onComplete(value);
        }
      }
    }));
  };
}function ownKeys$p(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$p(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$p(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$p(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper$5(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$5(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct$5() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

// Like recompose's `withHandlers` but takes as a second arg a higher-order function that will be
// called with each handler function and is supposed to defer the handling in an arbitrary way,
// e.g., `debounce` or `throttle`. When the wrapped component is unmounted, outstanding async
// handler calls will be canceled by calling the `cancel` method of the `asyncWrapper`'s return
// value.
var withAsyncHandlers = function withAsyncHandlers(handlers, asyncWrapper) {
  return function (BaseComponent) {
    if (process.env.NODE_ENV !== 'production' && typeof asyncWrapper !== 'function') {
      console.error(
      // eslint-disable-line no-console
      'withAsyncHandlers(): Expected a higher-order function .');
    }
    var factory = /*#__PURE__*/createFactory(BaseComponent);
    var WithAsyncHandlers = /*#__PURE__*/function (_Component) {
      _inherits(WithAsyncHandlers, _Component);
      var _super = _createSuper$5(WithAsyncHandlers);
      function WithAsyncHandlers() {
        var _this;
        _classCallCheck(this, WithAsyncHandlers);
        for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
          _args[_key] = arguments[_key];
        }
        _this = _super.call.apply(_super, [this].concat(_args));
        _defineProperty(_assertThisInitialized(_this), "cachedHandlers", {});
        _defineProperty(_assertThisInitialized(_this), "handlers", _mapValues(typeof handlers === 'function' ? handlers(_this.props) : handlers, function (createHandler, handlerName) {
          return asyncWrapper(function () {
            var cachedHandler = _this.cachedHandlers[handlerName];
            if (cachedHandler) {
              return cachedHandler.apply(void 0, arguments);
            }
            var handler = createHandler(_this.props);
            _this.cachedHandlers[handlerName] = handler;
            if (process.env.NODE_ENV !== 'production' && typeof handler !== 'function') {
              console.error(
              // eslint-disable-line no-console
              'withAsyncHandlers(): Expected a map of higher-order functions as first arg.');
            }
            return handler.apply(void 0, arguments);
          });
        }));
        return _this;
      }
      _createClass(WithAsyncHandlers, [{
        key: "componentDidUpdate",
        value: function componentDidUpdate() {
          this.cachedHandlers = {};
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          _forEach(this.handlers, function (handler) {
            if (handler && typeof handler.cancel === 'function') {
              handler.cancel();
            }
          });
        }
      }, {
        key: "render",
        value: function render() {
          return factory(_objectSpread$p(_objectSpread$p({}, this.props), this.handlers));
        }
      }]);
      return WithAsyncHandlers;
    }(Component);
    if (process.env.NODE_ENV !== 'production') {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withAsyncHandlers'))(WithAsyncHandlers);
    }
    return WithAsyncHandlers;
  };
};
var withAsyncHandlers$1 = withAsyncHandlers;var DEFAULT_POSITION = 'bottom left';
var REVERSE_POSITIONS = {
  top: 'bottom',
  bottom: 'top',
  right: 'left',
  left: 'right',
  middle: 'middle',
  center: 'center'
};
var pointIsObscuringNode = function pointIsObscuringNode(node, _ref) {
  var _document$elementFrom, _document;
  var _ref$x = _ref.x,
    x = _ref$x === void 0 ? 0 : _ref$x,
    _ref$y = _ref.y,
    y = _ref$y === void 0 ? 0 : _ref$y;
  var nodeAtPoint = ((_document$elementFrom = (_document = document).elementFromPoint) === null || _document$elementFrom === void 0 ? void 0 : _document$elementFrom.call(_document, x, y)) || null;
  return !(node !== null && node !== void 0 && node.contains(nodeAtPoint));
};
var withResponsivePosition = function withResponsivePosition(DropdownComponent) {
  return function (props) {
    var _props$autoFlip = props.autoFlip,
      autoFlip = _props$autoFlip === void 0 ? true : _props$autoFlip,
      inline = props.inline,
      isOpen = props.isOpen,
      _props$position = props.position,
      position = _props$position === void 0 ? DEFAULT_POSITION : _props$position;
    var shouldAutoFlip = inline && autoFlip;
    var _position$split = position.split(' '),
      _position$split2 = _slicedToArray(_position$split, 2),
      initialVertical = _position$split2[0],
      initialHorizontal = _position$split2[1];
    var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      shouldReverseHorizontally = _useState2[0],
      setShouldReverseHorizontally = _useState2[1];
    var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      shouldReverseVertically = _useState4[0],
      setShouldReverseVertically = _useState4[1];
    var horizontalPosition = shouldReverseHorizontally ? REVERSE_POSITIONS[initialHorizontal] : initialHorizontal;
    var verticalPosition = shouldReverseVertically ? REVERSE_POSITIONS[initialVertical] : initialVertical;
    var nodeRef = useRef(null);
    var isNodeObscured = useCallback(function (node, direction) {
      var nodeRect = node.getBoundingClientRect();
      var nodePosition = {
        horizontal: {
          left: nodeRect.right - 1,
          right: nodeRect.left,
          top: nodeRect.bottom - 1,
          bottom: nodeRect.top
        },
        vertical: {
          left: nodeRect.left,
          right: nodeRect.right - 1,
          top: nodeRect.top,
          bottom: nodeRect.bottom - 1
        }
      }[direction];
      return pointIsObscuringNode(node, {
        x: nodePosition[horizontalPosition],
        y: nodePosition[verticalPosition]
      });
    }, [horizontalPosition, verticalPosition]);
    var checkNodeAndUpdatePosition = useCallback(function () {
      var node = nodeRef.current;
      if (!node) return;
      var isObscuredHorizontally = isNodeObscured(node, 'horizontal');
      var isObscuredVertically = isNodeObscured(node, 'vertical');
      var updateReverseState = function updateReverseState(prevState) {
        return prevState === false ? prevState : !prevState;
      };
      if (isObscuredHorizontally) {
        setShouldReverseHorizontally(updateReverseState);
      }
      if (isObscuredVertically) {
        setShouldReverseVertically(updateReverseState);
      }
    }, [isNodeObscured]);
    var resetPosition = useCallback(function () {
      setShouldReverseHorizontally(null);
      setShouldReverseVertically(null);
    }, []);
    useLayoutEffect(function () {
      if (!shouldAutoFlip || !isOpen) return resetPosition();
      var timeout = setTimeout(function () {
        return checkNodeAndUpdatePosition();
      }, 0);
      return function () {
        return clearTimeout(timeout);
      };
    }, [shouldAutoFlip, checkNodeAndUpdatePosition, isOpen, resetPosition]);
    var dropdownProps = {
      position: "".concat(verticalPosition, " ").concat(horizontalPosition),
      align: undefined,
      inline: true,
      nodeRef: nodeRef
    };
    if (!shouldAutoFlip) {
      return /*#__PURE__*/React__default.createElement(DropdownComponent, props);
    }
    return /*#__PURE__*/React__default.createElement(DropdownComponent, _extends({}, props, dropdownProps));
  };
};
var withResponsivePosition$1 = withResponsivePosition;var _excluded$D = ["isOpen", "node", "children", "onClickNode", "onClickOutside", "onMouseEnterNode", "nodeRef"];
function _createSuper$4(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$4(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct$4() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var Dropdown = /*#__PURE__*/function (_Component) {
  _inherits(Dropdown, _Component);
  var _super = _createSuper$4(Dropdown);
  function Dropdown() {
    var _this;
    _classCallCheck(this, Dropdown);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "isHovered", void 0);
    return _this;
  }
  _createClass(Dropdown, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        isOpen = _this$props.isOpen,
        node = _this$props.node,
        children = _this$props.children,
        onClickNode = _this$props.onClickNode,
        onClickOutside = _this$props.onClickOutside,
        onMouseEnterNode = _this$props.onMouseEnterNode,
        nodeRef = _this$props.nodeRef,
        rest = _objectWithoutProperties(_this$props, _excluded$D);
      return /*#__PURE__*/React__default.createElement(Stick, _extends({}, _omit(rest, 'onClickOutside', 'setIsOpen'), {
        node: isOpen ?
        /*#__PURE__*/
        /* Please fix me */
        // jsx-a11y/no-static-element-interactions jsx-a11y/click-events-have-key-events
        // eslint-disable-next-line
        React__default.createElement("div", {
          onClick: onClickNode,
          onMouseEnter: onMouseEnterNode,
          ref: nodeRef
        }, node) : null,
        onClickOutside: isOpen ? onClickOutside : undefined
      }), typeof children === 'function' ? children(isOpen) : children);
    }
  }]);
  return Dropdown;
}(Component);
var styled$p = createDefaultStyle();
var enhance$6 = compose(styled$p, withResponsivePosition$1);
var Dropdown$1 = enhance$6(Dropdown);var uncontrolled = compose(withStateHandlers(function (_ref) {
  var isOpen = _ref.isOpen;
  return {
    isOpen: typeof isOpen !== 'undefined' ? isOpen : false
  };
}, {
  setIsOpen: function setIsOpen(state, _ref2) {
    var onOpen = _ref2.onOpen,
      onClose = _ref2.onClose;
    return function (isOpen, event) {
      if (!isOpen && onClose) {
        onClose(event);
      }
      if (isOpen && onOpen) {
        onOpen(event);
      }
      return {
        isOpen: isOpen
      };
    };
  }
}), omitProps(['onOpen', 'onClose']));
var uncontrolled$1 = uncontrolled;function _createSuper$3(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$3(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct$3() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var _ref = typeof window !== 'undefined' ? window : {
    setTimeout: function setTimeout(callback, ms) {
      return 0;
    },
    clearTimeout: function clearTimeout(handle) {}
  },
  setTimeout$1 = _ref.setTimeout,
  clearTimeout$1 = _ref.clearTimeout;
var createDelay = function createDelay(delayOnNextOpenState) {
  return function (ms) {
    return function (Dropdown) {
      return /*#__PURE__*/function (_Component) {
        _inherits(DelayedDropdownContainer, _Component);
        var _super = _createSuper$3(DelayedDropdownContainer);
        function DelayedDropdownContainer(props) {
          var _this;
          _classCallCheck(this, DelayedDropdownContainer);
          _this = _super.call(this, props);
          _defineProperty(_assertThisInitialized(_this), "lastPublishedIsOpen", void 0);
          _defineProperty(_assertThisInitialized(_this), "isOpen", void 0);
          _defineProperty(_assertThisInitialized(_this), "timer", void 0);
          _this.lastPublishedIsOpen = !!props.isOpen;
          return _this;
        }
        _createClass(DelayedDropdownContainer, [{
          key: "componentDidUpdate",
          value: function componentDidUpdate() {
            this.lastPublishedIsOpen = !!this.props.isOpen;
          }
        }, {
          key: "componentWillUnmount",
          value: function componentWillUnmount() {
            if (this.timer) {
              clearTimeout$1(this.timer);
            }
          }
        }, {
          key: "render",
          value: function render() {
            var _this2 = this;
            return /*#__PURE__*/React__default.createElement(Dropdown, _extends({}, this.props, {
              setIsOpen: function setIsOpen() {
                return _this2.handleSetIsOpen.apply(_this2, arguments);
              }
            }));
          }
        }, {
          key: "handleSetIsOpen",
          value: function handleSetIsOpen(isOpen, event) {
            var _this3 = this;
            if (this.timer) {
              clearTimeout$1(this.timer);
            }
            if (isOpen === delayOnNextOpenState) {
              this.timer = setTimeout$1(function () {
                if (isOpen === _this3.isOpen && isOpen !== _this3.lastPublishedIsOpen) {
                  _this3.props.setIsOpen(isOpen);
                }
                _this3.lastPublishedIsOpen = isOpen;
              }, ms);
            } else {
              this.props.setIsOpen(isOpen);
              this.lastPublishedIsOpen = isOpen;
            }
            this.isOpen = isOpen;
          }
        }]);
        return DelayedDropdownContainer;
      }(Component);
    };
  };
};
var delayOpen = createDelay(true);
var delayClose = createDelay(false);var toggleOnClick = withHandlers({
  onClick: function onClick(_ref) {
    var setIsOpen = _ref.setIsOpen,
      isOpen = _ref.isOpen;
    return function (event) {
      setIsOpen(!isOpen, event);
    };
  },
  onClickOutside: function onClickOutside(_ref2) {
    var setIsOpen = _ref2.setIsOpen;
    return function (event) {
      setIsOpen(false, event);
    };
  }
});
var toggleOnClick$1 = toggleOnClick;var toggleOnHover = withHandlers({
  onMouseEnter: function onMouseEnter(_ref) {
    var setIsOpen = _ref.setIsOpen;
    return function (event) {
      setIsOpen(true, event);
    };
  },
  onMouseLeave: function onMouseLeave(_ref2) {
    var setIsOpen = _ref2.setIsOpen;
    return function (event) {
      setIsOpen(false, event);
    };
  }
});
var toggleOnHover$1 = toggleOnHover;var closeOnClickNode = withHandlers({
  onClickNode: function onClickNode(_ref) {
    var setIsOpen = _ref.setIsOpen;
    return function (event) {
      setIsOpen(false, event);
    };
  }
});
var closeOnClickNode$1 = closeOnClickNode;var closeOnMouseEnterNode = withHandlers({
  onMouseEnterNode: function onMouseEnterNode(_ref) {
    var setIsOpen = _ref.setIsOpen;
    return function (event) {
      setIsOpen(false, event);
    };
  }
});
var closeOnMouseEnterNode$1 = closeOnMouseEnterNode;var index$1=/*#__PURE__*/Object.freeze({__proto__:null,'default':Dropdown$1,uncontrolled:uncontrolled$1,toggleOnClick:toggleOnClick$1,toggleOnHover:toggleOnHover$1,closeOnClickNode:closeOnClickNode$1,closeOnMouseEnterNode:closeOnMouseEnterNode$1,delayOpen:delayOpen,delayClose:delayClose});var SANITIZERS = {
  '.': /((?!-)(?!\.)\D)*/g,
  ',': /((?!-)(?!,)\D)*/g
};
var SEPARATOR_MATCHERS = {
  '.': /\./g,
  ',': /,/g
};
var defaultLocale = typeof navigator !== 'undefined' ? navigator.language : 'en-US';
function getDecimalSeparator(locale) {
  return 1.1.toLocaleString(locale).substr(1, 1);
}
function parseNumberString(locale, text) {
  if (!text) {
    return null;
  }
  var decimalSeparator = getDecimalSeparator(locale);
  var sanitizer = SANITIZERS[decimalSeparator];
  var separatorMatcher = SEPARATOR_MATCHERS[decimalSeparator];
  var count = 0;

  // remove all non-decimal characters excluding the decimal
  // separator and -
  var sanitized = text.replace(sanitizer, '')
  // remove all but the first -
  .replace(/(?!^)-/g, '')
  // remove all decimal separators but the first
  .replace(separatorMatcher, function (capture) {
    return count++ === 0 ? capture : '';
  });
  var numberValue = parseFloat(sanitized.replace(',', '.'));
  if (isNaN(numberValue)) {
    return null;
  }
  return numberValue;
}

// this regex allows the following things:
//
// - the '-' character at the very beginning (negative numbers)
// - any number (denoted by '\d')
// - any occurrence of ',' or '.'
var inputValidator = /^-?[\d,. ]*$/g;
var sanitizeNumberInput = function sanitizeNumberInput(value) {
  return value.split('').reduce(function (result, char, index) {
    if (!char.match(inputValidator)) {
      return result;
    }
    if (char === '-' && index !== 0) {
      return result;
    }
    return "".concat(result).concat(char);
  }, '');
};var _excluded$C = ["value", "culture", "min", "max", "onChange", "onFocus", "onBlur"];
function mapUp(value, min, max) {
  if (value == null) {
    return null;
  }
  return Math.min(max, Math.max(min, value));
}
var NumberInput = function NumberInput(_ref, ref) {
  var value = _ref.value,
    _ref$culture = _ref.culture,
    culture = _ref$culture === void 0 ? defaultLocale : _ref$culture,
    _ref$min = _ref.min,
    min = _ref$min === void 0 ? Number.NEGATIVE_INFINITY : _ref$min,
    _ref$max = _ref.max,
    max = _ref$max === void 0 ? Number.POSITIVE_INFINITY : _ref$max,
    _onChange = _ref.onChange,
    _onFocus = _ref.onFocus,
    _onBlur = _ref.onBlur,
    rest = _objectWithoutProperties(_ref, _excluded$C);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    editing = _useState2[0],
    setEditing = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    temporaryValue = _useState4[0],
    setTemporaryValue = _useState4[1];
  var localeValue = useLocaleValue(culture, value, editing);
  useEffect(function () {
    if (!editing) {
      setTemporaryValue(null);
    }
  }, [editing, value]);
  useEffect(function () {
    if (value == null) {
      setTemporaryValue(null);
    }
  }, [value]);
  return /*#__PURE__*/React__default.createElement(Input$1, _extends({}, rest, {
    ref: ref,
    type: "text",
    value: temporaryValue || localeValue,
    onChange: function onChange(newValue, event) {
      var textValue = sanitizeNumberInput(newValue);
      setTemporaryValue(textValue);
      if (textValue.endsWith(getDecimalSeparator(culture)) || textValue === '-') {
        return;
      }
      var newNumber = mapUp(parseNumberString(culture, textValue), min, max);
      if (value === newNumber) {
        return;
      }
      if (_onChange) {
        _onChange(newNumber, event);
      }
    },
    onFocus: function onFocus(event) {
      setEditing(true);
      if (_onFocus) {
        _onFocus(event);
      }
    },
    onBlur: function onBlur(event) {
      setEditing(false);
      if (_onBlur) {
        _onBlur(event);
      }
    }
  }));
};
var useLocaleValue = function useLocaleValue(locale, value, editing) {
  if (value == null) {
    return null;
  }
  return value.toLocaleString(locale, {
    maximumFractionDigits: 20,
    useGrouping: !editing
  });
};
var NumberInput$1 = /*#__PURE__*/forwardRef(NumberInput);var _excluded$B = ["value", "culture", "min", "max", "onFocus", "onBlur", "onChange"];
function Percentage(_ref, ref) {
  var value = _ref.value,
    _ref$culture = _ref.culture,
    culture = _ref$culture === void 0 ? defaultLocale : _ref$culture,
    _ref$min = _ref.min,
    min = _ref$min === void 0 ? 0 : _ref$min,
    _ref$max = _ref.max,
    max = _ref$max === void 0 ? 1 : _ref$max,
    _onFocus = _ref.onFocus,
    _onBlur = _ref.onBlur,
    _onChange = _ref.onChange,
    rest = _objectWithoutProperties(_ref, _excluded$B);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    editing = _useState2[0],
    setEditing = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    temporaryValue = _useState4[0],
    setTemporaryValue = _useState4[1];
  var visibleValue = value ? "".concat((value * 100).toLocaleString(culture, {
    maximumFractionDigits: 20
  }), "%") : null;
  useEffect(function () {
    if (!editing) {
      setTemporaryValue(null);
    }
  }, [editing, value]);
  useEffect(function () {
    if (editing && visibleValue != null) {
      setTemporaryValue(visibleValue.replace('%', ''));
    }
  }, [editing, visibleValue]);
  return /*#__PURE__*/React__default.createElement(Input$1, _extends({}, rest, {
    ref: ref,
    type: "text",
    value: temporaryValue || visibleValue,
    onChange: function onChange(newValue, event) {
      var textValue = sanitizeNumberInput(newValue);
      setTemporaryValue(textValue);
      if (textValue.endsWith(getDecimalSeparator(culture)) || textValue === '-') {
        return;
      }
      var newNumber = parseNumberString(culture, textValue);
      var newPercentage = mapUp(newNumber != null ? newNumber / 100 : null, min, max);
      if (newPercentage != null) {
        setTemporaryValue("".concat(newPercentage * 100));
      }
      if (value === newPercentage) {
        return;
      }
      if (_onChange) {
        _onChange(newPercentage, event);
      }
    },
    onFocus: function onFocus(event) {
      setEditing(true);
      if (_onFocus) {
        _onFocus(event);
      }
    },
    onBlur: function onBlur(event) {
      setEditing(false);
      if (_onBlur) {
        _onBlur(event);
      }
    }
  }));
}
var Percentage$1 = /*#__PURE__*/forwardRef(Percentage);var Number$1 = deprecateExport(NumberInput$1, 'The "Number" export in @signavio/ui/core has been renamed to "NumberInput". It will be removed in a future major update.');var _excluded$A = ["type", "inputRef", "placeholder"];
var TextInput = function TextInput(_ref, ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'text' : _ref$type,
    _inputRef = _ref.inputRef,
    placeholder = _ref.placeholder,
    rest = _objectWithoutProperties(_ref, _excluded$A);
  return /*#__PURE__*/React__default.createElement(Input$1, _extends({}, rest, {
    placeholder: placeholder,
    type: type,
    inputRef: function inputRef(node) {
      if (ref) {
        if (typeof ref === 'function') {
          ref(node);
        } else {
          ref.current = node;
        }
      }
      if (_inputRef) {
        if (typeof _inputRef === 'function') {
          _inputRef(node);
        } else {
          _inputRef.current = node;
        }
      }
    }
  }));
};
var TextInput$1 = /*#__PURE__*/forwardRef(TextInput);var _excluded$z = ["onChange", "style", "value", "className", "classNames"];
var Textarea = function Textarea(_ref, ref) {
  var _onChange = _ref.onChange,
    style = _ref.style,
    value = _ref.value,
    className = _ref.className,
    classNames = _ref.classNames,
    rest = _objectWithoutProperties(_ref, _excluded$z);
  var styles = useStyles(defaultStyles$a, {
    className: className,
    style: style,
    classNames: classNames
  });
  return /*#__PURE__*/React__default.createElement(AutosizeTextarea, _extends({}, rest, styles, {
    ref: ref,
    value: value === null ? '' : value,
    onChange: function onChange(e) {
      if (typeof _onChange === 'function') {
        _onChange(e.target.value, e);
      }
    }
  }));
};
var defaultStyles$a = {
  width: '100%',
  resize: 'vertical'
};
var Textarea$1 = /*#__PURE__*/forwardRef(Textarea);var Text = deprecateExport(TextInput$1, 'The "Text" export in @signavio/ui/core has been renamed to "TextInput". It will be removed in a future major update.');var _excluded$y = ["children", "style", "className", "classNames", "activeChildren", "accept", "onDrop", "onDragOver", "onDragLeave"];
var DropZone = function DropZone(_ref) {
  var children = _ref.children,
    style = _ref.style,
    className = _ref.className,
    classNames = _ref.classNames,
    activeChildren = _ref.activeChildren,
    accept = _ref.accept,
    _onDrop = _ref.onDrop,
    _onDragOver = _ref.onDragOver,
    _onDragLeave = _ref.onDragLeave,
    rest = _objectWithoutProperties(_ref, _excluded$y);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    dragActive = _useState2[0],
    setDragActive = _useState2[1];
  var styles = useStyles(defaultStyles$9, {
    style: style,
    className: className,
    classNames: classNames
  }, {
    '&active': dragActive
  });
  return /*#__PURE__*/React__default.createElement("div", _extends({}, rest, styles, {
    onDragOver: function onDragOver(event) {
      event.preventDefault();
      if (_onDragOver) {
        _onDragOver(event);
      }
      setDragActive(true);
    },
    onDragLeave: function onDragLeave(event) {
      if (_onDragLeave) {
        _onDragLeave(event);
      }
      setDragActive(false);
    },
    onDrop: function onDrop(event) {
      event.preventDefault();
      if (_onDrop) {
        _onDrop(extractFiles(event, accept));
      }
      setDragActive(false);
    }
  }), children, dragActive && activeChildren);
};
var defaultStyles$9 = {};
var extractFiles = function extractFiles(event, accept) {
  return _toConsumableArray(event.dataTransfer.files).filter(function (file) {
    return testAccept(file, accept);
  });
};
function testAccept(file, accept) {
  var testAcceptPattern = function testAcceptPattern(pattern) {
    return pattern[0] === '.' ? new RegExp(".*\\".concat(pattern)).test(file.name) : new RegExp(pattern.replace(/\*/g, '.*')).test(file.type);
  };
  return !accept || accept.split('|').some(testAcceptPattern);
}
var DropZone$1 = DropZone;var _excluded$x = ["children", "style", "accept", "value", "inputRef", "className", "classNames", "readOnly", "onClick", "disabled", "labelId"];
function FileSelect(_ref, ref) {
  var children = _ref.children,
    style = _ref.style,
    accept = _ref.accept,
    value = _ref.value,
    inputRef = _ref.inputRef,
    className = _ref.className,
    classNames = _ref.classNames,
    readOnly = _ref.readOnly,
    onClick = _ref.onClick,
    disabled = _ref.disabled;
    _ref.labelId;
    var rest = _objectWithoutProperties(_ref, _excluded$x);
  var input = useRef();
  var styles = useStyles(defaultStyles$8, {
    style: style,
    className: className,
    classNames: classNames
  });
  var handleChange = function handleChange(files) {
    // the following code looks a bit weird, but this is to please
    // flow. See: https://github.com/facebook/flow/issues/6594
    if (rest.multiple) {
      rest.onChange && rest.onChange(files, input.current);
    } else {
      var file = files ? files[0] : null;
      rest.onChange && rest.onChange(file, input.current);
    }
  };
  return /*#__PURE__*/React__default.createElement(DropZone$1, {
    onClick: onClick,
    onDrop: handleChange,
    style: styles,
    accept: accept
  }, /*#__PURE__*/React__default.createElement("div", _extends({}, styles('label'), {
    "data-testid": "label",
    onKeyDown: function onKeyDown(event) {
      if (disabled) {
        return;
      }
      if (event.key === ' ') {
        if (input.current) {
          event.preventDefault();
          input.current.click();
        }
      }
    },
    onClick: function onClick(event) {
      event.preventDefault();
      if (!readOnly && input.current) {
        input.current.click();
      }
    }
  }), children), /*#__PURE__*/React__default.createElement("input", _extends({}, rest, {
    readOnly: readOnly
  }, styles('input'), {
    disabled: disabled
    // Passing the `value` as `key` ensures that a new input element is rendered whenever
    // the value changes. This is important, because otherwise `onChange` would not be
    // triggered when selecting the previously selected file again after a clear.
    ,
    key: value,
    ref: mergeRefs([input, inputRef, ref]),
    type: "file",
    "data-testid": "file-select-hidden-input",
    accept: accept,
    multiple: rest.multiple,
    onChange: function onChange(event) {
      if (event.target.files) {
        // conversion from FileList type to Array<File>
        handleChange(_toConsumableArray(event.target.files));
      } else {
        handleChange([]);
      }
    }
  })));
}
var defaultStyles$8 = {
  label: {
    display: 'block',
    cursor: 'pointer'
  },
  input: {
    display: 'none'
  }
};
var FileSelect$1 = /*#__PURE__*/forwardRef(FileSelect);var DELETE = 46;
var BACKSPACE = 8;
var TAB = 9;
var ESCAPE = 27;
var RETURN = 13;
var ARROW_LEFT = 37;
var ARROW_UP = 38;
var ARROW_RIGHT = 39;
var ARROW_DOWN = 40;var keycodes=/*#__PURE__*/Object.freeze({__proto__:null,DELETE:DELETE,BACKSPACE:BACKSPACE,TAB:TAB,ESCAPE:ESCAPE,RETURN:RETURN,ARROW_LEFT:ARROW_LEFT,ARROW_UP:ARROW_UP,ARROW_RIGHT:ARROW_RIGHT,ARROW_DOWN:ARROW_DOWN});var xxxsmall = 4;
var xxsmall = 8;
var xsmall$1 = 12;
var small$1 = 16;
var medium = 20;
var large$1 = 24;
var xlarge$1 = 32;
var xxlarge = 48;
var xxxlarge = 72;
var xxxxlarge = 88;var spacing=/*#__PURE__*/Object.freeze({__proto__:null,xxxsmall:xxxsmall,xxsmall:xxsmall,xsmall:xsmall$1,small:small$1,medium:medium,large:large$1,xlarge:xlarge$1,xxlarge:xxlarge,xxxlarge:xxxlarge,xxxxlarge:xxxxlarge});var xsmall = 4;
var small = 8;
var normal = 16;
var large = 32;
var xlarge = 40;var padding=/*#__PURE__*/Object.freeze({__proto__:null,xsmall:xsmall,small:small,normal:normal,large:large,xlarge:xlarge});var size$1 = {
  xxsmall: '6pt',
  xsmall: '9pt',
  small: '12px',
  button: '14px',
  normal: '16px',
  large: '18px',
  xlarge: '20px',
  xxlarge: '24px',
  h1: '40px',
  h2: '30px',
  title1: '44px',
  title2: '34px',
  title3: '24px',
  title4: '18px',
  article: '16px',
  body: '14px'
};
var indicator = {
  normal: size$1.small,
  small: 9
};
var weight = {
  normal: 400,
  bold: 600
};
var family = {
  normal: "'Open Sans', 'Noto Sans', sans-serif",
  heading: "'Open Sans', 'Noto Sans', sans-serif",
  monospace: "'Roboto Mono', 'Lucida Console', Monaco, monospace"
};
var title1 = {
  fontFamily: family.normal,
  fontSize: size$1.title1,
  fontWeight: weight.bold,
  letterSpacing: '0.008em',
  lineHeight: '56px'
};
var title2 = {
  fontFamily: family.normal,
  fontSize: size$1.title2,
  fontWeight: weight.bold,
  letterSpacing: '0.0074em',
  lineHeight: '44px'
};
var title3 = {
  fontFamily: family.normal,
  fontSize: size$1.title3,
  fontWeight: weight.bold,
  letterSpacing: '0.0063em',
  lineHeight: '32px'
};
var title4 = {
  fontFamily: family.normal,
  fontSize: size$1.title4,
  fontWeight: weight.bold,
  letterSpacing: '0em',
  lineHeight: '28px'
};
var article = {
  fontFamily: family.normal,
  fontSize: size$1.article,
  fontWeight: weight.normal,
  letterSpacing: '0em',
  lineHeight: '24px'
};
var body = {
  fontFamily: family.normal,
  fontWeight: weight.normal,
  fontSize: size$1.body,
  letterSpacing: '0em',
  lineHeight: '20px'
};
var caption = {
  fontFamily: family.normal,
  fontWeight: weight.normal,
  fontSize: size$1.small,
  letterSpacing: '0.0063em',
  lineHeight: '20px'
};
var strongCaption = {
  fontFamily: family.normal,
  fontWeight: weight.bold,
  fontSize: size$1.small,
  letterSpacing: '0.0063em',
  lineHeight: '20px'
};
var button1 = {
  fontFamily: family.normal,
  fontSize: size$1.button,
  fontWeight: weight.bold,
  letterSpacing: '0.0156em',
  lineHeight: '16px'
};
var button2 = {
  fontFamily: family.normal,
  fontSize: size$1.small,
  fontWeight: weight.bold,
  letterSpacing: '0.0125em',
  lineHeight: '16px'
};var font=/*#__PURE__*/Object.freeze({__proto__:null,size:size$1,indicator:indicator,weight:weight,family:family,title1:title1,title2:title2,title3:title3,title4:title4,article:article,body:body,caption:caption,strongCaption:strongCaption,button1:button1,button2:button2});var button$1 = {
  normal: 40,
  small: 24
};
var width = {
  modal: 672,
  dialog: 504
};
var tableRow = {
  normal: 40,
  compact: 36
};
var contentConsumptionToolbar = {
  buttonSize: 32,
  width: 50
};var size=/*#__PURE__*/Object.freeze({__proto__:null,button:button$1,width:width,tableRow:tableRow,contentConsumptionToolbar:contentConsumptionToolbar});var popover = 999;
var toast = 999;
var modal$2 = 999;
var dropdown = 999;
var header$1 = 999;
var draggable = 999;
var fullscreenContentConsumption = 99;
var contentConsumptionControls = 98;
var fullscreenContentConsumptionControls = 2;var zIndex=/*#__PURE__*/Object.freeze({__proto__:null,popover:popover,toast:toast,modal:modal$2,dropdown:dropdown,header:header$1,draggable:draggable,fullscreenContentConsumption:fullscreenContentConsumption,contentConsumptionControls:contentConsumptionControls,fullscreenContentConsumptionControls:fullscreenContentConsumptionControls});var card = {
  boxShadow: '0 1px 2px 1px rgba(0, 0, 0, 0.16), 0 0 1px 0 rgba(0, 0, 0, 0.10)'
};
var menu = {
  boxShadow: '0 4px 8px 1px rgba(0, 0, 0, 0.16), 0 0 4px 0 rgba(0, 0, 0, 0.10)'
};
var modal$1 = {
  boxShadow: '0 7px 14px 1px rgba(0, 0, 0, 0.16), 0 0 7px 0 rgba(0, 0, 0, 0.10)'
};
var header = {
  boxShadow: '0px 1px 4px rgba(0, 0, 0, 0.16)'
};var shadow=/*#__PURE__*/Object.freeze({__proto__:null,card:card,menu:menu,modal:modal$1,header:header});var button = {
  borderRadius: {
    regular: '2px',
    small: 0
  }
};
var modal = {
  borderRadius: '2px'
};
var hint = {
  borderRadius: '2px'
};
var chipDropDown = {
  borderRadius: 0
};
var tab = {
  borderRadius: {
    regular: '2px 2px 0 0',
    small: 0
  }
};
var sidebarItem = {
  borderRadius: '0 2px 2px 0'
};var border=/*#__PURE__*/Object.freeze({__proto__:null,button:button,modal:modal,hint:hint,chipDropDown:chipDropDown,tab:tab,sidebarItem:sidebarItem});// If no name and children are provided to an option
// the option's value is displayed. We also have to consider
// this when searching for an option.
var getDisplayName = function getDisplayName(name, value, hasChildren) {
  return name || !hasChildren && !_isNil(value) && "".concat(value);
};
var getDisplayName$1 = getDisplayName;var _excluded$w = ["component", "onMouseEnter", "onMouseLeave", "name", "value", "disabled", "search", "highlightMatch", "highlightFn", "onSelect", "onHighlight", "onUnhighlight", "onMouseDown"];
var preventDefault = function preventDefault(ev) {
  ev.preventDefault();
};
var OptionWrapper = function OptionWrapper(_ref) {
  var OptionComponent = _ref.component,
    onMouseEnter = _ref.onMouseEnter,
    onMouseLeave = _ref.onMouseLeave,
    name = _ref.name,
    value = _ref.value,
    disabled = _ref.disabled,
    search = _ref.search,
    highlightMatch = _ref.highlightMatch,
    highlightFn = _ref.highlightFn;
    _ref.onSelect;
    var onHighlight = _ref.onHighlight,
    onUnhighlight = _ref.onUnhighlight,
    onMouseDown = _ref.onMouseDown,
    rest = _objectWithoutProperties(_ref, _excluded$w);
  var displayName = getDisplayName$1(name, value, !!rest.children);
  var highlightedName = displayName && highlightMatch(displayName, search, highlightFn);
  return /*#__PURE__*/React__default.createElement(OptionComponent, _extends({}, rest, {
    search: search,
    name: name,
    value: value,
    disabled: disabled,
    highlightedName: highlightedName,
    onMouseEnter: sequence(onMouseEnter, !disabled && function () {
      return onHighlight(value);
    }),
    onMouseLeave: sequence(onMouseLeave, !disabled && function () {
      return onUnhighlight(value);
    }),
    onMouseDown: sequence(disabled && preventDefault, onMouseDown)
  }));
};
var enhance$5 = compose(pure, withProps(function (_ref2) {
  var onClick = _ref2.onClick,
    onMouseDown = _ref2.onMouseDown,
    disabled = _ref2.disabled,
    onSelect = _ref2.onSelect,
    value = _ref2.value;
  return _defineProperty({}, isIE11OrLower ? 'onMouseDown' : 'onClick', sequence(isIE11OrLower ? onMouseDown : onClick, !disabled && function () {
    return onSelect(value);
  }));
}));
var OptionWrapper$1 = enhance$5(OptionWrapper);var _excluded$v = ["emptyMessage", "onBlur", "onKeyDown", "tabIndex", "style", "height", "optionHeight"],
  _excluded2 = ["style"];
function ownKeys$o(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$o(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$o(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$o(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper$2(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$2(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct$2() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var Select = /*#__PURE__*/function (_Component) {
  _inherits(Select, _Component);
  var _super = _createSuper$2(Select);
  function Select(props) {
    var _this;
    _classCallCheck(this, Select);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "handleHighlight", function (value) {
      _this.setState({
        focusedValue: value
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleUnhighlight", function () {
      _this.setState({
        focusedValue: _this.props.multiple === true ? null : _this.props.value
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleKeyDown", function (ev) {
      var _ARROW_UP$ARROW_DOWN$;
      var handler = (_ARROW_UP$ARROW_DOWN$ = {}, _defineProperty(_ARROW_UP$ARROW_DOWN$, ARROW_UP, _this.focusPrev), _defineProperty(_ARROW_UP$ARROW_DOWN$, ARROW_DOWN, _this.focusNext), _defineProperty(_ARROW_UP$ARROW_DOWN$, RETURN, _this.selectFocused), _ARROW_UP$ARROW_DOWN$)[ev.keyCode];
      if (handler) {
        handler.call(_assertThisInitialized(_this), ev);
        ev.preventDefault();
      }
    });
    _defineProperty(_assertThisInitialized(_this), "handleBlur", function (ev) {
      _this.setState({
        focusedValue: _this.props.multiple === true ? null : _this.props.value
      });
      _this.hideWidgetIfDefined();
    });
    _defineProperty(_assertThisInitialized(_this), "focusNext", function () {
      var options = _this.getFilteredOptions();
      if (options.length < 1) return;
      var option = getItemAt(options, findValueIndex(options, _this.state.focusedValue) + 1);
      _this.setState({
        focusedValue: option.props.value
      });
    });
    _defineProperty(_assertThisInitialized(_this), "focusPrev", function () {
      var options = _this.getFilteredOptions();
      if (options.length < 1) return;
      var option = getItemAt(options, Math.max(findValueIndex(options, _this.state.focusedValue), 0) - 1);
      _this.setState({
        focusedValue: option.props.value
      });
    });
    _defineProperty(_assertThisInitialized(_this), "hideWidgetIfDefined", function () {
      var onRequestHideWidget = _this.props.onRequestHideWidget;
      if (onRequestHideWidget) {
        // special support for use in stickWidgetToInput HoC
        onRequestHideWidget();
      }
    });
    _this.state = {
      focusedValue: null
    };
    return _this;
  }
  _createClass(Select, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        emptyMessage = _this$props.emptyMessage,
        onBlur = _this$props.onBlur,
        onKeyDown = _this$props.onKeyDown,
        _this$props$tabIndex = _this$props.tabIndex,
        tabIndex = _this$props$tabIndex === void 0 ? 0 : _this$props$tabIndex,
        style = _this$props.style,
        height = _this$props.height,
        optionHeight = _this$props.optionHeight,
        rest = _objectWithoutProperties(_this$props, _excluded$v);
      var options = this.getFilteredOptions({
        includeNonOptionsAndDisabled: true
      });
      var shouldVirtualize = !!height && !!optionHeight && optionHeight * options.length > height;
      var baseStyle = style.style,
        styleProps = _objectWithoutProperties(style, _excluded2);
      return (
        /*#__PURE__*/
        // eslint-disable-next-line jsx-a11y/no-static-element-interactions
        React__default.createElement("div", _extends({}, _omit(rest, 'value', 'search', 'children', 'onRequestHideWidget', 'highlightFn', 'highlightMatch', 'matchString'), {
          tabIndex: tabIndex,
          onKeyDown: sequence(function (ev) {
            return _this2.handleKeyDown(ev);
          }, onKeyDown),
          onBlur: sequence(function (ev) {
            return _this2.handleBlur(ev);
          }, onBlur)
        }, styleProps, {
          style: _objectSpread$o(_objectSpread$o({}, baseStyle), {}, {
            overflowY: 'hidden'
          })
        }), /*#__PURE__*/React__default.createElement("div", {
          style: _objectSpread$o({
            overflowY: 'auto'
          }, height ? {
            maxHeight: height
          } : {})
        }, options.length === 0 && emptyMessage, shouldVirtualize && /*#__PURE__*/React__default.createElement(VirtualList, {
          width: "100%",
          height: height,
          itemCount: options.length,
          itemSize: optionHeight,
          overscanCount: 10,
          renderItem: function renderItem(_ref) {
            var index = _ref.index,
              style = _ref.style;
            return /*#__PURE__*/React__default.createElement("div", {
              key: options[index].key,
              style: style
            }, _this2.renderOption(options[index]));
          }
        }), !shouldVirtualize && options.map(function (child) {
          return _this2.renderOption(child);
        })))
      );
    }
  }, {
    key: "renderOption",
    value: function renderOption(option) {
      var _this3 = this;
      if (!('value' in option.props)) {
        return option;
      }
      var _this$props2 = this.props,
        search = _this$props2.search,
        _this$props2$highligh = _this$props2.highlightFn,
        highlightFn = _this$props2$highligh === void 0 ? highlightFnDefault : _this$props2$highligh,
        _this$props2$highligh2 = _this$props2.highlightMatch,
        highlightMatch = _this$props2$highligh2 === void 0 ? highlightMatchDefault : _this$props2$highligh2;
      return /*#__PURE__*/React__default.createElement(OptionWrapper$1, _extends({
        component: option.type
      }, option.props, {
        highlightFn: highlightFn,
        highlightMatch: highlightMatch,
        search: search,
        key: option.key,
        isFocused: this.state.focusedValue === option.props.value,
        isSelected: this.props.multiple === true ? this.props.value && this.props.value.includes(option.props.value) : this.props.value === option.props.value,
        onSelect: function onSelect(value) {
          return _this3.handleSelect(value);
        },
        onHighlight: this.handleHighlight,
        onUnhighlight: this.handleUnhighlight
      }));
    }
  }, {
    key: "selectFocused",
    value: function selectFocused() {
      this.handleSelect(this.state.focusedValue);
    }
  }, {
    key: "handleSelect",
    value: function handleSelect(optionValue) {
      if (!this.props.multiple && this.props.onChange && optionValue !== this.props.value) {
        this.props.onChange(optionValue);
      }
      if (this.props.multiple === true && this.props.onChange) {
        if (!this.props.value) {
          this.props.onChange([optionValue]);
        }
        if (this.props.value && !this.props.value.includes(optionValue)) {
          this.props.onChange([].concat(_toConsumableArray(this.props.value), [optionValue]));
        }
        if (this.props.multiple === true &&
        // flow needs this to be repeated
        this.props.value && this.props.value.includes(optionValue)) {
          // flow needs this to be assigned to local vars
          var value = this.props.value;
          var onChange = this.props.onChange;
          onChange(value.filter(function (item) {
            return item !== optionValue;
          }));
        }
      }
      this.hideWidgetIfDefined();
    }
  }, {
    key: "getFilteredOptions",
    value: function getFilteredOptions() {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        includeNonOptionsAndDisabled = _ref2.includeNonOptionsAndDisabled;
      var _this$props3 = this.props,
        _this$props3$matchStr = _this$props3.matchString,
        matchString = _this$props3$matchStr === void 0 ? matchStringDefault : _this$props3$matchStr,
        children = _this$props3.children,
        search = _this$props3.search;
      var someMatchSearch = _some(function (keyword) {
        return matchString(keyword, search);
      });
      return Children.toArray(children).filter(function (_ref3) {
        var props = _ref3.props;
        // Only consider children that have a `value` prop to be options.
        // This allows using elements such as dividers.
        if (!('value' in props)) {
          // non-option children won't be matched in search
          return includeNonOptionsAndDisabled;
        }
        if (!includeNonOptionsAndDisabled && props.disabled) {
          return false;
        }
        if (!search) {
          return true;
        }
        var displayName = getDisplayName$1(props.name, props.value, !!props.children);
        var hasMatchingDisplayName = displayName && matchString(displayName, search);
        var hasMatchingKeywords = someMatchSearch(props.keywords || []);
        return hasMatchingDisplayName || hasMatchingKeywords;
      });
    }
  }]);
  return Select;
}(Component);
var enhance$4 = createDefaultStyle();
var Select$1 = enhance$4(Select);
var findValueIndex = function findValueIndex(options, value) {
  return _findIndex(function (option) {
    return option.props.value === value;
  }, options);
};
var getItemAt = function getItemAt(array, i) {
  var modI = i % array.length;
  if (modI < 0) modI += array.length;
  return array[modI];
};
var matchStringDefault = function matchStringDefault(string, search) {
  if (!search) {
    return true;
  }
  return fuzzySearch(search, string).match;
};
var highlightFnDefault = function highlightFnDefault(match, key) {
  return /*#__PURE__*/React__default.createElement("strong", {
    key: key
  }, match);
};
var highlightMatchDefault = function highlightMatchDefault(string, search, highlightFn) {
  if (!search) return [string];
  return fuzzySearch(search, string, {
    highlightFn: highlightFn
  }).result;
};function ValueRenderer(_ref) {
  var children = _ref.children,
    value = _ref.value,
    _ref$placeholder = _ref.placeholder,
    placeholder = _ref$placeholder === void 0 ? '---' : _ref$placeholder,
    valueDisplay = _ref.valueDisplay,
    onBlur = _ref.onBlur,
    onKeyDown = _ref.onKeyDown,
    onFocus = _ref.onFocus,
    disabled = _ref.disabled,
    style = _ref.style;
  var props = disabled ? {
    disabled: disabled
  } : {
    onBlur: onBlur,
    onFocus: onFocus,
    onKeyDown: onKeyDown,
    tabIndex: 0
  };
  var content;
  if (value == null) {
    content = placeholder;
  } else if (valueDisplay) {
    content = valueDisplay;
  } else {
    var selectedOption = _find(Children.toArray(children), function (child) {
      return child.props.value === value;
    });
    content = selectedOption ? /*#__PURE__*/React__default.cloneElement(selectedOption, {
      style: style('option')
    }) : value;
  }
  return /*#__PURE__*/React__default.createElement("div", _extends({
    "data-testid": "value-renderer"
  }, props, style), content);
}
var styled$o = createDefaultStyle({
  option: {
    // overwrite default option styles
  }
});
var ValueRenderer$1 = styled$o(ValueRenderer);var _excluded$u = ["value", "isExpanded", "searchEnabled", "search", "searchPlaceholder", "valueDisplay", "wrapTrigger", "onFocus", "onBlur", "onKeyDown", "onSearch", "renderInput", "style"];
var preventArrowUpDownDefaults = function preventArrowUpDownDefaults(ev) {
  if (ev.keyCode === ARROW_DOWN || ev.keyCode === ARROW_UP) {
    ev.preventDefault();
  }
};
function Trigger(_ref) {
  var value = _ref.value,
    isExpanded = _ref.isExpanded,
    _ref$searchEnabled = _ref.searchEnabled,
    searchEnabled = _ref$searchEnabled === void 0 ? true : _ref$searchEnabled,
    search = _ref.search,
    searchPlaceholder = _ref.searchPlaceholder,
    valueDisplay = _ref.valueDisplay,
    _ref$wrapTrigger = _ref.wrapTrigger,
    wrapTrigger = _ref$wrapTrigger === void 0 ? function (trigger) {
      return trigger;
    } : _ref$wrapTrigger,
    onFocus = _ref.onFocus,
    _onBlur = _ref.onBlur,
    onKeyDown = _ref.onKeyDown,
    onSearch = _ref.onSearch,
    renderInput = _ref.renderInput,
    style = _ref.style,
    rest = _objectWithoutProperties(_ref, _excluded$u);
  var handleWrapperClick = isExpanded ? _onBlur : function (ev) {
    if (onFocus) {
      onFocus(ev);
    }
    onSearch(undefined);
  };
  var isActive = isExpanded && searchEnabled;
  var InputComponent = renderInput;
  var container = useRef();
  if (isActive) {
    return /*#__PURE__*/React__default.createElement("div", _extends({
      tabIndex: "-1"
    }, style, {
      ref: container
    }), wrapTrigger( /*#__PURE__*/React__default.createElement(InputComponent, _extends({}, _omit(rest, 'children', 'emptyMessage', 'highlightFn', 'matchString', 'highlightMatch', 'height', 'optionHeight'), {
      style: style('search')
      // Please fix me
      // eslint-disable-next-line jsx-a11y/no-autofocus
      ,
      autoFocus: true,
      value: search || '',
      placeholder: searchPlaceholder,
      onChange: function onChange(val) {
        return onSearch(val);
      },
      onBlur: function onBlur(event, relatedTarget) {
        var clickOutsideOfTrigger = !relatedTarget || container.current && !container.current.contains(relatedTarget);
        if (clickOutsideOfTrigger) {
          _onBlur(event);
        }
      },
      onKeyDown: sequence(preventArrowUpDownDefaults, onKeyDown)
    })), {
      isExpanded: isExpanded,
      onClick: handleWrapperClick
    }));
  }
  return /*#__PURE__*/React__default.createElement("div", _extends({
    tabIndex: "-1"
  }, style, {
    ref: container
  }), wrapTrigger( /*#__PURE__*/React__default.createElement(ValueRenderer$1, _extends({
    value: value,
    valueDisplay: valueDisplay
  }, _omit(rest, 'emptyMessage', 'highlightFn', 'matchString', 'highlightMatch', 'height', 'optionHeight'), {
    onFocus: sequence(onFocus, function () {
      return onSearch(undefined);
    }),
    onKeyDown: sequence(preventArrowUpDownDefaults, onKeyDown),
    style: style(value == null ? 'placeholder' : 'value')
  })), {
    isExpanded: isExpanded,
    onClick: handleWrapperClick
  }));
}
var enhance$3 = compose(withPropsOnChange(['renderInput'], function (_ref2) {
  var renderInput = _ref2.renderInput;
  return {
    renderInput: onBlurWithRelatedTarget$1(renderInput || TextInput$1)
  };
}), createDefaultStyle({
  outline: 'none',
  value: {
    option: {
      // overwrite default option styles
    }
  },
  placeholder: {
    color: '#999'
  },
  '&disabled': {}
}, function (_ref3) {
  var disabled = _ref3.disabled;
  return {
    '&disabled': disabled
  };
}));
var Trigger$1 = enhance$3(Trigger);function _createSuper$1(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$1(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct$1() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
// a wrapper around Select for omitting some props while proxying the handleKeyDown instance method
var SelectWrapper = /*#__PURE__*/function (_Component) {
  _inherits(SelectWrapper, _Component);
  var _super = _createSuper$1(SelectWrapper);
  function SelectWrapper() {
    var _this;
    _classCallCheck(this, SelectWrapper);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "select", void 0);
    return _this;
  }
  _createClass(SelectWrapper, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      return /*#__PURE__*/React__default.createElement(Select$1, _extends({}, _omit(this.props, 'onSearch', 'searchEnabled', 'searchPlaceholder', 'wrapTrigger', 'valueDisplay', 'placeholder', 'renderInput'), {
        ref: function ref(_ref) {
          _this2.select = _ref;
        }
      }));
    }
  }, {
    key: "handleKeyDown",
    value: function handleKeyDown() {
      var _this$select;
      (_this$select = this.select).handleKeyDown.apply(_this$select, arguments);
    }
  }]);
  return SelectWrapper;
}(Component);
var DropdownSelect = compose(withState('search', 'setSearch', undefined), withHandlers({
  onSearch: function onSearch(_ref2) {
    var setSearch = _ref2.setSearch,
      _onSearch = _ref2.onSearch;
    return sequence(setSearch, _onSearch);
  },
  onRequestHideWidget: function onRequestHideWidget(_ref3) {
    var onBlur = _ref3.onBlur;
    return function () {
      if (!onBlur) {
        return;
      }
      onBlur({
        relatedTarget: document.body,
        nativeEvent: {
          relatedTarget: document.body
        }
      });
    };
  }
}), omitProps(['setSearch']), createDefaultStyle({
  node: {
    zIndex: dropdown
  }
}))(stickWidgetToInput$1(SelectWrapper, Trigger$1, {
  proxyEvents: {
    onKeyDown: 'handleKeyDown'
  },
  stickProps: function stickProps(_ref4) {
    var autoFlipVertically = _ref4.autoFlipVertically;
    return {
      sameWidth: true,
      updateOnAnimationFrame: true,
      autoFlipVertically: autoFlipVertically
    };
  }
}));
var DropdownSelect$1 = DropdownSelect;var _excluded$t = ["value", "name", "highlightedName", "children", "style"];
var Option = function Option(_ref) {
  var value = _ref.value,
    name = _ref.name,
    highlightedName = _ref.highlightedName,
    children = _ref.children,
    style = _ref.style,
    rest = _objectWithoutProperties(_ref, _excluded$t);
  return /*#__PURE__*/React__default.createElement("div", _extends({}, rest, style), children || highlightedName || name || value);
};
var getModifiers = function getModifiers(_ref2) {
  var isFocused = _ref2.isFocused,
    isSelected = _ref2.isSelected,
    disabled = _ref2.disabled;
  return {
    '&focused': isFocused,
    '&selected': isSelected,
    '&disabled': disabled
  };
};
var substyle = createDefaultStyle({
  cursor: 'pointer',
  ':hover': {},
  '&focused': {},
  '&selected': {},
  '&disabled': {
    cursor: 'default',
    ':hover': {}
  }
}, getModifiers);
var enhance$2 = compose(substyle, omitProps(['search', 'keywords', 'isFocused', 'isSelected', 'disabled']));
var Option$1 = enhance$2(Option);function getMeridiem(hours) {
  if (hours == null) {
    return null;
  }
  if (hours >= 12) {
    return 'PM';
  }
  return 'AM';
}function setHoursMeridiem(hours, meridiem) {
  if (hours == null) {
    return 12;
  }
  if (!meridiem || meridiem === 'AM') {
    return hours % 12;
  }
  return hours % 12 + 12;
}function to12HoursFormat(hours) {
  if (typeof hours !== 'number') {
    return null;
  }
  var result = hours % 12;
  if (result === 0) {
    return 12;
  }
  return result;
}function to24HoursFormat(hours) {
  if (typeof hours !== 'number') {
    return null;
  }
  return hours % 24;
}function getEndOfMonth(year, month) {
  if (!month) {
    return 31;
  }
  var now = new Date();

  // monthIndex is 0-based, so we have to subtract 1 always
  return endOfMonth(new Date(year || now.getFullYear(), month - 1, 1)).getDate();
}function Fragment(props) {
  return null;
}var toNDigitString = _curry(function (n, number) {
  if (isNaN(number) || number == null) {
    return null;
  }
  return number.toString().padStart(n, '0');
});
var toNDigitString$1 = toNDigitString;var to2DigitString = toNDigitString$1(2);
var to2DigitString$1 = to2DigitString;var to4DigitString = toNDigitString$1(4);
var to4DigitString$1 = to4DigitString;function parseNumber(str) {
  var max = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Infinity;
  var min = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var cleanedStr = (str || '').replace(/[^0-9]/g, '');
  if (!cleanedStr) {
    return null;
  }
  var number = parseInt(cleanedStr, 10);
  if (max === null || max === undefined) {
    return number;
  }
  return Math.min(max, Math.max(min, number));
}function cycleNumber(value, increment) {
  var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Infinity;
  var min = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  if (value == null || isNaN(value)) {
    return null;
  }
  var maxButNoMin = !_isNil(min) && _isNil(max);
  var minButNoMax = _isNil(min) && !_isNil(max);
  invariant(!maxButNoMin && !minButNoMax, "If you are using min and max, you have to provide both values! min: ".concat(min, " / max: ").concat(max));
  invariant(min < max, "Minimum value must be greater than max value. min: ".concat(min, " / max: ").concat(max));
  var span = max - min + 1;
  var normalized = (value - min + increment) % span;
  if (normalized < 0) {
    normalized += span;
  }
  return min + normalized;
}var getFragmentKey = function getFragmentKey(fragment) {
  invariant(typeof fragment.key === 'string', "Input fragments need a \"string\" key but got \"".concat(_typeof(fragment.key), "\"."));
  return ['{{', fragment.key.replace('.$', ''), '}}'].join('');
};
var getFragmentKey$1 = getFragmentKey;function numberEnteredComplete(number, max) {
  if (!number) {
    return false;
  }
  return number * 10 > max;
}function useFragments(template, children) {
  var input = useRef();
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    focusedFragmentIndex = _useState2[0],
    setFocusedFragmentIndex = _useState2[1];
  var fragments = useMemo(function () {
    return Children.toArray(children).filter(function (fragment) {
      return fragment && template.indexOf(getFragmentKey$1(fragment)) >= 0;
    }).sort(function (a, b) {
      return template.indexOf(getFragmentKey$1(a)) - template.indexOf(getFragmentKey$1(b));
    });
  }, [children, template]);
  var focusedFragment = focusedFragmentIndex == null ? null : fragments[focusedFragmentIndex];
  var focusNextFragment = useCallback(function () {
    invariant(focusedFragmentIndex != null, 'Cannot focus next fragment because none has focus.');
    var newIndex = Math.min(focusedFragmentIndex + 1, fragments.length - 1);
    setFocusedFragmentIndex(newIndex);

    // there is no next fragment
    if (newIndex === fragments.length - 1) {
      return null;
    }
    return newIndex;
  }, [focusedFragmentIndex, fragments.length]);
  var focusPreviousFragment = useCallback(function () {
    invariant(focusedFragmentIndex != null, 'Cannot focus previous fragment because none has focus.');
    var newIndex = Math.max(focusedFragmentIndex - 1, 0);
    setFocusedFragmentIndex(newIndex);
    return newIndex;
  }, [focusedFragmentIndex]);
  var getValue = useCallback(function () {
    var tpl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : template;
    return fragments.reduce(function (result, fragment) {
      return result.replace(getFragmentKey$1(fragment), fillUp(fragment.props.value, fragment.props.length));
    }, tpl);
  }, [fragments, template]);
  var getFragmentStartIndex = useCallback(function () {
    var fragmentIndex = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : focusedFragmentIndex;
    invariant(fragmentIndex != null, 'Cannot get a start index because no fragment has focus.');
    var fragment = fragments[fragmentIndex];
    return getValue(template.substring(0, template.indexOf(getFragmentKey$1(fragment)))).length;
  }, [focusedFragmentIndex, fragments, getValue, template]);
  var focusFragmentAtCursorPosition = useCallback(function (position) {
    var index = 0;
    while (index < fragments.length - 1 && getFragmentStartIndex(index + 1) <= position) {
      index++;
    }
    setFocusedFragmentIndex(index);
  }, [fragments.length, getFragmentStartIndex]);
  var hasValue = useCallback(function () {
    return fragments.some(function (_ref) {
      var value = _ref.props.value;
        _ref.key;
      return value != null;
    });
  }, [fragments]);
  useLayoutEffect(function () {
    var inputElement = input.current;
    if (!inputElement || !focusedFragment) {
      return;
    }
    var selectionStart = getFragmentStartIndex();
    var selectionEnd = selectionStart + focusedFragment.props.length;
    inputElement.setSelectionRange(selectionStart, selectionEnd);
  }, [focusedFragment, getFragmentStartIndex]);
  return [input, fragments, focusedFragment, focusedFragmentIndex, hasValue, getValue, getFragmentStartIndex, focusPreviousFragment, focusNextFragment, setFocusedFragmentIndex, focusFragmentAtCursorPosition];
}
var fillUp = function fillUp(value, length) {
  var stringValue = value || '';
  var diff = Math.max(length - stringValue.length, 0);
  return Array(diff + 1).join('‐') + stringValue;
};var _excluded$s = ["template", "placeholder", "children", "onSelect", "onFocus", "onBlur", "onKeyDown", "inputRef"];
function FragmentedInput(_ref, ref) {
  var template = _ref.template,
    placeholder = _ref.placeholder,
    children = _ref.children,
    _onSelect = _ref.onSelect,
    _onFocus = _ref.onFocus,
    _onBlur = _ref.onBlur,
    _onKeyDown = _ref.onKeyDown,
    inputRef = _ref.inputRef,
    rest = _objectWithoutProperties(_ref, _excluded$s);
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    currentFragmentValue = _useState2[0],
    setCurrentFragmentValue = _useState2[1];
  useEffect(function () {
    if (inputRef) {
      console.warn('You are using the "inputRef" property on a <FragmentedInput />. This property is deprecated in favor of the default "ref" prop.');
    }
  }, [inputRef]);
  var _useFragments = useFragments(template, children),
    _useFragments2 = _slicedToArray(_useFragments, 11),
    fragmentRef = _useFragments2[0],
    fragments = _useFragments2[1],
    focusedFragment = _useFragments2[2],
    focusedFragmentIndex = _useFragments2[3],
    hasValue = _useFragments2[4],
    getValue = _useFragments2[5],
    getFragmentStartIndex = _useFragments2[6],
    focusPreviousFragment = _useFragments2[7],
    focusNextFragment = _useFragments2[8],
    focusFragmentAtIndex = _useFragments2[9],
    focusFragmentAtCursorPosition = _useFragments2[10];
  useEffect(function () {
    setCurrentFragmentValue('');
  }, [focusedFragmentIndex]);
  var showPlaceholder = !focusedFragment && !hasValue();
  var value = getValue();
  return /*#__PURE__*/React__default.createElement(Input$1, _extends({}, rest, {
    type: "text",
    ref: mergeRefs([ref, inputRef, fragmentRef]),
    value: showPlaceholder ? null : value,
    placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : getDefaultPlaceholder(template, fragments),
    onChange: function onChange(newValue) {
      if (!focusedFragment) {
        return;
      }
      var changeLength = newValue.length - value.length;
      var startIndex = getFragmentStartIndex();
      var addition = newValue.substring(startIndex, startIndex + focusedFragment.props.length + changeLength);
      var newFragmentValue = currentFragmentValue + addition;
      if (newFragmentValue.length >= focusedFragment.props.length) {
        var slicingRange = focusedFragment.props.length - 1;
        focusNextFragment() || setCurrentFragmentValue((currentFragmentValue + addition).slice(-slicingRange));
      } else {
        setCurrentFragmentValue(newFragmentValue);
      }
      focusedFragment.props.onChange(newFragmentValue, function () {
        return void focusNextFragment();
      });
    },
    onSelect: function onSelect(event) {
      var target = event.target;
      if (!(target instanceof window.HTMLInputElement)) {
        return;
      }
      var selectionStart = target.selectionStart;
      if (shallIgnoreSelectEvent(event) || selectionStart == null) {
        return;
      }
      focusFragmentAtCursorPosition(selectionStart);
      if (_onSelect) {
        _onSelect(event);
      }
    },
    onFocus: function onFocus(event) {
      focusFragmentAtIndex(0);
      if (_onFocus) {
        _onFocus(event);
      }
    },
    onBlur: function onBlur(event) {
      focusFragmentAtIndex(null);
      if (_onBlur) {
        _onBlur(event);
      }
    },
    onKeyDown: function onKeyDown(event) {
      if (_onKeyDown) {
        _onKeyDown(event, focusedFragment ? {
          fragment: focusedFragment,
          isFirst: focusedFragmentIndex === 0,
          isLast: focusedFragmentIndex === fragments.length - 1
        } : {
          fragment: null,
          isFirst: false,
          isLast: false
        });
      }
      if (!focusedFragment) {
        return;
      }
      focusedFragment.props.onKeyDown(event);
      if (event.key === 'Tab') {
        var nextIndex = event.shiftKey ? focusPreviousFragment() : focusNextFragment();
        if (nextIndex !== focusedFragmentIndex) {
          event.preventDefault();
        }
      }
      if (event.key === 'ArrowRight') {
        focusNextFragment();
        event.preventDefault();
      }
      if (event.key === 'ArrowLeft') {
        focusPreviousFragment();
        event.preventDefault();
      }
      if (event.key === 'Delete' || event.key === 'Backspace') {
        focusedFragment.props.onChange(null);
        setCurrentFragmentValue('');
        event.preventDefault();
      }
    }
  }));
}
var getDefaultPlaceholder = function getDefaultPlaceholder(template, fragments) {
  return fragments.reduce(function (placeholder, fragment) {
    return placeholder.replace(getFragmentKey$1(fragment), fragment.props.placeholder || Array(fragment.props.length).join('-'));
  }, template);
};

// React translates keydown and keyup event into selectionchange event for certain
// browser (IE and FF). This messes up our selection mgmt, so we have to ignore those events
var shallIgnoreSelectEvent = function shallIgnoreSelectEvent(event) {
  var nativeEvent = event.nativeEvent;
  if (!(nativeEvent instanceof KeyboardEvent)) {
    return;
  }
  var isKeyDownOrUp = nativeEvent.type === 'keyup' || nativeEvent.type === 'keydown';
  var isLeftOrRight = nativeEvent.key === 'ArrowRight' || nativeEvent.key === 'ArrowLeft';
  return isKeyDownOrUp && !isLeftOrRight;
};
var FragmentedInput$1 = /*#__PURE__*/forwardRef(FragmentedInput);function ownKeys$n(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$n(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$n(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$n(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function useFragmentedValue(value, onChange, _ref) {
  var valueToState = _ref.valueToState,
    stateToValue = _ref.stateToValue;
  var _useState = useState(function () {
      return valueToState(value);
    }),
    _useState2 = _slicedToArray(_useState, 2),
    internalValue = _useState2[0],
    setInternalValue = _useState2[1];
  var handleChange = useCallback(function (newValue) {
    var nextState = _objectSpread$n(_objectSpread$n({}, internalValue), newValue);
    setInternalValue(nextState);
    var nextValue = stateToValue(nextState);
    if (value !== nextValue) {
      onChange(nextValue);
    }
  }, [internalValue, onChange, stateToValue, value]);
  useEffect(function () {
    setInternalValue(valueToState(value));
  }, [value, valueToState]);
  return [internalValue, handleChange];
}var maxValue$1 = 23;
function create24HourFragment(_ref) {
  var value = _ref.value,
    _onChange = _ref.onChange;
  return /*#__PURE__*/React__default.createElement(Fragment, {
    key: "HH",
    placeholder: "HH",
    length: 2,
    value: to2DigitString$1(to24HoursFormat(value)),
    onChange: function onChange(val, complete) {
      var parsedValue = parseNumber(val, 24);
      if (!isNumber(parsedValue)) {
        return;
      }
      if (parsedValue === 24) {
        parsedValue = 0;
      }
      if (numberEnteredComplete(parsedValue, 23) && complete) {
        complete();
      }
      _onChange({
        hour: parsedValue
      });
    },
    onKeyDown: function onKeyDown(event) {
      if (event.key === 'ArrowUp') {
        _onChange({
          hour: cycleNumber(value, 1, maxValue$1) || 0
        });
        event.preventDefault();
      }
      if (event.key === 'ArrowDown') {
        _onChange({
          hour: cycleNumber(value, -1, maxValue$1) || 0
        });
        event.preventDefault();
      }
      if (event.key === 'Backspace' || event.key === 'Delete') {
        _onChange({
          hour: null
        });
        event.preventDefault();
      }
    }
  });
}var maxValue = 23;

// value is hours between 0 and 23
function create12HourFragment(_ref) {
  var value = _ref.value,
    _onChange = _ref.onChange;
  var meridiem = getMeridiem(value);
  return /*#__PURE__*/React__default.createElement(Fragment, {
    key: "hh",
    placeholder: "HH",
    length: 2,
    value: to2DigitString$1(to12HoursFormat(value)),
    onChange: function onChange(val, complete) {
      var parsedValue = parseNumber(val, 24);
      if (numberEnteredComplete(parsedValue, 12) && complete) {
        complete();
      }
      if (parsedValue == null || !isNumber(parsedValue)) {
        return;
      }
      if (parsedValue === 24) {
        parsedValue = 0;
      }
      if (parsedValue < 12 && meridiem === 'PM') {
        parsedValue += 12;
      }
      if (parsedValue === 12 && meridiem === 'AM') {
        parsedValue = 0;
      }
      _onChange({
        hour: parsedValue
      });
    },
    onKeyDown: function onKeyDown(event) {
      if (event.key === 'ArrowUp') {
        _onChange({
          hour: cycleNumber(value, 1, maxValue) || 0
        });
        event.preventDefault();
      }
      if (event.key === 'ArrowDown') {
        _onChange({
          hour: cycleNumber(value, -1, maxValue) || 0
        });
        event.preventDefault();
      }
      if (event.key === 'Backspace' || event.key === 'Delete') {
        _onChange({
          hour: null
        });
        event.preventDefault();
      }
    }
  });
}// value is hours between 0 and 23
function createMeridiemFragment(_ref) {
  var value = _ref.value,
    _onChange = _ref.onChange;
  return /*#__PURE__*/React__default.createElement(Fragment, {
    key: "A",
    placeholder: "AM",
    length: 2,
    value: getMeridiem(value),
    onChange: function onChange(meridiem, complete) {
      var parsedMeridiem = meridiem ? meridiem.toUpperCase() : getMeridiem(value);
      if (!parsedMeridiem) {
        parsedMeridiem = 'AM';
      } else if (parsedMeridiem[0] === 'A') {
        parsedMeridiem = 'AM';
      } else if (parsedMeridiem[0] === 'P') {
        parsedMeridiem = 'PM';
      } else {
        parsedMeridiem = getMeridiem(value); // keep previous value
      }

      if (complete) {
        complete();
      }
      _onChange({
        hour: setHoursMeridiem(value, parsedMeridiem)
      });
    },
    onKeyDown: function onKeyDown(event) {
      if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
        var meridiem = getMeridiem(value) === 'AM' ? 'PM' : 'AM';
        _onChange({
          hour: setHoursMeridiem(value, meridiem)
        });
        event.preventDefault();
      }
    }
  });
}var maxMinute = 59;
var createMinuteFragment$2 = function createMinuteFragment(_ref) {
  var value = _ref.value,
    _onChange = _ref.onChange;
  return /*#__PURE__*/React__default.createElement(Fragment, {
    key: "mm",
    placeholder: "MM",
    length: 2,
    value: to2DigitString$1(value),
    onChange: function onChange(val, complete) {
      var parsedValue = parseNumber(val, maxMinute);
      if (!isNumber(parsedValue)) {
        return;
      }
      if (numberEnteredComplete(parsedValue, maxMinute) && complete) {
        complete();
      }
      _onChange({
        minute: parsedValue
      });
    },
    onKeyDown: function onKeyDown(event) {
      if (event.key === 'ArrowUp') {
        _onChange({
          minute: cycleNumber(value, 1, maxMinute) || 0
        });
        event.preventDefault();
      }
      if (event.key === 'ArrowDown') {
        _onChange({
          minute: cycleNumber(value, -1, maxMinute) || 0
        });
        event.preventDefault();
      }
      if (event.key === 'Backspace' || event.key === 'Delete') {
        _onChange({
          minute: null
        });
        event.preventDefault();
      }
    }
  });
};
var createMinuteFragment$3 = createMinuteFragment$2;function createYearFragment(_ref) {
  var value = _ref.value,
    _onChange = _ref.onChange,
    _ref$min = _ref.min,
    min = _ref$min === void 0 ? 0 : _ref$min,
    _ref$max = _ref.max,
    max = _ref$max === void 0 ? 9999 : _ref$max;
  return /*#__PURE__*/React__default.createElement(Fragment, {
    key: "YYYY",
    placeholder: "YYYY",
    length: 4,
    value: to4DigitString$1(value),
    onChange: function onChange(val) {
      if (!val) {
        return;
      }
      var number = parseNumber(val);
      if (number == null || !isNumber(number)) {
        return;
      }
      if (val.startsWith(0) || val.length === 3) {
        number += 2000;
      }
      if (val.length <= 2 && number < 50) {
        number += 2000;
      }
      if (val.length <= 2 && number < 100) {
        number += 1900;
      }
      _onChange({
        year: number
      });
    },
    onKeyDown: function onKeyDown(event) {
      var val = isNumber(value) ? value : new Date().getFullYear();
      if (event.key === 'ArrowUp') {
        _onChange({
          year: cycleNumber(val, 1, max, min)
        });
        event.preventDefault();
      }
      if (event.key === 'ArrowDown') {
        _onChange({
          year: cycleNumber(val, -1, max, min)
        });
        event.preventDefault();
      }
      if (event.key === 'Backspace' || event.key === 'Delete') {
        _onChange({
          year: null
        });
        event.preventDefault();
      }
    }
  });
}var maxMonth = 12;
var minMonth = 1;
function createMonthFragment(_ref) {
  var value = _ref.value,
    _onChange = _ref.onChange;
  return /*#__PURE__*/React__default.createElement(Fragment, {
    key: "MM",
    placeholder: "MM",
    length: 2,
    value: to2DigitString$1(value),
    onChange: function onChange(val, complete) {
      var parsedValue = parseNumber(val, 12, 1);
      if (!isNumber(parsedValue)) {
        return;
      }
      if (numberEnteredComplete(parsedValue, 12) && complete) {
        complete();
      }
      _onChange({
        month: parsedValue
      });
    },
    onKeyDown: function onKeyDown(event) {
      if (event.key === 'ArrowUp') {
        _onChange({
          month: cycleNumber(value, 1, maxMonth, minMonth) || minMonth
        });
        event.preventDefault();
      }
      if (event.key === 'ArrowDown') {
        _onChange({
          month: cycleNumber(value, -1, maxMonth, minMonth) || maxMonth
        });
        event.preventDefault();
      }
      if (event.key === 'Backspace' || event.key === 'Delete') {
        _onChange({
          month: null
        });
        event.preventDefault();
      }
    }
  });
}var minDay = 1;
function createDateFragment(year, month, _ref) {
  var value = _ref.value,
    _onChange = _ref.onChange;
  var maxDay = getEndOfMonth(year, month);
  var coercedValue = value && Math.min(value, maxDay);
  return /*#__PURE__*/React__default.createElement(Fragment, {
    key: "DD",
    placeholder: "DD",
    length: 2,
    value: to2DigitString$1(coercedValue),
    onChange: function onChange(val, complete) {
      var parsedVal = parseNumber(val, maxDay, 1);
      if (!isNumber(parsedVal)) {
        return;
      }
      if (numberEnteredComplete(parsedVal, maxDay) && complete) {
        complete();
      }
      _onChange({
        date: parsedVal
      });
    },
    onKeyDown: function onKeyDown(event) {
      if (event.key === 'ArrowUp') {
        _onChange({
          date: cycleNumber(coercedValue, 1, maxDay, minDay) || minDay
        });
        event.preventDefault();
      }
      if (event.key === 'ArrowDown') {
        _onChange({
          date: cycleNumber(coercedValue, -1, maxDay, minDay) || maxDay
        });
        event.preventDefault();
      }
      if (event.key === 'Backspace' || event.key === 'Delete') {
        _onChange({
          date: null
        });
        event.preventDefault();
      }
    }
  });
}var year = '2020';
var month = '11';
var day = '19';
var hour = '13';
var minute = '45';
var testDate = new Date("".concat(year, "-").concat(month, "-").concat(day, "T").concat(hour, ":").concat(minute));
var getTemplate$2 = function getTemplate(locale, format) {
  var formatter = format === 'L' ? new Intl.DateTimeFormat(locale, {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric'
  }) : new Intl.DateTimeFormat(locale, {
    hour: 'numeric',
    minute: 'numeric'
  });
  var formattedDate = formatter.format(testDate);
  var finalFormat = formattedDate.replace(year, '{{YYYY}}').replace(month, '{{MM}}').replace(day, '{{DD}}').replace(minute, '{{mm}}').replace('PM', '{{A}}') // e.g. in en-US
  .replace('pm', '{{A}}'); // e.g. in en-AU

  if (finalFormat.includes('{{A}}')) {
    finalFormat = finalFormat.replace('1', '{{hh}}');
  } else {
    finalFormat = finalFormat.replace(hour, '{{HH}}');
  }
  return finalFormat;
};
var getFragmentTemplate = getTemplate$2;var valueToState$6 = function valueToState(value) {
  if (value == null) {
    return {
      year: null,
      month: null,
      date: null,
      hour: null,
      minute: null
    };
  }
  var localTime = new Date(value);
  return {
    year: localTime.getFullYear(),
    month: localTime.getMonth() + 1,
    date: localTime.getDate(),
    hour: localTime.getHours(),
    minute: localTime.getMinutes()
  };
};
var valueToState$7 = valueToState$6;function stateToMoment$2(_ref) {
  var year = _ref.year,
    month = _ref.month,
    date = _ref.date,
    hour = _ref.hour,
    minute = _ref.minute;
  if (typeof year !== 'number' || typeof month !== 'number' || typeof date !== 'number' || typeof hour !== 'number' || typeof minute !== 'number') {
    return null;
  }
  var newState = new Date();
  newState.setFullYear(Math.max(year, 1));
  newState.setMonth(month - 1);
  newState.setDate(date);
  newState.setHours(hour);
  newState.setMinutes(minute);
  newState.setSeconds(0);
  newState.setMilliseconds(0);
  if (!isValid(newState)) {
    return null;
  }
  return newState.toISOString();
}var datetimeUtils=/*#__PURE__*/Object.freeze({__proto__:null,valueToState:valueToState$7,stateToValue:stateToMoment$2});var valueToState$4 = function valueToState(value) {
  if (value == null) {
    return {
      year: null,
      month: null,
      date: null,
      hour: null,
      minute: null
    };
  }
  var localTime = new Date(value);
  return {
    year: localTime.getFullYear(),
    month: localTime.getMonth() + 1,
    date: localTime.getDate(),
    hour: localTime.getHours(),
    minute: localTime.getMinutes()
  };
};
var valueToState$5 = valueToState$4;function stateToMoment$1(_ref) {
  var year = _ref.year,
    month = _ref.month,
    day = _ref.date,
    hour = _ref.hour,
    minute = _ref.minute;
  if (typeof year !== 'number' || typeof month !== 'number' || typeof day !== 'number' || typeof hour !== 'number' || typeof minute !== 'number') {
    return null;
  }
  var date = new Date("".concat(year, "-").concat(pad(month), "-").concat(pad(day), "T").concat(pad(hour), ":").concat(pad(minute)));
  return [format(date, 'yyyy-MM-dd'), format(date, 'HH:mm:ss')].join('T');
}
var pad = function pad(value) {
  return value.toString().padStart(2, '0');
};var datetimelocalUtils=/*#__PURE__*/Object.freeze({__proto__:null,valueToState:valueToState$5,stateToValue:stateToMoment$1});var defaultValue$1 = {
  year: null,
  month: null,
  date: null
};
function valueToState$3(value) {
  if (value == null) {
    return defaultValue$1;
  }
  var _value$split = value.split('-'),
    _value$split2 = _slicedToArray(_value$split, 3),
    yearText = _value$split2[0],
    monthText = _value$split2[1],
    dateText = _value$split2[2];
  var year = parseInt(yearText, 10);
  var month = parseInt(monthText, 10);
  var date = parseInt(dateText, 10);
  if (!isNumber(year) || !isNumber(month) || !isNumber(date)) {
    return defaultValue$1;
  }
  return {
    year: year,
    month: month,
    date: date
  };
}function stateToValue$1(_ref) {
  var year = _ref.year,
    month = _ref.month,
    date = _ref.date;
  if (typeof year !== 'number' || typeof month !== 'number' || typeof date !== 'number') {
    return null;
  }
  return [year, month.toString().padStart(2, '0'), date.toString().padStart(2, '0')].join('-');
}var dateUtils=/*#__PURE__*/Object.freeze({__proto__:null,valueToState:valueToState$3,stateToValue:stateToValue$1});function stateToMoment(_ref) {
  var hour = _ref.hour,
    minute = _ref.minute;
  if (typeof hour !== 'number' || typeof minute !== 'number') {
    return null;
  }
  return [hour.toString().padStart(2, '0'), minute.toString().padStart(2, '0')].join(':');
}var valueToState$1 = function valueToState(value) {
  if (value == null) {
    return {
      hour: null,
      minute: null
    };
  }
  var _value$split = value.split(':'),
    _value$split2 = _slicedToArray(_value$split, 2),
    hourText = _value$split2[0],
    minuteText = _value$split2[1];
  var hour = parseInt(hourText, 10);
  var minute = parseInt(minuteText, 10);
  if (!isNumber(hour) || !isNumber(minute)) {
    return {
      hour: null,
      minute: null
    };
  }
  return {
    hour: hour,
    minute: minute
  };
};
var valueToState$2 = valueToState$1;var timeUtils=/*#__PURE__*/Object.freeze({__proto__:null,stateToValue:stateToMoment,valueToState:valueToState$2});var culture = typeof navigator !== 'undefined' ? navigator.language : 'en-US';
var defaultCulture = culture;var _excluded$r = ["culture", "step", "value", "template", "onChange"];
function Time(_ref, ref) {
  var _ref$culture = _ref.culture,
    culture = _ref$culture === void 0 ? defaultCulture : _ref$culture,
    _ref$step = _ref.step,
    step = _ref$step === void 0 ? 1 : _ref$step,
    value = _ref.value,
    template = _ref.template,
    onChange = _ref.onChange,
    rest = _objectWithoutProperties(_ref, _excluded$r);
  var _useFragmentedValue = useFragmentedValue(value, onChange, timeUtils),
    _useFragmentedValue2 = _slicedToArray(_useFragmentedValue, 2),
    _useFragmentedValue2$ = _useFragmentedValue2[0],
    hour = _useFragmentedValue2$.hour,
    minute = _useFragmentedValue2$.minute,
    onComponentChange = _useFragmentedValue2[1];
  return /*#__PURE__*/React__default.createElement(FragmentedInput$1, _extends({}, rest, {
    ref: ref,
    template: template || getFragmentTemplate(culture, 'LT')
  }), create24HourFragment({
    value: hour,
    onChange: onComponentChange,
    step: Math.max(step / 3600, 1)
  }), create12HourFragment({
    value: hour,
    onChange: onComponentChange,
    step: Math.max(step / 3600, 1)
  }), createMinuteFragment$3({
    value: minute,
    onChange: onComponentChange,
    step: Math.max(Math.round(step / 60), 1)
  }), createMeridiemFragment({
    value: hour,
    onChange: onComponentChange
  }));
}
var Time$1 = /*#__PURE__*/forwardRef(Time);var _excluded$q = ["culture", "step", "template", "minYear", "maxYear", "value", "onChange"];
function DateInput(_ref, ref) {
  var _ref$culture = _ref.culture,
    culture = _ref$culture === void 0 ? defaultCulture : _ref$culture,
    _ref$step = _ref.step,
    step = _ref$step === void 0 ? 1 : _ref$step,
    template = _ref.template,
    minYear = _ref.minYear,
    maxYear = _ref.maxYear,
    value = _ref.value,
    onChange = _ref.onChange,
    rest = _objectWithoutProperties(_ref, _excluded$q);
  var _useFragmentedValue = useFragmentedValue(value, onChange, dateUtils),
    _useFragmentedValue2 = _slicedToArray(_useFragmentedValue, 2),
    _useFragmentedValue2$ = _useFragmentedValue2[0],
    year = _useFragmentedValue2$.year,
    month = _useFragmentedValue2$.month,
    date = _useFragmentedValue2$.date,
    onComponentChange = _useFragmentedValue2[1];
  return /*#__PURE__*/React__default.createElement(FragmentedInput$1, _extends({}, rest, {
    ref: ref,
    template: template || getFragmentTemplate(culture, 'L')
  }), createYearFragment({
    value: year,
    onChange: onComponentChange,
    step: 1,
    min: minYear,
    max: maxYear
  }), createMonthFragment({
    value: month,
    onChange: onComponentChange,
    step: 1
  }), createDateFragment(year, month, {
    value: date,
    onChange: onComponentChange,
    step: step
  }));
}
var DateInput$1 = /*#__PURE__*/forwardRef(DateInput);var _excluded$p = ["culture", "step", "value", "onChange"];
function DateTime(_ref, ref) {
  var _ref$culture = _ref.culture,
    culture = _ref$culture === void 0 ? defaultCulture : _ref$culture,
    _ref$step = _ref.step,
    step = _ref$step === void 0 ? 60 : _ref$step,
    value = _ref.value,
    onChange = _ref.onChange,
    rest = _objectWithoutProperties(_ref, _excluded$p);
  var _useFragmentedValue = useFragmentedValue(value, onChange, datetimeUtils),
    _useFragmentedValue2 = _slicedToArray(_useFragmentedValue, 2),
    _useFragmentedValue2$ = _useFragmentedValue2[0],
    year = _useFragmentedValue2$.year,
    month = _useFragmentedValue2$.month,
    hour = _useFragmentedValue2$.hour,
    minute = _useFragmentedValue2$.minute,
    date = _useFragmentedValue2$.date,
    onComponentChange = _useFragmentedValue2[1];
  return /*#__PURE__*/React__default.createElement(FragmentedInput$1, _extends({}, rest, {
    template: getTemplate$1(culture),
    ref: ref
  }), createYearFragment({
    value: year,
    onChange: onComponentChange,
    step: 1
  }), createMonthFragment({
    value: month,
    onChange: onComponentChange,
    step: 1
  }), createDateFragment(year, month, {
    value: date,
    onChange: onComponentChange,
    step: 1
  }), create24HourFragment({
    value: hour,
    onChange: onComponentChange,
    step: Math.max(step / 3600, 1)
  }), create12HourFragment({
    value: hour,
    onChange: onComponentChange,
    step: Math.max(step / 3600, 1)
  }), createMinuteFragment$3({
    value: minute,
    onChange: onComponentChange,
    step: Math.max(Math.round(step / 60), 1)
  }), createMeridiemFragment({
    value: hour,
    onChange: onComponentChange
  }));
}
var getTemplate$1 = function getTemplate(culture, step) {
  var dateTemplate = getFragmentTemplate(culture, 'L');
  var timeTemplate = getFragmentTemplate(culture, 'LT');
  return "".concat(dateTemplate, "\u3000").concat(timeTemplate);
};
var DateTime$1 = /*#__PURE__*/forwardRef(DateTime);var _excluded$o = ["culture", "step", "value", "onChange"];
function DateTimeLocal(_ref) {
  var _ref$culture = _ref.culture,
    culture = _ref$culture === void 0 ? defaultCulture : _ref$culture,
    _ref$step = _ref.step,
    step = _ref$step === void 0 ? 60 : _ref$step,
    value = _ref.value,
    onChange = _ref.onChange,
    rest = _objectWithoutProperties(_ref, _excluded$o);
  var _useFragmentedValue = useFragmentedValue(value, onChange, datetimelocalUtils),
    _useFragmentedValue2 = _slicedToArray(_useFragmentedValue, 2),
    _useFragmentedValue2$ = _useFragmentedValue2[0],
    year = _useFragmentedValue2$.year,
    month = _useFragmentedValue2$.month,
    date = _useFragmentedValue2$.date,
    hour = _useFragmentedValue2$.hour,
    minute = _useFragmentedValue2$.minute,
    onComponentChange = _useFragmentedValue2[1];
  return /*#__PURE__*/React__default.createElement(FragmentedInput$1, _extends({}, rest, {
    template: getTemplate(culture)
  }), createYearFragment({
    value: year,
    onChange: onComponentChange,
    step: 1
  }), createMonthFragment({
    value: month,
    onChange: onComponentChange,
    step: 1
  }), createDateFragment(year, month, {
    value: date,
    onChange: onComponentChange,
    step: 1
  }), create24HourFragment({
    value: hour,
    onChange: onComponentChange,
    step: Math.max(step / 3600, 1)
  }), create12HourFragment({
    value: hour,
    onChange: onComponentChange,
    step: Math.max(step / 3600, 1)
  }), createMinuteFragment$3({
    value: minute,
    onChange: onComponentChange,
    step: Math.max(Math.round(step / 60), 1)
  }), createMeridiemFragment({
    value: hour,
    onChange: onComponentChange
  }));
}
var getTemplate = function getTemplate(culture, step) {
  var dateTemplate = getFragmentTemplate(culture, 'L');
  var timeTemplate = getFragmentTemplate(culture, 'LT');
  return "".concat(dateTemplate, "\u3000").concat(timeTemplate);
};var numberSequence = function numberSequence(low, high) {
  return Array(high - low + 1).fill(null).map(function (_, i) {
    return low + i;
  });
};
function generateYears(date, minYears, maxYears) {
  var thisYear = new Date();
  var lowestDefaultYear = thisYear.getFullYear() - minYears;
  var highestDefaultYear = thisYear.getFullYear() + maxYears;
  var lowestSelectedYear = date - minYears;
  var highestSelectedYear = date + maxYears;
  var lowestPossibleYear = Math.min(lowestSelectedYear, lowestDefaultYear);
  var highestPossibleYear = Math.max(highestSelectedYear, highestDefaultYear);
  return numberSequence(lowestPossibleYear, highestPossibleYear);
}var DEFAULT_YEAR_EPSILON = 5;
var YearMonthNavigation = function YearMonthNavigation(_ref) {
  var date = _ref.date,
    locale = _ref.locale,
    _ref$yearsPast = _ref.yearsPast,
    yearsPast = _ref$yearsPast === void 0 ? DEFAULT_YEAR_EPSILON : _ref$yearsPast,
    _ref$yearsFuture = _ref.yearsFuture,
    yearsFuture = _ref$yearsFuture === void 0 ? DEFAULT_YEAR_EPSILON : _ref$yearsFuture,
    style = _ref.style,
    className = _ref.className,
    classNames = _ref.classNames,
    _onChange = _ref.onChange;
  var styles = useStyles(defaultStyles$7, {
    style: style,
    className: className,
    classNames: classNames
  });
  var months = getMonthsInYear(locale, date.getFullYear());
  var years = generateYears(date.getFullYear(), yearsPast, yearsFuture);

  /* Please fix me */
  // onBlur must be used instead of onchange, unless absolutely necessary and it causes no negative consequences for keyboard only or screen reader users
  /* eslint-disable jsx-a11y/no-onchange */
  return /*#__PURE__*/React__default.createElement("div", styles, /*#__PURE__*/React__default.createElement("select", _extends({}, styles('month'), {
    "data-testid": "select-month",
    value: date.getMonth(),
    onChange: function onChange(event) {
      event.stopPropagation();
      _onChange({
        year: date.getFullYear(),
        month: parseInt(event.target.value, 10)
      });
    }
  }), months.map(function (month, i) {
    return /*#__PURE__*/React__default.createElement("option", _extends({}, styles('option'), {
      key: i,
      value: i
    }), month);
  })), /*#__PURE__*/React__default.createElement("select", _extends({}, styles('year'), {
    "data-testid": "select-year",
    value: date.getFullYear(),
    onChange: function onChange(event) {
      event.stopPropagation();
      _onChange({
        month: date.getMonth(),
        year: parseInt(event.target.value, 10)
      });
    }
  }), years.map(function (year) {
    return /*#__PURE__*/React__default.createElement("option", _extends({}, styles('option'), {
      key: year,
      value: year
    }), year);
  })));

  /* Please fix me */
  /* eslint-enable jsx-a11y/no-onchange */
};

var MONTHS_IN_A_YEAR = 12;
var getMonthsInYear = function getMonthsInYear(locale, year) {
  var formatter = new Intl.DateTimeFormat(locale, {
    month: 'long'
  });
  return Array(MONTHS_IN_A_YEAR).fill(null).map(function (_, month) {
    return formatter.format(new Date(year, month, 1));
  });
};
var defaultStyles$7 = {
  display: 'table-caption',
  textAlign: 'center'
};
var YearMonthNavigation$1 = YearMonthNavigation;var datePickerPropTypes = {
  localeUtils: PropTypes.shape({
    formatMonthTitle: PropTypes.func,
    formatWeekdayShort: PropTypes.func,
    formatWeekdayLong: PropTypes.func,
    getFirstDayOfWeek: PropTypes.func
  })
};
var DayPickerPropTypes = datePickerPropTypes;function Caption$1(_ref) {
  var date = _ref.date,
    months = _ref.months,
    locale = _ref.locale,
    localeUtils = _ref.localeUtils,
    onClick = _ref.onClick,
    style = _ref.style;
  return (
    /*#__PURE__*/
    // Please fix me
    // jsx-a11y/click-events-have-key-events jsx-a11y/no-noninteractive-element-interactions
    // eslint-disable-next-line
    React__default.createElement("div", _extends({
      onClick: onClick
    }, style, {
      role: "heading",
      "aria-level": "2"
    }), months ? "".concat(months[date.getMonth()], " ").concat(date.getFullYear()) : localeUtils.formatMonthTitle(date, locale))
  );
}
Caption$1.propTypes = {
  date: PropTypes.instanceOf(Date),
  months: PropTypes.arrayOf(PropTypes.string),
  locale: PropTypes.string,
  localeUtils: DayPickerPropTypes.localeUtils,
  onClick: PropTypes.func,
  style: PropTypes.func.isRequired
};
var Caption$2 = createDefaultStyle({
  display: 'table-caption'
})(Caption$1);/**
 * Clone a date object.
 *
 * @param  {Date} d The date to clone
 * @return {Date} The cloned date
 */
function clone(d) {
  return new Date(d.getTime());
}

/**
 * Return `d` as a new date with `n` months added.
 * @param {[type]} d
 * @param {[type]} n
 */
function addMonths(d, n) {
  var newDate = clone(d);
  newDate.setMonth(d.getMonth() + n);
  return newDate;
}

/**
 * Return `true` if two dates are the same day, ignoring the time.
 *
 * @param  {Date}  d1
 * @param  {Date}  d2
 * @return {Boolean}
 */
function isSameDay(d1, d2) {
  if (!d1 || !d2) {
    return false;
  }
  return d1.getDate() === d2.getDate() && d1.getMonth() === d2.getMonth() && d1.getFullYear() === d2.getFullYear();
}function handleEvent(handler, day, modifiers) {
  if (!handler) {
    return undefined;
  }
  var dayState = {};
  modifiers.forEach(function (modifier) {
    dayState[modifier] = true;
  });
  return function (e) {
    e.persist();
    handler(e, day, dayState);
  };
}
function Day(_ref) {
  var day = _ref.day,
    tabIndex = _ref.tabIndex,
    empty = _ref.empty,
    modifiers = _ref.modifiers,
    onMouseEnter = _ref.onMouseEnter,
    onMouseLeave = _ref.onMouseLeave,
    onClick = _ref.onClick,
    onKeyDown = _ref.onKeyDown,
    onTouchStart = _ref.onTouchStart,
    onTouchEnd = _ref.onTouchEnd,
    onFocus = _ref.onFocus,
    ariaLabel = _ref.ariaLabel,
    ariaDisabled = _ref.ariaDisabled,
    ariaSelected = _ref.ariaSelected,
    dataDayInside = _ref.dataDayInside,
    children = _ref.children,
    style = _ref.style;
  if (empty) {
    return /*#__PURE__*/React__default.createElement("div", _extends({
      role: "gridcell",
      "aria-disabled": true
    }, style));
  }
  return /*#__PURE__*/React__default.createElement("div", _extends({}, style, {
    tabIndex: tabIndex,
    role: "gridcell",
    "data-dayinside": dataDayInside,
    "aria-label": ariaLabel,
    "aria-disabled": ariaDisabled.toString(),
    "aria-selected": ariaSelected.toString(),
    onClick: handleEvent(onClick, day, modifiers),
    onKeyDown: handleEvent(onKeyDown, day, modifiers),
    onMouseEnter: handleEvent(onMouseEnter, day, modifiers),
    onMouseLeave: handleEvent(onMouseLeave, day, modifiers),
    onTouchEnd: handleEvent(onTouchEnd, day, modifiers),
    onTouchStart: handleEvent(onTouchStart, day, modifiers),
    onFocus: handleEvent(onFocus, day, modifiers)
  }), children);
}
Day.propTypes = {
  day: PropTypes.instanceOf(Date).isRequired,
  children: PropTypes.node.isRequired,
  dataDayInside: PropTypes.bool,
  ariaDisabled: PropTypes.bool,
  ariaLabel: PropTypes.string,
  ariaSelected: PropTypes.bool,
  empty: PropTypes.bool,
  modifiers: PropTypes.array,
  onClick: PropTypes.func,
  onKeyDown: PropTypes.func,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  onTouchEnd: PropTypes.func,
  onTouchStart: PropTypes.func,
  onFocus: PropTypes.func,
  tabIndex: PropTypes.number,
  style: PropTypes.func.isRequired
};
Day.defaultProps = {
  modifiers: [],
  empty: false
};
var styled$n = createDefaultStyle({
  display: 'table-cell',
  cursor: 'pointer',
  verticalAlign: 'middle',
  '&today': {
    fontWeight: 500
  },
  '&disabled': {
    cursor: 'default'
  },
  '&outside': {
    cursor: 'default'
  }
}, function (_ref2) {
  var modifiers = _ref2.modifiers;
  return modifiers.map(function (modifier) {
    return "&".concat(modifier);
  });
});
var Day$1 = styled$n(Day);var WEEKDAYS_LONG = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
var WEEKDAYS_SHORT = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];
var MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
function formatDay(day) {
  return day.toDateString();
}
function formatMonthTitle(d) {
  return "".concat(MONTHS[d.getMonth()], " ").concat(d.getFullYear());
}
function formatWeekdayShort(i) {
  return WEEKDAYS_SHORT[i];
}
function formatWeekdayLong(i) {
  return WEEKDAYS_LONG[i];
}
function getFirstDayOfWeek() {
  return 0;
}
function getMonths() {
  return MONTHS;
}
var LocaleUtils = {
  formatDay: formatDay,
  formatMonthTitle: formatMonthTitle,
  formatWeekdayShort: formatWeekdayShort,
  formatWeekdayLong: formatWeekdayLong,
  getFirstDayOfWeek: getFirstDayOfWeek,
  getMonths: getMonths
};var LocaleUtils$1=/*#__PURE__*/Object.freeze({__proto__:null,formatDay:formatDay,formatMonthTitle:formatMonthTitle,formatWeekdayShort:formatWeekdayShort,formatWeekdayLong:formatWeekdayLong,getFirstDayOfWeek:getFirstDayOfWeek,getMonths:getMonths,'default':LocaleUtils});function ownKeys$m(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$m(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$m(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$m(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function cancelEvent(e) {
  e.preventDefault();
  e.stopPropagation();
}
function getCustomProps(props, propTypes) {
  var customProps = {};
  Object.keys(props).filter(function (propName) {
    return !{}.hasOwnProperty.call(propTypes, propName);
  }).forEach(function (propName) {
    customProps[propName] = props[propName];
  });
  return customProps;
}
function getFirstDayOfMonth(d) {
  return new Date(d.getFullYear(), d.getMonth(), 1, 12);
}
function getDaysInMonth(d) {
  var resultDate = getFirstDayOfMonth(d);
  resultDate.setMonth(resultDate.getMonth() + 1);
  resultDate.setDate(resultDate.getDate() - 1);
  return resultDate.getDate();
}
function getModifiersFromProps(props) {
  var modifiers = _objectSpread$m({}, props.modifiers);
  if (props.selectedDays) {
    modifiers.selected = props.selectedDays;
  }
  if (props.disabledDays) {
    modifiers.disabled = props.disabledDays;
  }
  return modifiers;
}
function getFirstDayOfWeekFromProps(props) {
  var firstDayOfWeek = props.firstDayOfWeek,
    _props$locale = props.locale,
    locale = _props$locale === void 0 ? 'en' : _props$locale,
    _props$localeUtils = props.localeUtils,
    localeUtils = _props$localeUtils === void 0 ? {} : _props$localeUtils;
  if (!isNaN(firstDayOfWeek)) {
    return firstDayOfWeek;
  }
  if (localeUtils.getFirstDayOfWeek) {
    return localeUtils.getFirstDayOfWeek(locale);
  }
  return 0;
}
function getModifiersForDay(d) {
  var modifierFunctions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return Object.keys(modifierFunctions).reduce(function (modifiers, modifier) {
    var func = modifierFunctions[modifier];
    if (func(d)) {
      modifiers.push(modifier);
    }
    return modifiers;
  }, []);
}
function getMonthsDiff(d1, d2) {
  return d2.getMonth() - d1.getMonth() + 12 * (d2.getFullYear() - d1.getFullYear());
}
function getWeekArray(d) {
  var firstDayOfWeek = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : getFirstDayOfWeek();
  var fixedWeeks = arguments.length > 2 ? arguments[2] : undefined;
  var daysInMonth = getDaysInMonth(d);
  var dayArray = [];
  var week = [];
  var weekArray = [];
  for (var i = 1; i <= daysInMonth; i += 1) {
    dayArray.push(new Date(d.getFullYear(), d.getMonth(), i, 12));
  }
  dayArray.forEach(function (day) {
    if (week.length > 0 && day.getDay() === firstDayOfWeek) {
      weekArray.push(week);
      week = [];
    }
    week.push(day);
    if (dayArray.indexOf(day) === dayArray.length - 1) {
      weekArray.push(week);
    }
  });

  // unshift days to start the first week
  var firstWeek = weekArray[0];
  for (var _i = 7 - firstWeek.length; _i > 0; _i -= 1) {
    var outsideDate = clone(firstWeek[0]);
    outsideDate.setDate(firstWeek[0].getDate() - 1);
    firstWeek.unshift(outsideDate);
  }

  // push days until the end of the last week
  var lastWeek = weekArray[weekArray.length - 1];
  for (var _i2 = lastWeek.length; _i2 < 7; _i2 += 1) {
    var _outsideDate = clone(lastWeek[lastWeek.length - 1]);
    _outsideDate.setDate(lastWeek[lastWeek.length - 1].getDate() + 1);
    lastWeek.push(_outsideDate);
  }

  // add extra weeks to reach 6 weeks
  if (fixedWeeks && weekArray.length < 6) {
    var lastExtraWeek;
    for (var _i3 = weekArray.length; _i3 < 6; _i3 += 1) {
      lastExtraWeek = weekArray[weekArray.length - 1];
      var lastDay = lastExtraWeek[lastExtraWeek.length - 1];
      var extraWeek = [];
      for (var j = 0; j < 7; j += 1) {
        var _outsideDate2 = clone(lastDay);
        _outsideDate2.setDate(lastDay.getDate() + j + 1);
        extraWeek.push(_outsideDate2);
      }
      weekArray.push(extraWeek);
    }
  }
  return weekArray;
}
function startOfMonth(d) {
  var newDate = clone(d);
  newDate.setDate(1);
  newDate.setHours(12, 0, 0, 0); // always set noon to avoid time zone issues
  return newDate;
}function ownKeys$l(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$l(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$l(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$l(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function Weekdays(_ref) {
  var firstDayOfWeek = _ref.firstDayOfWeek,
    weekdaysLong = _ref.weekdaysLong,
    weekdaysShort = _ref.weekdaysShort,
    locale = _ref.locale,
    localeUtils = _ref.localeUtils,
    weekdayElement = _ref.weekdayElement,
    style = _ref.style;
  var days = [];
  for (var i = 0; i < 7; i += 1) {
    var weekday = (i + firstDayOfWeek) % 7;
    var elementProps = _objectSpread$l({
      key: i,
      weekday: weekday,
      weekdaysLong: weekdaysLong,
      weekdaysShort: weekdaysShort,
      localeUtils: localeUtils,
      locale: locale
    }, style('weekday'));
    var element = /*#__PURE__*/React__default.cloneElement(weekdayElement, elementProps);
    days.push(element);
  }
  return /*#__PURE__*/React__default.createElement("div", _extends({}, style, {
    role: "rowgroup"
  }), /*#__PURE__*/React__default.createElement("div", _extends({}, style('row'), {
    role: "columnheader"
  }), days));
}
Weekdays.propTypes = {
  firstDayOfWeek: PropTypes.number.isRequired,
  weekdaysLong: PropTypes.arrayOf(PropTypes.string),
  weekdaysShort: PropTypes.arrayOf(PropTypes.string),
  locale: PropTypes.string.isRequired,
  localeUtils: DayPickerPropTypes.localeUtils.isRequired,
  weekdayElement: PropTypes.element,
  style: PropTypes.func.isRequired
};
var styled$m = createDefaultStyle({
  display: 'table-header-group',
  row: {
    display: 'table-row'
  }
});
var Weekdays$1 = styled$m(Weekdays);function Month(_ref) {
  var month = _ref.month,
    months = _ref.months,
    weekdaysLong = _ref.weekdaysLong,
    weekdaysShort = _ref.weekdaysShort,
    locale = _ref.locale,
    localeUtils = _ref.localeUtils,
    captionElement = _ref.captionElement,
    onCaptionClick = _ref.onCaptionClick,
    children = _ref.children,
    firstDayOfWeek = _ref.firstDayOfWeek,
    style = _ref.style,
    weekdayElement = _ref.weekdayElement,
    fixedWeeks = _ref.fixedWeeks;
  var captionProps = {
    date: month,
    months: months,
    localeUtils: localeUtils,
    locale: locale,
    onClick: onCaptionClick ? function (e) {
      return onCaptionClick(e, month);
    } : undefined
  };
  var weeks = getWeekArray(month, firstDayOfWeek, fixedWeeks);
  return /*#__PURE__*/React__default.createElement("div", style, captionElement && captionElement(captionProps), /*#__PURE__*/React__default.createElement(Weekdays$1, {
    weekdaysShort: weekdaysShort,
    weekdaysLong: weekdaysLong,
    firstDayOfWeek: firstDayOfWeek,
    locale: locale,
    localeUtils: localeUtils,
    weekdayElement: weekdayElement,
    style: style('weekdays')
  }), /*#__PURE__*/React__default.createElement("div", _extends({}, style('body'), {
    role: "grid"
  }), weeks.map(function (week, j) {
    return /*#__PURE__*/React__default.createElement("div", _extends({
      key: j
    }, style('week'), {
      role: "gridcell"
    }), week.map(function (day) {
      return children(day, month);
    }));
  })));
}
Month.propTypes = {
  month: PropTypes.instanceOf(Date).isRequired,
  months: PropTypes.arrayOf(PropTypes.string),
  captionElement: PropTypes.node.isRequired,
  firstDayOfWeek: PropTypes.number.isRequired,
  weekdaysLong: PropTypes.arrayOf(PropTypes.string),
  weekdaysShort: PropTypes.arrayOf(PropTypes.string),
  locale: PropTypes.string.isRequired,
  localeUtils: DayPickerPropTypes.localeUtils.isRequired,
  onCaptionClick: PropTypes.func,
  children: PropTypes.func.isRequired,
  style: PropTypes.func.isRequired,
  weekdayElement: PropTypes.element,
  fixedWeeks: PropTypes.bool
};
var styled$l = createDefaultStyle({
  display: 'table',
  borderCollapse: 'collapse',
  borderSpacing: 0,
  userSelect: 'none',
  body: {
    display: 'table-row-group'
  },
  week: {
    display: 'table-row'
  }
});
var Month$1 = styled$l(Month);function Navbar(_ref) {
  var style = _ref.style,
    showPreviousButton = _ref.showPreviousButton,
    showNextButton = _ref.showNextButton,
    onPreviousClick = _ref.onPreviousClick,
    onNextClick = _ref.onNextClick,
    dir = _ref.dir;
  var previousClickHandler = dir === 'rtl' ? onNextClick : onPreviousClick;
  var nextClickHandler = dir === 'rtl' ? onPreviousClick : onNextClick;
  var previousButton = showPreviousButton &&
  /*#__PURE__*/
  // Please fix me
  // jsx-a11y/click-events-have-key-events jsx-a11y/interactive-supports-focus
  // eslint-disable-next-line
  React__default.createElement("span", _extends({
    role: "button",
    key: "previous"
  }, style('button')('&prev'), {
    onClick: function onClick() {
      return previousClickHandler();
    }
  }), "\u3008");
  var nextButton = showNextButton &&
  /*#__PURE__*/
  // Please fix me
  // jsx-a11y/interactive-supports-focus jsx-a11y/click-events-have-key-events
  // eslint-disable-next-line
  React__default.createElement("span", _extends({
    role: "button",
    key: "right"
  }, style('button')('&next'), {
    onClick: function onClick() {
      return nextClickHandler();
    }
  }), "\u3009");
  return /*#__PURE__*/React__default.createElement("div", style, dir === 'rtl' ? [nextButton, previousButton] : [previousButton, nextButton]);
}
var NavbarPropTypes = {
  style: PropTypes.func.isRequired,
  showPreviousButton: PropTypes.bool,
  showNextButton: PropTypes.bool,
  onPreviousClick: PropTypes.func,
  onNextClick: PropTypes.func,
  dir: PropTypes.string
};
Navbar.propTypes = NavbarPropTypes;
Navbar.defaultProps = {
  dir: 'ltr',
  showPreviousButton: true,
  showNextButton: true
};
var styled$k = createDefaultStyle({
  position: 'absolute',
  left: 0,
  right: 0,
  button: {
    position: 'absolute',
    width: '1.5rem',
    height: '1.5rem',
    cursor: 'pointer',
    '&prev': {
      left: 0
    },
    '&next': {
      right: 0
    }
  }
});
var Navbar$1 = styled$k(Navbar);function Weekday(_ref) {
  var weekday = _ref.weekday,
    style = _ref.style,
    weekdaysLong = _ref.weekdaysLong,
    weekdaysShort = _ref.weekdaysShort,
    localeUtils = _ref.localeUtils,
    locale = _ref.locale;
  var title;
  if (weekdaysLong) {
    title = weekdaysLong[weekday];
  } else {
    title = localeUtils.formatWeekdayLong(weekday, locale);
  }
  var content;
  if (weekdaysShort) {
    content = weekdaysShort[weekday];
  } else {
    content = localeUtils.formatWeekdayShort(weekday, locale);
  }
  return /*#__PURE__*/React__default.createElement("div", style, /*#__PURE__*/React__default.createElement("abbr", _extends({}, style('abbr'), {
    title: title
  }), content));
}
var WeekdayPropTypes = {
  weekday: PropTypes.number,
  style: PropTypes.func.isRequired,
  locale: PropTypes.string,
  localeUtils: DayPickerPropTypes.localeUtils,
  weekdaysLong: PropTypes.arrayOf(PropTypes.string),
  weekdaysShort: PropTypes.arrayOf(PropTypes.string)
};
Weekday.propTypes = WeekdayPropTypes;
var styled$j = createDefaultStyle({
  display: 'table-cell',
  textAlign: 'center'
});
var Weekday$1 = styled$j(Weekday);var keys = {
  LEFT: 37,
  UP: 38,
  RIGHT: 39,
  DOWN: 40,
  ENTER: 13,
  SPACE: 32
};
var keys$1 = keys;var _excluded$n = ["locale", "localeUtils", "canChangeMonth", "navbarElement"];
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var DayPicker = /*#__PURE__*/function (_Component) {
  _inherits(DayPicker, _Component);
  var _super = _createSuper(DayPicker);
  function DayPicker(_props) {
    var _this;
    _classCallCheck(this, DayPicker);
    _this = _super.call(this, _props);
    _defineProperty(_assertThisInitialized(_this), "getStateFromProps", function (props) {
      var initialMonth = startOfMonth(props.initialMonth);
      var currentMonth = initialMonth;
      if (props.pagedNavigation && props.numberOfMonths > 1 && props.fromMonth) {
        var diffInMonths = getMonthsDiff(props.fromMonth, currentMonth);
        currentMonth = addMonths(props.fromMonth, Math.floor(diffInMonths / props.numberOfMonths) * props.numberOfMonths);
      }
      return {
        currentMonth: currentMonth
      };
    });
    _defineProperty(_assertThisInitialized(_this), "dayPicker", null);
    _this.renderDayInMonth = _this.renderDayInMonth.bind(_assertThisInitialized(_this));
    _this.showNextMonth = _this.showNextMonth.bind(_assertThisInitialized(_this));
    _this.showPreviousMonth = _this.showPreviousMonth.bind(_assertThisInitialized(_this));
    _this.handleKeyDown = _this.handleKeyDown.bind(_assertThisInitialized(_this));
    _this.handleDayClick = _this.handleDayClick.bind(_assertThisInitialized(_this));
    _this.handleDayKeyDown = _this.handleDayKeyDown.bind(_assertThisInitialized(_this));
    _this.state = _this.getStateFromProps(_props);
    return _this;
  }
  _createClass(DayPicker, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.initialMonth !== prevProps.initialMonth) {
        this.setState(this.getStateFromProps(this.props));
      }
    }
  }, {
    key: "getDayNodes",
    value: function getDayNodes() {
      return this.dayPicker.querySelectorAll('[data-dayinside]');
    }
  }, {
    key: "getNextNavigableMonth",
    value: function getNextNavigableMonth() {
      return addMonths(this.state.currentMonth, this.props.numberOfMonths);
    }
  }, {
    key: "getPreviousNavigableMonth",
    value: function getPreviousNavigableMonth() {
      return addMonths(this.state.currentMonth, -1);
    }
  }, {
    key: "allowPreviousMonth",
    value: function allowPreviousMonth() {
      var previousMonth = addMonths(this.state.currentMonth, -1);
      return this.allowMonth(previousMonth);
    }
  }, {
    key: "allowNextMonth",
    value: function allowNextMonth() {
      var nextMonth = addMonths(this.state.currentMonth, this.props.numberOfMonths);
      return this.allowMonth(nextMonth);
    }
  }, {
    key: "allowMonth",
    value: function allowMonth(d) {
      var _this$props = this.props,
        fromMonth = _this$props.fromMonth,
        toMonth = _this$props.toMonth,
        canChangeMonth = _this$props.canChangeMonth;
      if (!canChangeMonth || fromMonth && getMonthsDiff(fromMonth, d) < 0 || toMonth && getMonthsDiff(toMonth, d) > 0) {
        return false;
      }
      return true;
    }
  }, {
    key: "allowYearChange",
    value: function allowYearChange() {
      return this.props.canChangeMonth;
    }
  }, {
    key: "showMonth",
    value: function showMonth(d, callback) {
      var _this2 = this;
      if (!this.allowMonth(d)) {
        return;
      }
      this.setState({
        currentMonth: startOfMonth(d)
      }, function () {
        if (callback) {
          callback();
        }
        if (_this2.props.onMonthChange) {
          _this2.props.onMonthChange(_this2.state.currentMonth);
        }
      });
    }
  }, {
    key: "showNextMonth",
    value: function showNextMonth(callback) {
      if (!this.allowNextMonth()) {
        return;
      }
      var deltaMonths = this.props.pagedNavigation ? this.props.numberOfMonths : 1;
      var nextMonth = addMonths(this.state.currentMonth, deltaMonths);
      this.showMonth(nextMonth, callback);
    }
  }, {
    key: "showPreviousMonth",
    value: function showPreviousMonth(callback) {
      if (!this.allowPreviousMonth()) {
        return;
      }
      var deltaMonths = this.props.pagedNavigation ? this.props.numberOfMonths : 1;
      var previousMonth = addMonths(this.state.currentMonth, -deltaMonths);
      this.showMonth(previousMonth, callback);
    }
  }, {
    key: "showNextYear",
    value: function showNextYear() {
      if (!this.allowYearChange()) {
        return;
      }
      var nextMonth = addMonths(this.state.currentMonth, 12);
      this.showMonth(nextMonth);
    }
  }, {
    key: "showPreviousYear",
    value: function showPreviousYear() {
      if (!this.allowYearChange()) {
        return;
      }
      var nextMonth = addMonths(this.state.currentMonth, -12);
      this.showMonth(nextMonth);
    }
  }, {
    key: "focusFirstDayOfMonth",
    value: function focusFirstDayOfMonth() {
      this.getDayNodes()[0].focus();
    }
  }, {
    key: "focusLastDayOfMonth",
    value: function focusLastDayOfMonth() {
      var dayNodes = this.getDayNodes();
      dayNodes[dayNodes.length - 1].focus();
    }
  }, {
    key: "focusPreviousDay",
    value: function focusPreviousDay(dayNode) {
      var _this3 = this;
      var dayNodes = this.getDayNodes();
      var dayNodeIndex = _toConsumableArray(dayNodes).indexOf(dayNode);
      if (dayNodeIndex === 0) {
        this.showPreviousMonth(function () {
          return _this3.focusLastDayOfMonth();
        });
      } else {
        dayNodes[dayNodeIndex - 1].focus();
      }
    }
  }, {
    key: "focusNextDay",
    value: function focusNextDay(dayNode) {
      var _this4 = this;
      var dayNodes = this.getDayNodes();
      var dayNodeIndex = _toConsumableArray(dayNodes).indexOf(dayNode);
      if (dayNodeIndex === dayNodes.length - 1) {
        this.showNextMonth(function () {
          return _this4.focusFirstDayOfMonth();
        });
      } else {
        dayNodes[dayNodeIndex + 1].focus();
      }
    }
  }, {
    key: "focusNextWeek",
    value: function focusNextWeek(dayNode) {
      var _this5 = this;
      var dayNodes = this.getDayNodes();
      var dayNodeIndex = _toConsumableArray(dayNodes).indexOf(dayNode);
      var isInLastWeekOfMonth = dayNodeIndex > dayNodes.length - 8;
      if (isInLastWeekOfMonth) {
        this.showNextMonth(function () {
          var daysAfterIndex = dayNodes.length - dayNodeIndex;
          var nextMonthDayNodeIndex = 7 - daysAfterIndex;
          _this5.getDayNodes()[nextMonthDayNodeIndex].focus();
        });
      } else {
        dayNodes[dayNodeIndex + 7].focus();
      }
    }
  }, {
    key: "focusPreviousWeek",
    value: function focusPreviousWeek(dayNode) {
      var _this6 = this;
      var dayNodes = this.getDayNodes();
      var dayNodeIndex = _toConsumableArray(dayNodes).indexOf(dayNode);
      var isInFirstWeekOfMonth = dayNodeIndex <= 6;
      if (isInFirstWeekOfMonth) {
        this.showPreviousMonth(function () {
          var previousMonthDayNodes = _this6.getDayNodes();
          var startOfLastWeekOfMonth = previousMonthDayNodes.length - 7;
          var previousMonthDayNodeIndex = startOfLastWeekOfMonth + dayNodeIndex;
          previousMonthDayNodes[previousMonthDayNodeIndex].focus();
        });
      } else {
        dayNodes[dayNodeIndex - 7].focus();
      }
    }

    // Event handlers
  }, {
    key: "handleKeyDown",
    value: function handleKeyDown(e) {
      e.persist();
      switch (e.keyCode) {
        case keys$1.LEFT:
          this.showPreviousMonth();
          break;
        case keys$1.RIGHT:
          this.showNextMonth();
          break;
        case keys$1.UP:
          this.showPreviousYear();
          break;
        case keys$1.DOWN:
          this.showNextYear();
          break;
      }
      if (this.props.onKeyDown) {
        this.props.onKeyDown(e);
      }
    }
  }, {
    key: "handleDayKeyDown",
    value: function handleDayKeyDown(e, day, modifiers) {
      e.persist();
      switch (e.keyCode) {
        case keys$1.LEFT:
          cancelEvent(e);
          this.focusPreviousDay(e.target);
          break;
        case keys$1.RIGHT:
          cancelEvent(e);
          this.focusNextDay(e.target);
          break;
        case keys$1.UP:
          cancelEvent(e);
          this.focusPreviousWeek(e.target);
          break;
        case keys$1.DOWN:
          cancelEvent(e);
          this.focusNextWeek(e.target);
          break;
        case keys$1.ENTER:
        case keys$1.SPACE:
          cancelEvent(e);
          if (this.props.onDayClick) {
            this.handleDayClick(e, day, modifiers);
          }
          break;
      }
      if (this.props.onDayKeyDown) {
        this.props.onDayKeyDown(e, day, modifiers);
      }
    }
  }, {
    key: "handleDayClick",
    value: function handleDayClick(e, day, modifiers) {
      e.persist();
      if (modifiers.outside) {
        this.handleOutsideDayClick(day);
      }
      this.props.onDayClick(e, day, modifiers);
    }
  }, {
    key: "handleOutsideDayClick",
    value: function handleOutsideDayClick(day) {
      var currentMonth = this.state.currentMonth;
      var numberOfMonths = this.props.numberOfMonths;
      var diffInMonths = getMonthsDiff(currentMonth, day);
      if (diffInMonths > 0 && diffInMonths >= numberOfMonths) {
        this.showNextMonth();
      } else if (diffInMonths < 0) {
        this.showPreviousMonth();
      }
    }
  }, {
    key: "renderNavbar",
    value: function renderNavbar() {
      var _this$props2 = this.props,
        locale = _this$props2.locale,
        localeUtils = _this$props2.localeUtils,
        canChangeMonth = _this$props2.canChangeMonth,
        navbarElement = _this$props2.navbarElement,
        attributes = _objectWithoutProperties(_this$props2, _excluded$n);
      if (!canChangeMonth) return null;
      var props = {
        style: this.props.style('navbar'),
        nextMonth: this.getNextNavigableMonth(),
        previousMonth: this.getPreviousNavigableMonth(),
        showPreviousButton: this.allowPreviousMonth(),
        showNextButton: this.allowNextMonth(),
        onNextClick: this.showNextMonth,
        onPreviousClick: this.showPreviousMonth,
        dir: attributes.dir,
        locale: locale,
        localeUtils: localeUtils
      };
      return /*#__PURE__*/React__default.cloneElement(navbarElement, props);
    }
  }, {
    key: "renderDayInMonth",
    value: function renderDayInMonth(day, month) {
      var dayModifiers = [];
      if (isSameDay(day, new Date())) {
        dayModifiers.push('today');
      }
      if (day.getMonth() !== month.getMonth()) {
        dayModifiers.push('outside');
      }
      dayModifiers = [].concat(_toConsumableArray(dayModifiers), _toConsumableArray(getModifiersForDay(day, getModifiersFromProps(this.props))));
      var isOutside = day.getMonth() !== month.getMonth();
      var tabIndex = null;
      if (this.props.onDayClick && !isOutside) {
        tabIndex = -1;
        // Focus on the first day of the month
        if (day.getDate() === 1) {
          tabIndex = this.props.tabIndex;
        }
      }
      var key = "".concat(day.getFullYear()).concat(day.getMonth()).concat(day.getDate());
      return /*#__PURE__*/React__default.createElement(Day$1, {
        key: "".concat(isOutside ? 'outside-' : '').concat(key),
        dataDayInside: !isOutside,
        day: day,
        modifiers: dayModifiers,
        empty: isOutside && !this.props.enableOutsideDays && !this.props.fixedWeeks,
        tabIndex: tabIndex,
        ariaLabel: this.props.localeUtils.formatDay(day, this.props.locale),
        ariaDisabled: isOutside || dayModifiers.indexOf('disabled') > -1,
        ariaSelected: dayModifiers.indexOf('selected') > -1,
        onMouseEnter: this.props.onDayMouseEnter,
        onMouseLeave: this.props.onDayMouseLeave,
        onKeyDown: this.handleDayKeyDown,
        onTouchStart: this.props.onDayTouchStart,
        onTouchEnd: this.props.onDayTouchEnd,
        onFocus: this.props.onDayFocus,
        onClick: this.props.onDayClick ? this.handleDayClick : undefined,
        style: this.props.style('day')
      }, this.props.renderDay(day));
    }
  }, {
    key: "renderMonths",
    value: function renderMonths() {
      var months = [];
      var firstDayOfWeek = getFirstDayOfWeekFromProps(this.props);
      for (var i = 0; i < this.props.numberOfMonths; i += 1) {
        var month = addMonths(this.state.currentMonth, i);
        months.push( /*#__PURE__*/React__default.createElement(Month$1, {
          key: i,
          month: month,
          months: this.props.months,
          weekdaysShort: this.props.weekdaysShort,
          weekdaysLong: this.props.weekdaysLong,
          locale: this.props.locale,
          localeUtils: this.props.localeUtils,
          firstDayOfWeek: firstDayOfWeek,
          fixedWeeks: this.props.fixedWeeks,
          weekdayComponent: this.props.weekdayComponent,
          weekdayElement: this.props.weekdayElement,
          captionElement: this.props.captionElement,
          onCaptionClick: this.props.onCaptionClick,
          style: this.props.style('month')
        }, this.renderDayInMonth));
      }
      if (this.props.reverseMonths) {
        months.reverse();
      }
      return months;
    }
  }, {
    key: "render",
    value: function render() {
      var _this7 = this;
      // eslint-disable-next-line react/forbid-foreign-prop-types
      var customProps = getCustomProps(this.props, DayPicker.propTypes);
      return (
        /*#__PURE__*/
        // Please fix me
        // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
        React__default.createElement("div", _extends({}, customProps, this.props.style, {
          ref: function ref(el) {
            _this7.dayPicker = el;
          },
          role: "application",
          tabIndex: this.props.canChangeMonth && this.props.tabIndex,
          onKeyDown: this.handleKeyDown
        }), this.renderNavbar(), this.renderMonths())
      );
    }
  }]);
  return DayPicker;
}(Component);
_defineProperty(DayPicker, "propTypes", {
  initialMonth: PropTypes.instanceOf(Date),
  numberOfMonths: PropTypes.number,
  selectedDays: PropTypes.func,
  disabledDays: PropTypes.func,
  modifiers: PropTypes.object,
  locale: PropTypes.string,
  localeUtils: DayPickerPropTypes.localeUtils,
  enableOutsideDays: PropTypes.bool,
  fixedWeeks: PropTypes.bool,
  canChangeMonth: PropTypes.bool,
  reverseMonths: PropTypes.bool,
  pagedNavigation: PropTypes.bool,
  fromMonth: PropTypes.instanceOf(Date),
  toMonth: PropTypes.instanceOf(Date),
  firstDayOfWeek: PropTypes.oneOf([0, 1, 2, 3, 4, 5, 6]),
  months: PropTypes.arrayOf(PropTypes.string),
  weekdaysLong: PropTypes.arrayOf(PropTypes.string),
  weekdaysShort: PropTypes.arrayOf(PropTypes.string),
  onKeyDown: PropTypes.func,
  onDayClick: PropTypes.func,
  onDayKeyDown: PropTypes.func,
  onDayMouseEnter: PropTypes.func,
  onDayMouseLeave: PropTypes.func,
  onDayTouchStart: PropTypes.func,
  onDayTouchEnd: PropTypes.func,
  onDayFocus: PropTypes.func,
  onMonthChange: PropTypes.func,
  onCaptionClick: PropTypes.func,
  renderDay: PropTypes.func,
  weekdayElement: PropTypes.element,
  navbarElement: PropTypes.element,
  captionElement: PropTypes.element,
  dir: PropTypes.string,
  style: PropTypes.func.isRequired,
  tabIndex: PropTypes.number
});
_defineProperty(DayPicker, "defaultProps", {
  tabIndex: 0,
  initialMonth: new Date(),
  numberOfMonths: 1,
  locale: 'en',
  localeUtils: LocaleUtils$1,
  enableOutsideDays: false,
  fixedWeeks: false,
  canChangeMonth: true,
  reverseMonths: false,
  pagedNavigation: false,
  renderDay: function renderDay(day) {
    return day.getDate();
  },
  weekdayElement: /*#__PURE__*/React__default.createElement(Weekday$1, null),
  navbarElement: /*#__PURE__*/React__default.createElement(Navbar$1, null),
  captionElement: function captionElement(captionProps) {
    return /*#__PURE__*/React__default.createElement(Caption$2, captionProps);
  }
});
var styled$i = createDefaultStyle({
  position: 'relative',
  userSelect: 'none',
  textAlign: 'center',
  '&interactionDisabled': {
    day: {
      cursor: 'default'
    }
  }
}, function (_ref) {
  var _ref2;
  var locale = _ref.locale,
    onDayClick = _ref.onDayClick;
  return _ref2 = {}, _defineProperty(_ref2, "&".concat(locale), !!locale), _defineProperty(_ref2, '&interactionDisabled', !onDayClick), _ref2;
});
var DayPicker$1 = styled$i(DayPicker);var _excluded$m = ["value", "hideNavigation", "culture", "datePickerRef", "modifiers", "style", "yearsPast", "yearsFuture", "className", "classNames", "onChange", "onRequestHideWidget"];
function ownKeys$k(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$k(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$k(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$k(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function DatePicker(_ref, ref) {
  var value = _ref.value,
    hideNavigation = _ref.hideNavigation,
    _ref$culture = _ref.culture,
    culture = _ref$culture === void 0 ? defaultCulture : _ref$culture,
    datePickerRef = _ref.datePickerRef,
    modifiers = _ref.modifiers,
    style = _ref.style,
    yearsPast = _ref.yearsPast,
    yearsFuture = _ref.yearsFuture,
    className = _ref.className,
    classNames = _ref.classNames,
    onChange = _ref.onChange,
    onRequestHideWidget = _ref.onRequestHideWidget,
    rest = _objectWithoutProperties(_ref, _excluded$m);
  var styles = useStyles(defaultStyles$6, {
    style: style,
    className: className,
    classNames: classNames
  });
  var _useState = useState(function () {
      return getInitialMonth(value);
    }),
    _useState2 = _slicedToArray(_useState, 2),
    initialMonth = _useState2[0],
    setInitialMonth = _useState2[1];
  useEffect(function () {
    setInitialMonth(getInitialMonth(value));
  }, [value]);
  return /*#__PURE__*/React__default.createElement(DayPicker$1, _extends({}, rest, {
    initialMonth: initialMonth,
    modifiers: useMemo(function () {
      return _objectSpread$k(_objectSpread$k({}, modifiers), {}, {
        selected: function selected(date) {
          return value && isSameDay$1(date, new Date(value));
        },
        isSunday: function isSunday(date) {
          return date.getDay() === DAYS.SUNDAY;
        },
        isMonday: function isMonday(date) {
          return date.getDay() === DAYS.MONDAY;
        },
        isTuesday: function isTuesday(date) {
          return date.getDay() === DAYS.TUESDAY;
        },
        isWednesday: function isWednesday(date) {
          return date.getDay() === DAYS.WEDNESDAY;
        },
        isThursday: function isThursday(date) {
          return date.getDay() === DAYS.THURSDAY;
        },
        isFriday: function isFriday(date) {
          return date.getDay() === DAYS.FRIDAY;
        },
        isSaturday: function isSaturday(date) {
          return date.getDay() === DAYS.SATURDAY;
        }
      });
    }, [modifiers, value]),
    onChange: onChange,
    onDayClick: function onDayClick(event, day) {
      var nextValue = format(day, 'yyyy-MM-dd');
      if (nextValue !== value) {
        onChange(nextValue);
      }
      if (onRequestHideWidget) {
        onRequestHideWidget();
      }
    },
    value: value,
    style: styles,
    ref: mergeRefs([ref, datePickerRef]),
    captionElement: function captionElement(captionProps) {
      return !hideNavigation && /*#__PURE__*/React__default.createElement(YearMonthNavigation$1, _extends({}, captionProps, {
        yearsPast: yearsPast,
        yearsFuture: yearsFuture,
        locale: culture,
        style: styles('navigation'),
        onChange: function onChange(_ref2) {
          var month = _ref2.month,
            year = _ref2.year;
          var newDate = new Date(year, month, 1);
          setInitialMonth(newDate);
        }
      }));
    }
  }));
}
var getInitialMonth = function getInitialMonth(value) {
  var current = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Date();
  if (value == null) {
    return new Date();
  }
  if (isSameMonth(current, new Date(value))) {
    return current;
  }
  var _value$split = value.split('-'),
    _value$split2 = _slicedToArray(_value$split, 3),
    year = _value$split2[0],
    month = _value$split2[1],
    day = _value$split2[2];
  return new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
};
var DAYS = {
  SUNDAY: 0,
  MONDAY: 1,
  TUESDAY: 2,
  WEDNESDAY: 3,
  THURSDAY: 4,
  FRIDAY: 5,
  SATURDAY: 6
};
var defaultStyles$6 = {
  day: {
    '&selected': {
      backgroundColor: '#29b6f6'
    }
  },
  month: {
    width: '100%'
  }
};
var DatePicker$1 = /*#__PURE__*/forwardRef(DatePicker);var DateCombo = stickWidgetToInput$1(DatePicker$1, omitProps('isExpanded')(DateInput$1), {
  stickProps: function stickProps(_ref) {
    var autoFlipVertically = _ref.autoFlipVertically;
    return {
      autoFlipVertically: autoFlipVertically
    };
  }
});function formatUri(uri) {
  if (uri == null || uri.trim() === '') {
    return {
      valid: true,
      formattedUri: null
    };
  }
  if (isURL(uri, {
    require_protocol: true,
    require_tld: false,
    require_valid_protocol: false
  })) {
    return {
      valid: true,
      formattedUri: uri
    };
  }
  if (isURL("http://".concat(uri))) {
    // prepend http:// as the default protocol
    return {
      valid: true,
      formattedUri: "http://".concat(uri)
    };
  }
  if (isURL(uri, {
    protocols: ['file'],
    require_host: false,
    require_valid_protocol: true
  })) {
    return {
      valid: true,
      formattedUri: uri
    };
  }
  return {
    valid: false,
    formattedUri: null
  };
}var _excluded$l = ["onChange", "onBlur", "onFocus", "value"];
function isEncoded(uri) {
  return uri !== decodeURIComponent(uri);
}
function encodeURIWhenRequired(uri) {
  uri = uri || '';
  if (isEncoded(uri)) {
    return uri.trim();
  }
  return encodeURI(uri.trim());
}
var UrlInput = function UrlInput(_ref, ref) {
  var _onChange = _ref.onChange,
    _onBlur = _ref.onBlur,
    _onFocus = _ref.onFocus,
    value = _ref.value,
    rest = _objectWithoutProperties(_ref, _excluded$l);
  var _formatUri = formatUri(encodeURIWhenRequired(value)),
    formattedUri = _formatUri.formattedUri;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    editing = _useState2[0],
    setEditing = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    temporaryValue = _useState4[0],
    setTemporaryValue = _useState4[1];
  useEffect(function () {
    if (!editing) {
      setTemporaryValue(null);
    }
  }, [editing, value]);
  useEffect(function () {
    if (value == null) {
      setTemporaryValue(null);
    }
  }, [value]);
  return /*#__PURE__*/React__default.createElement(Input$1, _extends({}, rest, {
    type: "url",
    inputRef: ref,
    onFocus: function onFocus(event) {
      setEditing(true);
      if (_onFocus) {
        _onFocus(event);
      }
    },
    onChange: function onChange(newValue, event) {
      setTemporaryValue(newValue);
      var _formatUri2 = formatUri(encodeURIWhenRequired(newValue)),
        valid = _formatUri2.valid,
        formattedUri = _formatUri2.formattedUri;
      if (value === formattedUri) {
        return;
      }
      if (!valid) {
        return;
      }
      if (_onChange) {
        _onChange(formattedUri, event);
      }
    },
    onBlur: function onBlur(event) {
      if (value != null && temporaryValue != null) {
        var _formatUri3 = formatUri(encodeURIWhenRequired(temporaryValue)),
          _formattedUri = _formatUri3.formattedUri;
        if (_onChange && _formattedUri === null) {
          _onChange(_formattedUri, event);
        }
      }
      setEditing(false);
      if (_onBlur) {
        _onBlur(event);
      }
    },
    value: temporaryValue || formattedUri
  }));
};
var UrlInput$1 = /*#__PURE__*/forwardRef(UrlInput);var Url = deprecateExport(UrlInput$1, 'The "Url" export in @signavio/ui/core has been renamed to "UrlInput". It will be removed in a future major update.');var _excluded$k = ["value", "onFocus", "onBlur", "onChange"];
function sanitize(value) {
  if (value == null || value.trim() === '') {
    return {
      valid: true,
      sanitizedValue: null
    };
  }
  if (!isEmail(value, {
    allow_display_name: true
  })) {
    return {
      valid: false,
      sanitizedValue: null
    };
  }
  return {
    valid: true,
    sanitizedValue: normalizeEmail(value, {
      gmail_convert_googlemaildotcom: false,
      gmail_remove_subaddress: false,
      gmail_remove_dots: false,
      outlookdotcom_remove_subaddress: false,
      yahoo_remove_subaddress: false,
      icloud_remove_subaddress: false
    })
  };
}
var EmailInput = function EmailInput(_ref, ref) {
  var _ref$value = _ref.value,
    value = _ref$value === void 0 ? null : _ref$value,
    _onFocus = _ref.onFocus,
    _onBlur = _ref.onBlur,
    _onChange = _ref.onChange,
    rest = _objectWithoutProperties(_ref, _excluded$k);
  var _sanitize = sanitize(value),
    sanitizedValue = _sanitize.sanitizedValue;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    editing = _useState2[0],
    setEditing = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    temporaryValue = _useState4[0],
    setTemporaryValue = _useState4[1];
  useEffect(function () {
    if (!editing) {
      setTemporaryValue(null);
    }
  }, [editing, value]);
  useEffect(function () {
    if (value == null) {
      setTemporaryValue(null);
    }
  }, [value]);
  return /*#__PURE__*/React__default.createElement(Input$1, _extends({}, rest, {
    inputRef: ref,
    value: temporaryValue || sanitizedValue,
    onChange: function onChange(newValue, event) {
      setTemporaryValue(newValue);
      var _sanitize2 = sanitize(newValue),
        valid = _sanitize2.valid,
        sanitizedValue = _sanitize2.sanitizedValue;
      if (value === sanitizedValue) {
        return;
      }
      if (!valid) {
        return;
      }
      if (_onChange) {
        _onChange(sanitizedValue, event);
      }
    },
    type: "email",
    onFocus: function onFocus(event) {
      setEditing(true);
      if (_onFocus) {
        _onFocus(event);
      }
    },
    onBlur: function onBlur(event) {
      if (value != null && temporaryValue != null) {
        var _sanitize3 = sanitize(temporaryValue),
          _sanitizedValue = _sanitize3.sanitizedValue;
        if (_onChange && _sanitizedValue === null) {
          _onChange(_sanitizedValue, event);
        }
      }
      setEditing(false);
      if (_onBlur) {
        _onBlur(event);
      }
    }
  }));
};
var EmailInput$1 = /*#__PURE__*/forwardRef(EmailInput);var Email = deprecateExport(EmailInput$1, 'The "Email" export in @signavio/ui/core has been renamed to "EmailInput". It will be removed in a future major update.');var _excluded$j = ["children", "disabled", "style", "frontChildren", "rearChildren", "block", "small", "className", "classNames", "onClick"];
function Button(_ref) {
  var children = _ref.children,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    style = _ref.style,
    frontChildren = _ref.frontChildren,
    rearChildren = _ref.rearChildren,
    _ref$block = _ref.block,
    block = _ref$block === void 0 ? false : _ref$block,
    _ref$small = _ref.small,
    small = _ref$small === void 0 ? false : _ref$small,
    className = _ref.className,
    classNames = _ref.classNames,
    onClick = _ref.onClick,
    rest = _objectWithoutProperties(_ref, _excluded$j);
  var styles = useStyles(defaultStyles$5, {
    style: style,
    className: className,
    classNames: classNames
  }, {
    '&small': small,
    '&disabled': disabled,
    '&block': block,
    '&hasContent': !!children
  });
  return /*#__PURE__*/React__default.createElement("button", _extends({}, rest, styles, {
    disabled: disabled,
    onClick: onClick
  }), frontChildren && /*#__PURE__*/React__default.createElement("span", styles('frontChildren'), frontChildren), children, rearChildren && /*#__PURE__*/React__default.createElement("span", styles('rearChildren'), rearChildren));
}
var defaultStyles$5 = {
  display: 'inline-flex',
  alignItems: 'center',
  cursor: 'pointer',
  outline: 0,
  fontSize: button1.fontSize,
  lineHeight: button1.lineHeight,
  fontFamily: 'var(--glucose-main-font-family)',
  fontWeight: 'var(--glucose-bold-font-weight)',
  letterSpacing: 'var(--glucose-letter-spacing-button1)',
  borderRadius: 2,
  borderStyle: 'solid',
  borderWidth: 1,
  height: button$1.normal,
  margin: 0,
  paddingTop: 0,
  paddingBottom: 0,
  paddingLeft: small$1,
  paddingRight: small$1,
  background: 'none',
  '&hasContent': {
    frontChildren: {
      marginRight: xxsmall
    },
    rearChildren: {
      marginLeft: xxsmall
    }
  },
  '&small': {
    height: button$1.small,
    fontSize: button2.fontSize,
    letterSpacing: 'var(--glucose-letter-spacing-button2)',
    paddingLeft: xxsmall,
    paddingRight: xxsmall
  },
  '&disabled': {
    // disabled buttons do not fire onmouseleave.
    // this causes problems if you, for instance, wrap
    // a disabled button in a Popover component. Even
    // though this component wraps the button in a div
    // the onmouseleave event never happens. By disabling
    // all pointer events on the button we can circumvent
    // this behavior. So this looks weird but does the trick.
    pointerEvents: 'none'
  },
  '&block': {
    display: 'flex',
    width: '100%',
    justifyContent: 'center'
  }
};var glyphCharMap = {
  "bullet-edge": 57344,
  "bullet-square": 57345,
  "breadcrumb-separator": 57351,
  "value-null": 57352,
  "value-any": 57353,
  "diff-added": 57354,
  "diff-removed": 57355,
  "point-left": 57356,
  "point-right": 57357,
  "bullet-box": 57358,
  "breadcrumb-return": 57359,
  "point-up": 57360,
  "point-down": 57361,
  "link": 57376,
  "job-profile": 57379,
  "release-note": 57381,
  "news": 57382,
  "blog-post": 57385,
  "idea": 57386,
  "whitepaper": 57387,
  "process-example": 57396,
  "quick-info": 57397,
  "email": 57440,
  "signavio-platform": 57445,
  "youtube": 57450,
  "feedback": 57456,
  "salesforce": 57457,
  "gdrive": 57459,
  "boxcom": 57460,
  "zapier": 57462,
  "language-en": 57632,
  "language-de": 57633,
  "language-fr": 57634,
  "language-es": 57635,
  "language": 57663,
  "home": 57664,
  "notification-center": 57665,
  "app-gallery": 57666,
  "user-unknown": 58048,
  "user": 58049,
  "user-group": 58050,
  "user-substitute": 58051,
  "admin": 58052,
  "admin-group": 58053,
  "user-perspective": 58054,
  "process-manager": 58112,
  "process-intelligence": 58116,
  "training": 58118,
  "collaboration-hub": 58120,
  "quickmodel": 58121,
  "simulation": 58130,
  "approval-workflow": 58132,
  "access-rights": 58135,
  "explorer": 58143,
  "comparator": 58144,
  "dictionary": 58145,
  "manual": 58146,
  "plugin-feature": 58147,
  "testlab": 58151,
  "artificial-intelligence": 58152,
  "file": 58368,
  "file-unknown": 58369,
  "file-attachment": 58370,
  "folder": 58371,
  "unique-id": 58373,
  "picture": 58374,
  "microsoft-word": 58375,
  "microsoft-excel": 58376,
  "microsoft-powerpoint": 58377,
  "adobe-pdf": 58378,
  "primary-key": 58379,
  "dictionary-item": 58380,
  "attribute-item": 58382,
  "boolean": 58383,
  "number": 58384,
  "string": 58385,
  "string-multiline": 58386,
  "time": 58387,
  "date": 58388,
  "datetime": 58389,
  "duration": 58390,
  "ratio": 58391,
  "range-number": 58392,
  "enumeration": 58394,
  "hierarchy": 58395,
  "currency": 58396,
  "case": 58397,
  "task": 58398,
  "workflow": 58399,
  "report": 58400,
  "log": 58401,
  "task-complex": 58402,
  "caldav-event": 58403,
  "string-email": 58404,
  "email-item": 58405,
  "filter": 58407,
  "software-license": 58408,
  "file-connector": 58409,
  "diagram-bpmn": 58410,
  "diagram-dmn": 58411,
  "diagram-archimate": 58412,
  "diagram-epc": 58413,
  "process-map": 58414,
  "organization-chart": 58415,
  "graph-unspecified": 58416,
  "file-archive": 58417,
  "string-uri": 58418,
  "data-binding": 58419,
  "customer-journey-map": 58420,
  "graph-process-discovery": 58421,
  "key-measure": 58422,
  "graph-heatmap": 58423,
  "graph-bars-h-desc": 58424,
  "graph-bars-v-desc": 58425,
  "task-script": 58426,
  "file-script": 58427,
  "google-doc": 58428,
  "google-spreadsheet": 58429,
  "google-slide": 58430,
  "organization": 58431,
  "milestone": 58432,
  "frequency": 58433,
  "manpower": 58434,
  "cost": 58435,
  "case-adhoc": 58436,
  "task-public": 58437,
  "table": 58438,
  "spreadsheet": 58439,
  "graph-histogram": 58440,
  "graph-timeline": 58441,
  "chapter": 58442,
  "starred-item": 58443,
  "grouping": 58445,
  "case-variant": 58446,
  "dictionary-team": 58448,
  "dictionary-document": 58449,
  "dictionary-activity": 58450,
  "dictionary-event": 58451,
  "dictionary-system": 58452,
  "dictionary-goal": 58453,
  "dictionary-requirement": 58454,
  "dictionary-risk": 58455,
  "dictionary-control": 58456,
  "dictionary-category": 58457,
  "dictionary-entry": 58458,
  "recent": 58459,
  "spacing-tool": 58460,
  "formula": 58461,
  "text-style": 58462,
  "navigation-map": 58463,
  "graph-sankey": 58464,
  "graph-box-whisker": 58465,
  "graph-conformance": 58466,
  "expand": 58624,
  "collapse": 58625,
  "nav-prev": 58626,
  "nav-next": 58627,
  "menu-slide-out": 58628,
  "menu-slide-in": 58629,
  "menu-overlay-open": 58631,
  "menu-overlay-close": 58632,
  "dropdown-open": 58633,
  "dropdown-close": 58634,
  "refresh": 58639,
  "search": 58640,
  "reset": 58641,
  "remove": 58642,
  "item-create": 58644,
  "save": 58645,
  "edit": 58646,
  "comment": 58647,
  "item-rename": 58649,
  "file-move": 58650,
  "undo": 58655,
  "redo": 58656,
  "print": 58657,
  "overlay-show": 58658,
  "overlay-risk-control": 58659,
  "canvas-expand-left": 58660,
  "canvas-shrink-left": 58661,
  "canvas-expand-right": 58662,
  "canvas-shrink-right": 58663,
  "canvas-expand-top": 58664,
  "canvas-shrink-top": 58665,
  "canvas-expand-bottom": 58666,
  "canvas-shrink-bottom": 58667,
  "trace-link": 58668,
  "select-none": 58669,
  "import": 58670,
  "export": 58671,
  "merge": 58672,
  "share": 58673,
  "configure": 58674,
  "panel-pin": 58675,
  "account-logout": 58677,
  "clipboard-copy": 58678,
  "clipboard-cut": 58679,
  "clipboard-paste": 58680,
  "file-download": 58681,
  "file-upload": 58682,
  "terminate": 58683,
  "atomize": 58684,
  "differentiate": 58685,
  "decision-run": 58686,
  "remap": 58687,
  "nav-list": 58688,
  "organization-switch": 58690,
  "execute": 58691,
  "send": 58692,
  "show-more": 58695,
  "drag-sort": 58696,
  "skip-next": 58697,
  "skip-prev": 58698,
  "zoom": 58699,
  "user-reassign": 58700,
  "highlight": 58701,
  "zoom-out": 58702,
  "fullscreen-view": 58703,
  "fullscreen-escape": 58704,
  "panel-left-expand": 58705,
  "panel-left-collapse": 58706,
  "panel-right-expand": 58707,
  "panel-right-collapse": 58708,
  "panel-bottom-expand": 58709,
  "panel-bottom-collapse": 58710,
  "align-left": 58711,
  "align-right": 58712,
  "align-top": 58713,
  "align-bottom": 58714,
  "align-center-h": 58715,
  "align-center-v": 58716,
  "distribute-h": 58717,
  "distribute-v": 58718,
  "resize-equal": 58719,
  "zoom-fit": 58720,
  "zoom-reset": 58721,
  "apply-style": 58722,
  "clear-style": 58723,
  "check-conventions": 58724,
  "toolbar-group": 58725,
  "arrange-front": 58726,
  "arrange-back": 58727,
  "arrange-forward": 58728,
  "arrange-backward": 58729,
  "convert-shape": 58730,
  "outsource": 58731,
  "rotate": 58732,
  "tree-expand": 58733,
  "tree-collapse": 58734,
  "help": 58735,
  "add-lane": 58736,
  "add": 58737,
  "connect": 58738,
  "shift-row-up": 58739,
  "shift-row-down": 58740,
  "shift-column-left": 58741,
  "shift-column-right": 58742,
  "minimap": 58743,
  "dot-grid": 58744,
  "app-prev": 58745,
  "add-filter": 58746,
  "advanced-search": 58747,
  "accuracy-increase": 58748,
  "accuracy-decrease": 58749,
  "add-insight": 58750,
  "info": 59136,
  "success": 59137,
  "warning": 59138,
  "warning-emphasized": 59139,
  "error": 59140,
  "visible-confirmed": 59141,
  "visible": 59142,
  "invisible": 59143,
  "visible-conditionally": 59144,
  "starred": 59145,
  "unstarred": 59146,
  "visible-pending": 59147,
  "published": 59148,
  "concealed": 59149,
  "comment-discussing": 59150,
  "comment-agreed": 59151,
  "comment-declined": 59152,
  "risk": 59153,
  "control": 59154,
  "published-changed": 59155,
  "disabled": 59156,
  "maintenance": 59157,
  "folder-closed": 59159,
  "folder-open": 59160,
  "checkbox-false": 59161,
  "checkbox-true": 59162,
  "task-done": 59163,
  "task-undone": 59164,
  "case-closed": 59165,
  "case-open": 59166,
  "access-denied": 59167,
  "access-granted": 59168,
  "priority-unassigned": 59169,
  "priority-low": 59170,
  "priority-normal": 59171,
  "priority-high": 59172,
  "priority-escalated": 59173,
  "policy-read": 59174,
  "policy-write": 59175,
  "policy-execute": 59176,
  "policy-remove": 59177,
  "checkbox-indeterminate": 59178,
  "radio-button-false": 59179,
  "radio-button-true": 59180,
  "select-multiple": 59181,
  "order-ascending": 59182,
  "order-descending": 59183,
  "process-level": 59184,
  "view-list": 59190,
  "view-tiles": 59191,
  "font-size": 59192,
  "font-weight": 59193,
  "font-slant": 59194,
  "color-text": 59195,
  "color-fill": 59196,
  "color-stroke": 59197,
  "time-now": 59198,
  "variant": 59199,
  "relocated": 59200,
  "emotion-positive": 59201,
  "emotion-negative": 59202,
  "pass-steps": 59203,
  "pass-single": 59204,
  "pass-multi": 59205,
  "pass-reiterate": 59206,
  "pass-discontinue": 59207,
  "corner-rounded": 59208,
  "corner-straight": 59209,
  "density-compact": 59210,
  "density-default": 59211,
  "density-comfortable": 59212,
  "view-grid": 59213,
  "view-grouped": 59214,
  "notification-enabled": 59215,
  "notification-disabled": 59216,
  "landscape": 59217,
  "portrait": 59218,
  "landscape-straight": 59219,
  "landscape-clockwise": 59220,
  "landscape-counter-clockwise": 59221,
  "portrait-straight": 59222,
  "portrait-clockwise": 59223,
  "portrait-counter-clockwise": 59224,
  "flow-right": 59225,
  "flow-bottom": 59226,
  "emotion-neutral": 59227,
  "emotion-very-positive": 59228,
  "emotion-very-negative": 59229,
  "throughput-funnel": 59648,
  "process-insights": 59649,
  "metric": 59650,
  "drill-down": 59651,
  "drill-up": 59652,
  "sort": 59653,
  "trex": 60355,
  "wallet": 60358,
  "person": 60359,
  "cogwheel": 60360,
  "flash": 60361,
  "timer": 60362,
  "dashboard": 60363,
  "page": 60364,
  "exclamation-mark": 60365,
  "flag": 60366,
  "computer": 60367,
  "mail": 60368,
  "clipboard": 60369,
  "checked-tick": 60370,
  "checked-cross": 60371,
  "unchecked": 60372,
  "text": 60373,
  "balance": 60374,
  "rocket": 60375,
  "dollar": 60376,
  "bpmn-type-user": 61440,
  "bpmn-type-send": 61441,
  "bpmn-type-receive": 61442,
  "bpmn-type-manual": 61443,
  "bpmn-type-rule": 61444,
  "bpmn-type-service": 61445,
  "bpmn-type-script": 61446,
  "event-start": 61696,
  "event-end": 61697,
  "event-inter": 61698,
  "event-inter-catch-timer": 61699,
  "event-inter-throw-link": 61700,
  "gateway-xor": 61701,
  "gateway-parallel": 61702,
  "subprocess": 61703,
  "activity": 61704
};var _excluded$i = ["children", "style", "className", "classNames", "role"];
function Glyph(_ref) {
  var children = _ref.children,
    style = _ref.style,
    className = _ref.className,
    classNames = _ref.classNames,
    _ref$role = _ref.role,
    role = _ref$role === void 0 ? 'img' : _ref$role,
    rest = _objectWithoutProperties(_ref, _excluded$i);
  var defaultStyles = {
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontVariant: 'normal',
    textTransform: 'none',
    userSelect: 'none',
    // more beautiful icon rendering
    WebkitFontSmoothing: 'antialiased',
    MozOsxFontSmoothing: 'grayscale',
    fontFamily: 'var(--glucose-icon-font-family)'
  };
  var styles = useStyles(defaultStyles, {
    style: style,
    className: className,
    classNames: classNames
  });
  return /*#__PURE__*/React__default.createElement("i", _extends({
    "data-testid": "glyph-icon",
    "data-icon-name": children
  }, styles, {
    "aria-hidden": "true"
  }, rest, {
    role: role
  }), findIconChar(children));
}
var findIconChar = function findIconChar(name) {
  var charCode = glyphCharMap[name];
  if (!charCode) {
    warn$1("Unknown icon \"".concat(name, "\""));
    // replacement character used to replace an unknown or unrepresentable character
    return "\uFFFD";
  }
  return String.fromCharCode(charCode);
};var _excluded$h = ["icon", "style", "indicator", "small", "large"];
var CoreIconButton = function CoreIconButton(_ref) {
  var icon = _ref.icon,
    style = _ref.style,
    indicator = _ref.indicator,
    small = _ref.small,
    large = _ref.large,
    rest = _objectWithoutProperties(_ref, _excluded$h);
  invariant(!(small && large), 'An IconButton cannot be "small" and "large" at the same time. Pick one!');
  return /*#__PURE__*/React__default.createElement("button", _extends({}, rest, style, {
    type: "button",
    alt: icon
  }), _isString(icon) ? /*#__PURE__*/React__default.createElement(Glyph, null, icon) : icon, indicator && /*#__PURE__*/React__default.createElement("div", style('indicator'), indicator));
};
var styled$h = createDefaultStyle({
  border: 0,
  width: button$1.normal,
  height: button$1.normal,
  borderRadius: 2,
  borderWidth: 1,
  padding: 0,
  fontSize: size$1.normal,
  cursor: 'pointer',
  position: 'relative',
  indicator: {
    position: 'absolute',
    top: -xxxsmall,
    right: -xxxsmall
  },
  '&disabled': {
    cursor: 'not-allowed',
    // disabled buttons do not fire onmouseleave.
    // this causes problems if you, for instance, wrap
    // a disabled button in a Popover component. Even
    // though this component wraps the button in a div
    // the onmouseleave event never happens. By disabling
    // all pointer events on the button we can circumvent
    // this behavior. So this looks weird but does the trick.
    pointerEvents: 'none'
  },
  '&small': {
    width: button$1.small,
    height: button$1.small,
    indicator: {
      top: 0,
      right: -xxxsmall,
      transform: 'translate(0, -50%)'
    }
  },
  '&large': {
    fontSize: size$1.xxlarge
  }
}, function (_ref2) {
  var small = _ref2.small,
    disabled = _ref2.disabled,
    large = _ref2.large;
  return {
    '&small': small,
    '&large': large,
    '&disabled': disabled
  };
});
var IconButton = styled$h(CoreIconButton);var _excluded$g = ["style", "className", "classNames", "color", "weight"];
var DEFAULT_STROKE_WIDTH = 2;
var MINIMUM_WEIGHT = 0.5;
var MAXIMUM_WEIGHT = 2;
function createSvgGlyph(SvgComponent) {
  return function (_ref) {
    var style = _ref.style,
      className = _ref.className,
      classNames = _ref.classNames,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'rgba(0, 0, 0, 0.9)' : _ref$color,
      _ref$weight = _ref.weight,
      weight = _ref$weight === void 0 ? 1 : _ref$weight,
      rest = _objectWithoutProperties(_ref, _excluded$g);
    var styles = useStyles(defaultStyles$4, {
      style: style,
      className: className,
      classNames: classNames
    });
    invariant(MINIMUM_WEIGHT <= weight && weight <= MAXIMUM_WEIGHT, "SvgGlyph's \"weight\" prop must be a number between ".concat(MINIMUM_WEIGHT, " and ").concat(MAXIMUM_WEIGHT, " but was: ").concat(weight));
    return /*#__PURE__*/React__default.createElement(SvgComponent, _extends({}, inline(styles, {
      color: color
    }), {
      "aria-hidden": "true",
      strokeWidth: DEFAULT_STROKE_WIDTH * weight
    }, rest));
  };
}
var defaultStyles$4 = {
  verticalAlign: 'middle'
};function SvgHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "currentColor"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M6 10v10h4v-6h4v6h4V10M3.5 12.5L12 4l8.5 8.5"
  }));
}
SvgHome.description = 'Entry page of an application and generic point of return for a user. Can also be a symbol for the current physical location of a user.\n#svg #localization #navigation #entry-point\n0xe140';var HomeGlyph = createSvgGlyph(SvgHome);
HomeGlyph.description = SvgHome.description;function createHourFragment(_ref) {
  var value = _ref.value,
    _onChange = _ref.onChange;
  return /*#__PURE__*/React__default.createElement(FragmentedInput$1, {
    key: "HOUR",
    placeholder: "--",
    length: 2,
    value: to2DigitString$1(value),
    onChange: function onChange(val) {
      if (!val) {
        return;
      }
      var number = parseNumber(val);
      if (number == null || !isNumber(number)) {
        return;
      }
      _onChange({
        hour: number
      });
    },
    onKeyDown: function onKeyDown(event) {
      if (event.key === 'ArrowUp') {
        _onChange({
          hour: value != null && value + 1 || 1
        });
        event.preventDefault();
      }
      if (event.key === 'ArrowDown') {
        _onChange({
          hour: value != null && value - 1 || null
        });
        event.preventDefault();
      }
      if (event.key === 'Delete' || event.key === 'Backspace') {
        _onChange({
          hour: null
        });
        event.preventDefault();
      }
    }
  });
}function valueToString(number) {
  if (isNaN(number) || number == null) {
    return null;
  }
  return number.toString();
}
function createDayFragment(_ref) {
  var value = _ref.value,
    _onChange = _ref.onChange;
  return /*#__PURE__*/React__default.createElement(FragmentedInput$1, {
    key: "DAY",
    placeholder: "-",
    length: 1,
    value: valueToString(value),
    onChange: function onChange(val) {
      if (!val) {
        return;
      }
      var number = parseNumber(val);
      if (number == null || !isNumber(number)) {
        return;
      }
      _onChange({
        day: number
      });
    },
    onKeyDown: function onKeyDown(event) {
      if (event.key === 'ArrowUp') {
        _onChange({
          day: value != null && value + 1 || 1
        });
        event.preventDefault();
      }
      if (event.key === 'ArrowDown') {
        _onChange({
          day: value != null && value - 1 || null
        });
        event.preventDefault();
      }
      if (event.key === 'Delete' || event.key === 'Backspace') {
        _onChange({
          day: null
        });
        event.preventDefault();
      }
    }
  });
}function createWeekFragment(_ref) {
  var value = _ref.value,
    _onChange = _ref.onChange;
  return /*#__PURE__*/React__default.createElement(FragmentedInput$1, {
    key: "WEEK",
    placeholder: "--",
    length: 2,
    value: to2DigitString$1(value),
    onChange: function onChange(val) {
      if (!val) {
        return;
      }
      var number = parseNumber(val);
      if (number == null || !isNumber(number)) {
        return;
      }
      _onChange({
        week: number
      });
    },
    onKeyDown: function onKeyDown(event) {
      if (event.key === 'ArrowUp') {
        _onChange({
          week: value != null && value + 1 || 1
        });
        event.preventDefault();
      }
      if (event.key === 'ArrowDown') {
        _onChange({
          week: value != null && value - 1 || null
        });
        event.preventDefault();
      }
      if (event.key === 'Delete' || event.key === 'Backspace') {
        _onChange({
          week: null
        });
        event.preventDefault();
      }
    }
  });
}var createMinuteFragment = function createMinuteFragment(_ref) {
  var value = _ref.value,
    _onChange = _ref.onChange;
    _ref.initialValue;
  return /*#__PURE__*/React__default.createElement(FragmentedInput$1, {
    key: "MINUTE",
    placeholder: "--",
    length: 2,
    value: to2DigitString$1(value),
    onChange: function onChange(val, complete) {
      if (!val) {
        return;
      }
      var number = parseNumber(val);
      if (number == null || !isNumber(number)) {
        return;
      }
      _onChange({
        minute: number
      });
    },
    onKeyDown: function onKeyDown(event) {
      if (event.key === 'ArrowUp') {
        _onChange({
          minute: value != null && value + 1 || 1
        });
        event.preventDefault();
      }
      if (event.key === 'ArrowDown') {
        _onChange({
          minute: value != null && value - 1 || null
        });
        event.preventDefault();
      }
      if (event.key === 'Delete' || event.key === 'Backspace') {
        _onChange({
          minute: null
        });
        event.preventDefault();
      }
    }
  });
};
var createMinuteFragment$1 = createMinuteFragment;var minuteInSeconds = 60;
var hourInSeconds = minuteInSeconds * 60;
var dayInSeconds = hourInSeconds * 24;
var weekInSeconds = dayInSeconds * 7;
function stateToValue(durations) {
  var calculatedDuration = Object.keys(durations).reduce(function (acc, duration) {
    var durationAmount = durations[duration] || 0;
    if (duration === 'week') {
      return acc + durationAmount * weekInSeconds;
    }
    if (duration === 'day') {
      return acc + durationAmount * dayInSeconds;
    }
    if (duration === 'hour') {
      return acc + durationAmount * hourInSeconds;
    }
    if (duration === 'minute') {
      return acc + durationAmount * minuteInSeconds;
    }
    return acc;
  }, 0);
  if (calculatedDuration === 0) {
    return null;
  }
  return calculatedDuration;
}function ownKeys$j(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$j(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$j(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$j(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var defaultValue = {
  week: null,
  day: null,
  hour: null,
  minute: null
};
function valueToState(value) {
  if (value == null) {
    return defaultValue;
  }
  var durationInSeconds = value;
  var result = Object.keys(defaultValue).reduce(function (acc, item) {
    if (item === 'week') {
      var fit = Math.floor(durationInSeconds / weekInSeconds);
      durationInSeconds -= fit * weekInSeconds;
      return _objectSpread$j(_objectSpread$j({}, acc), {}, {
        week: fit || null
      });
    }
    if (item === 'day') {
      var _fit = Math.floor(durationInSeconds / dayInSeconds);
      durationInSeconds -= _fit * dayInSeconds;
      return _objectSpread$j(_objectSpread$j({}, acc), {}, {
        day: _fit || null
      });
    }
    if (item === 'hour') {
      var _fit2 = Math.floor(durationInSeconds / hourInSeconds);
      durationInSeconds -= _fit2 * hourInSeconds;
      return _objectSpread$j(_objectSpread$j({}, acc), {}, {
        hour: _fit2 || null
      });
    }
    if (item === 'minute') {
      var _fit3 = Math.floor(durationInSeconds / minuteInSeconds);
      durationInSeconds -= _fit3 * minuteInSeconds;
      return _objectSpread$j(_objectSpread$j({}, acc), {}, {
        minute: _fit3 || null
      });
    }
    return acc;
  }, Object.freeze({}));
  return result;
}var _excluded$f = ["templateStrings", "value", "onChange", "onFocus", "onBlur"];
function getFullTemplate(value, templateStrings) {
  var minutes = templateStrings.minutes,
    hours = templateStrings.hours,
    days = templateStrings.days,
    weeks = templateStrings.weeks;
  var weekText = (value === null || value === void 0 ? void 0 : value.week) === 1 ? weeks.singular : weeks.plural;
  var dayText = (value === null || value === void 0 ? void 0 : value.day) === 1 ? days.singular : days.plural;
  var hoursText = (value === null || value === void 0 ? void 0 : value.hour) === 1 ? hours.singular : hours.plural;
  var minutesText = (value === null || value === void 0 ? void 0 : value.minute) === 1 ? minutes.singular : minutes.plural;
  return "{{WEEK}} ".concat(weekText, ", {{DAY}} ").concat(dayText, ", {{HOUR}} ").concat(hoursText, ", {{MINUTE}} ").concat(minutesText);
}
function getComputedTemplateString(value, templateStrings) {
  var minutes = templateStrings.minutes,
    hours = templateStrings.hours,
    days = templateStrings.days,
    weeks = templateStrings.weeks;
  var minute = value.minute,
    hour = value.hour,
    day = value.day,
    week = value.week;
  var weekText = week === 1 ? weeks.singular : weeks.plural;
  var dayText = day === 1 ? days.singular : days.plural;
  var hoursText = hour === 1 ? hours.singular : hours.plural;
  var minutesText = minute === 1 ? minutes.singular : minutes.plural;
  var weeksTemplate = week ? "{{WEEK}} ".concat(weekText) : '';
  var daysTemplate = day ? "{{DAY}} ".concat(dayText) : '';
  var hoursTemplate = hour ? "{{HOUR}} ".concat(hoursText) : '';
  var minutesTemplate = minute ? "{{MINUTE}} ".concat(minutesText) : '';
  var activeTemplates = [weeksTemplate, daysTemplate, hoursTemplate, minutesTemplate].filter(Boolean);
  return activeTemplates.length > 1 ? activeTemplates.join(', ') : activeTemplates.join();
}
function useTemplateString(value, templateStrings) {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isEditing = _useState2[0],
    setIsEditing = _useState2[1];
  var _useState3 = useState(getFullTemplate(value, templateStrings)),
    _useState4 = _slicedToArray(_useState3, 2),
    templateString = _useState4[0],
    setTemplateString = _useState4[1];
  useEffect(function () {
    var isDurationEmpty = Object.values(value).every(function (duration) {
      return duration === null;
    });
    if (isEditing || isDurationEmpty) {
      var fullTemplate = getFullTemplate(value, templateStrings);
      return setTemplateString(fullTemplate);
    }
    var computeTemplateString = getComputedTemplateString(value, templateStrings);
    setTemplateString(computeTemplateString);
  }, [isEditing, templateStrings, value]);
  return [templateString, setIsEditing];
}
function DurationInput(_ref, ref) {
  var templateStrings = _ref.templateStrings,
    value = _ref.value,
    onChange = _ref.onChange,
    _onFocus = _ref.onFocus,
    _onBlur = _ref.onBlur,
    rest = _objectWithoutProperties(_ref, _excluded$f);
  var _useFragmentedValue = useFragmentedValue(value, onChange, {
      valueToState: valueToState,
      stateToValue: stateToValue
    }),
    _useFragmentedValue2 = _slicedToArray(_useFragmentedValue, 2),
    computedValue = _useFragmentedValue2[0],
    onComponentChange = _useFragmentedValue2[1];
  var _useTemplateString = useTemplateString(computedValue, templateStrings),
    _useTemplateString2 = _slicedToArray(_useTemplateString, 2),
    templateString = _useTemplateString2[0],
    setIsEditing = _useTemplateString2[1];
  var minute = computedValue.minute,
    hour = computedValue.hour,
    day = computedValue.day,
    week = computedValue.week;
  return /*#__PURE__*/React__default.createElement(FragmentedInput$1, _extends({}, rest, {
    ref: ref,
    template: templateString,
    onBlur: function onBlur(event) {
      setIsEditing(false);
      if (_onBlur) {
        _onBlur(event);
      }
    },
    onFocus: function onFocus(event) {
      setIsEditing(true);
      if (_onFocus) {
        _onFocus(event);
      }
    }
  }), createWeekFragment({
    value: week,
    onChange: onComponentChange
  }), createDayFragment({
    value: day,
    onChange: onComponentChange
  }), createHourFragment({
    value: hour,
    onChange: onComponentChange
  }), createMinuteFragment$1({
    value: minute,
    onChange: onComponentChange
  }));
}
var DurationInput$1 = /*#__PURE__*/forwardRef(DurationInput);var ellipsisStyles = {
  '&ellipsis': {
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden'
  }
};
var ellipsisModifiers = function ellipsisModifiers(_ref) {
  var ellipsis = _ref.ellipsis;
  return {
    '&ellipsis': ellipsis
  };
};
var resolveTitle = function resolveTitle(_ref2) {
  var children = _ref2.children,
    ellipsis = _ref2.ellipsis,
    title = _ref2.title;
  if (title != null) {
    return title;
  }
  if (!ellipsis) {
    return undefined;
  }
  if (typeof children !== 'string') {
    return undefined;
  }
  return children;
};var _excluded$e = ["children", "style", "title", "ellipsis", "className", "classNames"];
function ownKeys$i(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$i(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$i(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$i(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function Title1(_ref) {
  var children = _ref.children,
    style = _ref.style,
    title = _ref.title,
    _ref$ellipsis = _ref.ellipsis,
    ellipsis = _ref$ellipsis === void 0 ? false : _ref$ellipsis,
    className = _ref.className,
    classNames = _ref.classNames,
    rest = _objectWithoutProperties(_ref, _excluded$e);
  var styles = useStyles(defaultStyle$7, {
    style: style,
    className: className,
    classNames: classNames
  }, ellipsisModifiers({
    ellipsis: ellipsis
  }));
  return /*#__PURE__*/React__default.createElement("h1", _extends({}, rest, styles, {
    title: resolveTitle({
      children: children,
      title: title,
      ellipsis: ellipsis
    })
  }), children);
}
var defaultStyle$7 = _objectSpread$i(_objectSpread$i({
  fontSize: title1.fontSize,
  lineHeight: title1.lineHeight,
  fontFamily: 'var(--glucose-heading-font-family)',
  fontWeight: 'var(--glucose-black-font-weight)',
  letterSpacing: 'var(--glucose-letter-spacing-title1)'
}, ellipsisStyles), {}, {
  margin: 0
});var _excluded$d = ["children", "title", "style", "ellipsis", "className", "classNames"];
function ownKeys$h(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$h(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$h(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$h(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function Title2(_ref) {
  var children = _ref.children,
    title = _ref.title,
    style = _ref.style,
    _ref$ellipsis = _ref.ellipsis,
    ellipsis = _ref$ellipsis === void 0 ? false : _ref$ellipsis,
    className = _ref.className,
    classNames = _ref.classNames,
    rest = _objectWithoutProperties(_ref, _excluded$d);
  var styles = useStyles(defaultStyle$6, {
    style: style,
    className: className,
    classNames: classNames
  }, ellipsisModifiers({
    ellipsis: ellipsis
  }));
  return /*#__PURE__*/React__default.createElement("h2", _extends({}, rest, styles, {
    title: resolveTitle({
      children: children,
      title: title,
      ellipsis: ellipsis
    })
  }), children);
}
var defaultStyle$6 = _objectSpread$h(_objectSpread$h({
  fontSize: title2.fontSize,
  lineHeight: title2.lineHeight,
  fontFamily: 'var(--glucose-heading-font-family)',
  fontWeight: 'var(--glucose-black-font-weight)',
  letterSpacing: 'var(--glucose-letter-spacing-title2)'
}, ellipsisStyles), {}, {
  margin: 0
});var _excluded$c = ["children", "style", "title", "ellipsis", "className", "classNames"];
function ownKeys$g(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$g(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$g(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$g(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function Title3(_ref) {
  var children = _ref.children,
    style = _ref.style,
    title = _ref.title,
    _ref$ellipsis = _ref.ellipsis,
    ellipsis = _ref$ellipsis === void 0 ? false : _ref$ellipsis,
    className = _ref.className,
    classNames = _ref.classNames,
    rest = _objectWithoutProperties(_ref, _excluded$c);
  var styles = useStyles(defaultStyle$5, {
    style: style,
    className: className,
    classNames: classNames
  }, ellipsisModifiers({
    ellipsis: ellipsis
  }));
  return /*#__PURE__*/React__default.createElement("h3", _extends({}, rest, styles, {
    title: resolveTitle({
      children: children,
      title: title,
      ellipsis: ellipsis
    })
  }), children);
}
var defaultStyle$5 = _objectSpread$g(_objectSpread$g({
  fontSize: title3.fontSize,
  lineHeight: title3.lineHeight,
  fontFamily: 'var(--glucose-heading-font-family)',
  fontWeight: 'var(--glucose-black-font-weight)',
  letterSpacing: 'var(--glucose-letter-spacing-title3)'
}, ellipsisStyles), {}, {
  margin: 0
});var _excluded$b = ["children", "style", "title", "ellipsis", "className", "classNames"];
function ownKeys$f(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$f(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$f(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$f(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function Title4(_ref) {
  var children = _ref.children,
    style = _ref.style,
    title = _ref.title,
    _ref$ellipsis = _ref.ellipsis,
    ellipsis = _ref$ellipsis === void 0 ? false : _ref$ellipsis,
    className = _ref.className,
    classNames = _ref.classNames,
    rest = _objectWithoutProperties(_ref, _excluded$b);
  var styles = useStyles(defaultStyle$4, {
    style: style,
    className: className,
    classNames: classNames
  }, ellipsisModifiers({
    ellipsis: ellipsis
  }));
  return /*#__PURE__*/React__default.createElement("h4", _extends({}, rest, styles, {
    title: resolveTitle({
      children: children,
      title: title,
      ellipsis: ellipsis
    })
  }), children);
}
var defaultStyle$4 = _objectSpread$f(_objectSpread$f({
  fontSize: title4.fontSize,
  lineHeight: title4.lineHeight,
  fontFamily: 'var(--glucose-main-font-family)',
  fontWeight: 'var(--glucose-bold-font-weight)',
  letterSpacing: title4.letterSpacing
}, ellipsisStyles), {}, {
  margin: 0
});function ownKeys$e(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$e(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$e(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$e(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function Body(_ref) {
  var children = _ref.children,
    style = _ref.style,
    title = _ref.title,
    className = _ref.className,
    classNames = _ref.classNames,
    _ref$ellipsis = _ref.ellipsis,
    ellipsis = _ref$ellipsis === void 0 ? false : _ref$ellipsis;
  var styles = useStyles(defaultStyle$3, {
    style: style,
    className: className,
    classNames: classNames
  }, ellipsisModifiers({
    ellipsis: ellipsis
  }));
  return /*#__PURE__*/React__default.createElement("p", _extends({}, styles, {
    title: resolveTitle({
      children: children,
      title: title,
      ellipsis: ellipsis
    })
  }), children);
}
var defaultStyle$3 = _objectSpread$e(_objectSpread$e({
  fontSize: body.fontSize,
  lineHeight: body.lineHeight,
  fontFamily: 'var(--glucose-main-font-family)',
  fontWeight: body.fontWeight,
  letterSpacing: body.letterSpacing
}, ellipsisStyles), {}, {
  maxWidth: 720,
  marginTop: 0,
  marginBottom: 0
});function ownKeys$d(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$d(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$d(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$d(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function Article(_ref) {
  var children = _ref.children,
    style = _ref.style,
    title = _ref.title,
    className = _ref.className,
    classNames = _ref.classNames,
    _ref$ellipsis = _ref.ellipsis,
    ellipsis = _ref$ellipsis === void 0 ? false : _ref$ellipsis;
  var styles = useStyles(defaultStyle$2, {
    style: style,
    className: className,
    classNames: classNames
  }, ellipsisModifiers({
    ellipsis: ellipsis
  }));
  return /*#__PURE__*/React__default.createElement("p", _extends({}, styles, {
    title: resolveTitle({
      children: children,
      title: title,
      ellipsis: ellipsis
    })
  }), children);
}
var defaultStyle$2 = _objectSpread$d(_objectSpread$d({
  fontSize: article.fontSize,
  lineHeight: article.lineHeight,
  fontFamily: 'var(--glucose-main-font-family)',
  fontWeight: article.fontWeight,
  letterSpacing: article.letterSpacing
}, ellipsisStyles), {}, {
  maxWidth: 920,
  marginTop: 0,
  marginBottom: 0
});function ownKeys$c(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$c(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$c(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$c(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function Caption(_ref) {
  var children = _ref.children,
    style = _ref.style,
    title = _ref.title,
    className = _ref.className,
    classNames = _ref.classNames,
    _ref$ellipsis = _ref.ellipsis,
    ellipsis = _ref$ellipsis === void 0 ? false : _ref$ellipsis;
  var styles = useStyles(defaultStyle$1, {
    style: style,
    className: className,
    classNames: classNames
  }, ellipsisModifiers({
    ellipsis: ellipsis
  }));
  return /*#__PURE__*/React__default.createElement("p", _extends({}, styles, {
    title: resolveTitle({
      children: children,
      title: title,
      ellipsis: ellipsis
    })
  }), children);
}
var defaultStyle$1 = _objectSpread$c(_objectSpread$c({
  fontSize: caption.fontSize,
  lineHeight: caption.lineHeight,
  fontFamily: 'var(--glucose-main-font-family)',
  fontWeight: caption.fontWeight,
  letterSpacing: 'var(--glucose-letter-spacing-title3)'
}, ellipsisStyles), {}, {
  marginTop: 0,
  marginBottom: 0
});function ownKeys$b(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$b(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$b(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$b(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function StrongCaption(_ref) {
  var children = _ref.children,
    style = _ref.style,
    title = _ref.title,
    className = _ref.className,
    classNames = _ref.classNames,
    _ref$ellipsis = _ref.ellipsis,
    ellipsis = _ref$ellipsis === void 0 ? false : _ref$ellipsis;
  var styles = useStyles(defaultStyle, {
    style: style,
    className: className,
    classNames: classNames
  }, ellipsisModifiers({
    ellipsis: ellipsis
  }));
  return /*#__PURE__*/React__default.createElement("p", _extends({}, styles, {
    title: resolveTitle({
      children: children,
      title: title,
      ellipsis: ellipsis
    })
  }), children);
}
var defaultStyle = _objectSpread$b(_objectSpread$b({
  fontSize: strongCaption.fontSize,
  lineHeight: strongCaption.lineHeight,
  fontFamily: 'var(--glucose-main-font-family)',
  fontWeight: 'var(--glucose-bold-font-weight)',
  letterSpacing: 'var(--glucose-letter-spacing-title3)'
}, ellipsisStyles), {}, {
  marginTop: 0,
  marginBottom: 0
});function transition() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var kind = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'ease';
  var speed = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '0.3s';
  var properties = Array.isArray(props) ? props : [props];
  return {
    transition: properties.map(function (property) {
      return "".concat(property, " ").concat(speed, " ").concat(kind);
    }).join(', ')
  };
}function ownKeys$a(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$a(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$a(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$a(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var merge = function merge(substyle, inlineStyle) {
  return _objectSpread$a(_objectSpread$a({}, substyle), {}, {
    style: _objectSpread$a(_objectSpread$a({}, substyle.style), inlineStyle)
  });
};
var merge$1 = merge;var lgMin = 1200;
var mdMin = 992;
var mdMax = lgMin - 1;
var smMin = 768;
var smMax = mdMin - 1;
var xsMin = 0;
var xsMax = smMin - 1;
var getRanges = function getRanges(_ref) {
  var xs = _ref.xs,
    sm = _ref.sm,
    md = _ref.md,
    lg = _ref.lg,
    print = _ref.print;
  var ranges = [];
  if (xs) {
    ranges.push("(min-width: ".concat(xsMin, "px) and (max-width: ").concat(xsMax, "px)"));
  }
  if (sm) {
    ranges.push("(min-width: ".concat(smMin, "px) and (max-width: ").concat(smMax, "px)"));
  }
  if (md) {
    ranges.push("(min-width: ".concat(mdMin, "px) and (max-width: ").concat(mdMax, "px)"));
  }
  if (lg) {
    ranges.push("(min-width: ".concat(lgMin, "px)"));
  }
  if (print) {
    ranges.push('print');
  }
  return ranges;
};
function getSizeMediaQuery(sizes) {
  var ranges = getRanges(sizes);
  return ranges.join(', ');
}
var makeRule = function makeRule(max) {
  return function () {
    var rules = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return _defineProperty({}, "@media (max-width: ".concat(max, "px)"), rules);
  };
};
var xs = makeRule(xsMax);
var sm = makeRule(smMax);
var md = makeRule(mdMax);
var lg = function lg(rules) {
  warn$1('The lg media helper is deprecated and will be removed in a future version. lg styles should be the default and can be restricted though xs, sm, and md styles.');
  return rules;
};
var print = function print() {
  var rules = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return {
    '@media print': rules
  };
};var media=/*#__PURE__*/Object.freeze({__proto__:null,lgMin:lgMin,mdMin:mdMin,mdMax:mdMax,smMin:smMin,smMax:smMax,xsMin:xsMin,xsMax:xsMax,getSizeMediaQuery:getSizeMediaQuery,xs:xs,sm:sm,md:md,lg:lg,print:print});function ownKeys$9(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$9(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$9(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$9(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function Box(_ref) {
  var _useStyles;
  var children = _ref.children,
    component = _ref.component,
    style = _ref.style,
    className = _ref.className,
    classNames = _ref.classNames,
    _ref$marginTop = _ref.marginTop,
    marginTop = _ref$marginTop === void 0 ? 'none' : _ref$marginTop,
    _ref$marginRight = _ref.marginRight,
    marginRight = _ref$marginRight === void 0 ? 'none' : _ref$marginRight,
    _ref$marginBottom = _ref.marginBottom,
    marginBottom = _ref$marginBottom === void 0 ? 'none' : _ref$marginBottom,
    _ref$marginLeft = _ref.marginLeft,
    marginLeft = _ref$marginLeft === void 0 ? 'none' : _ref$marginLeft,
    _ref$paddingTop = _ref.paddingTop,
    paddingTop = _ref$paddingTop === void 0 ? 'none' : _ref$paddingTop,
    _ref$paddingRight = _ref.paddingRight,
    paddingRight = _ref$paddingRight === void 0 ? 'none' : _ref$paddingRight,
    _ref$paddingBottom = _ref.paddingBottom,
    paddingBottom = _ref$paddingBottom === void 0 ? 'none' : _ref$paddingBottom,
    _ref$paddingLeft = _ref.paddingLeft,
    paddingLeft = _ref$paddingLeft === void 0 ? 'none' : _ref$paddingLeft,
    _ref$shadow = _ref.shadow,
    shadow = _ref$shadow === void 0 ? 'none' : _ref$shadow;
  var styles = useStyles(defaultStyles$3, {
    style: style,
    className: className,
    classNames: classNames
  }, (_useStyles = {}, _defineProperty(_useStyles, "&margin-top-".concat(marginTop), true), _defineProperty(_useStyles, "&margin-right-".concat(marginRight), true), _defineProperty(_useStyles, "&margin-bottom-".concat(marginBottom), true), _defineProperty(_useStyles, "&margin-left-".concat(marginLeft), true), _defineProperty(_useStyles, "&padding-top-".concat(paddingTop), true), _defineProperty(_useStyles, "&padding-right-".concat(paddingRight), true), _defineProperty(_useStyles, "&padding-bottom-".concat(paddingBottom), true), _defineProperty(_useStyles, "&padding-left-".concat(paddingLeft), true), _defineProperty(_useStyles, '&shadow', shadow !== 'none'), _defineProperty(_useStyles, "&shadow-".concat(shadow), true), _useStyles));
  var Component = component || 'div';
  return /*#__PURE__*/React__default.createElement(Component, styles, children);
}
var defaultStyles$3 = _objectSpread$9(_objectSpread$9({
  minWidth: 0
}, Object.entries(spacing).reduce(function (result, _ref2) {
  var _objectSpread2;
  var _ref3 = _slicedToArray(_ref2, 2),
    variant = _ref3[0],
    value = _ref3[1];
  return _objectSpread$9(_objectSpread$9({}, result), {}, (_objectSpread2 = {}, _defineProperty(_objectSpread2, "&margin-top-".concat(variant), {
    marginTop: value
  }), _defineProperty(_objectSpread2, "&margin-right-".concat(variant), {
    marginRight: value
  }), _defineProperty(_objectSpread2, "&margin-bottom-".concat(variant), {
    marginBottom: value
  }), _defineProperty(_objectSpread2, "&margin-left-".concat(variant), {
    marginLeft: value
  }), _defineProperty(_objectSpread2, "&padding-top-".concat(variant), {
    paddingTop: value
  }), _defineProperty(_objectSpread2, "&padding-right-".concat(variant), {
    paddingRight: value
  }), _defineProperty(_objectSpread2, "&padding-bottom-".concat(variant), {
    paddingBottom: value
  }), _defineProperty(_objectSpread2, "&padding-left-".concat(variant), {
    paddingLeft: value
  }), _objectSpread2));
}, Object.freeze({}))), {}, {
  '&shadow': {
    overflow: 'hidden',
    borderRadius: 2
  }
}, Object.entries(shadow).reduce(function (result, _ref4) {
  var _ref5 = _slicedToArray(_ref4, 2),
    variant = _ref5[0],
    value = _ref5[1];
  return _objectSpread$9(_objectSpread$9({}, result), {}, _defineProperty({}, "&shadow-".concat(variant), value));
}, Object.freeze({})));var Resize = function Resize(_ref) {
  var resizable = _ref.resizable,
    at = _ref.at,
    flex = _ref.flex,
    _ref$minWidth = _ref.minWidth,
    minWidth = _ref$minWidth === void 0 ? 0 : _ref$minWidth,
    _ref$maxWidth = _ref.maxWidth,
    maxWidth = _ref$maxWidth === void 0 ? Infinity : _ref$maxWidth,
    children = _ref.children,
    onResize = _ref.onResize,
    baseStyle = _ref.style;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    width = _useState2[0],
    setWidth = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    dragging = _useState4[0],
    setDragging = _useState4[1];
  var startX = useRef(null);
  var startWidth = useRef(null);
  var elementRef = useRef(null);
  var newWidth = useRef(null);
  var handleMouseDown = useCallback(function (ev) {
    startWidth.current = elementRef.current && elementRef.current.offsetWidth;
    startX.current = ev.clientX;
    setDragging(true);
  }, []);
  var handleMouseMove = useCallback(function (ev) {
    if (startX.current === null) {
      // only handle mouse move if the mousedown was on our resize handle element
      return;
    }
    var deltaX = (ev.clientX - startX.current) * (at === 'left' ? 1 : -1);
    invariant(startWidth.current != null, 'no Resize component found');
    var finalWidth = Math.max(Math.min(startWidth.current + deltaX, maxWidth), minWidth);
    setWidth(finalWidth);
    newWidth.current = finalWidth;
  }, [minWidth, maxWidth, at]);
  var handleMouseUp = useCallback(function (ev) {
    if (startX.current === null) {
      return;
    }
    if (onResize && typeof newWidth.current === 'number') {
      onResize(newWidth.current);
    }
    startX.current = null;
    newWidth.current = null;
    setDragging(false);
  }, [onResize]);
  useEffect(function () {
    window.addEventListener('mousemove', handleMouseMove);
    window.addEventListener('mouseup', handleMouseUp);
    return function () {
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('mouseup', handleMouseUp);
    };
  }, [handleMouseMove, handleMouseUp]);
  var style = baseStyle({
    '&dragging': dragging
  });
  var isCollapsed = children === null || typeof children === 'undefined' || children === false;
  return /*#__PURE__*/React__default.createElement("div", _extends({}, merge$1(style, {
    flex: width == null || isCollapsed ? flex : "0 0 ".concat(width, "px"),
    minWidth: minWidth === -Infinity ? 0 : minWidth,
    maxWidth: maxWidth === Infinity ? '100%' : maxWidth,
    width: width == null || isCollapsed ? null : width
  }), {
    ref: elementRef
  }), /*#__PURE__*/React__default.createElement("div", style('content'), children), resizable &&
  /*#__PURE__*/
  // Please fix me
  // eslint-disable-next-line jsx-a11y/no-static-element-interactions
  React__default.createElement("div", _extends({}, style(isCollapsed ? 'hiddenHandle' : 'handle'), {
    onMouseDown: handleMouseDown
  }), /*#__PURE__*/React__default.createElement("div", style('bar'))));
};
var styled$g = createDefaultStyle({
  position: 'relative',
  pointerEvents: 'auto',
  height: '100%',
  content: {
    height: '100%',
    overflowY: 'auto'
  },
  handle: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    width: 7,
    left: -3,
    cursor: 'col-resize',
    zIndex: 100,
    display: 'flex',
    transition: 'opacity .2s ease',
    userSelect: 'none'
  },
  hiddenHandle: {
    display: 'none'
  },
  bar: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    width: 1,
    left: 3
  },
  '&atLeft': {
    handle: {
      left: 'auto',
      right: -3
    }
  }
}, function (_ref2) {
  var at = _ref2.at;
  return {
    '&atLeft': at === 'left'
  };
});
var Resize$1 = styled$g(Resize);function ownKeys$8(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$8(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$8(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$8(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var OverlayPanel = function OverlayPanel(_ref) {
  var panel = _ref.panel,
    panelGhost = _ref.panelGhost,
    _ref$at = _ref.at,
    at = _ref$at === void 0 ? 'right' : _ref$at,
    children = _ref.children,
    flexPanel = _ref.flexPanel,
    flexMain = _ref.flexMain,
    resizable = _ref.resizable,
    onResize = _ref.onResize,
    minWidth = _ref.minWidth,
    maxWidth = _ref.maxWidth,
    noBackdrop = _ref.noBackdrop,
    onRequestClose = _ref.onRequestClose,
    delayBackdropActivation = _ref.delayBackdropActivation,
    baseStyle = _ref.style;
  var backdropActive = useDelayActivate(!noBackdrop && !!panel, delayBackdropActivation);
  var style = baseStyle({
    '&backdropActive': backdropActive
  });
  /* Please fix me
  /* jsx-a11y/click-events-have-key-events jsx-a11y/no-static-element-interactions */
  /* eslint-disable */
  return /*#__PURE__*/React__default.createElement("div", style, /*#__PURE__*/React__default.createElement("div", style('main'), children), /*#__PURE__*/React__default.createElement("div", _extends({
    "aria-modal": !noBackdrop && !!panel
  }, style('backdrop'), {
    onMouseDown: function onMouseDown(ev) {
      // only handle direct clicks on the backdrop, not those that
      // bubble up from the panel element
      // also check if it's only left button
      if (ev.target === ev.currentTarget && ev.buttons === 1) {
        invariant(!!onRequestClose, '`onRequestClose` prop is required if the Panel component uses the overlay state');
        onRequestClose();
      }
    }
  }), /*#__PURE__*/React__default.createElement("div", merge$1(style('void'), {
    flex: flexMain
  })), /*#__PURE__*/React__default.createElement(Resize$1, {
    style: style('panel'),
    at: at,
    resizable: !!resizable,
    onResize: onResize,
    flex: flexPanel,
    minWidth: minWidth,
    maxWidth: maxWidth
  }, panel || panelGhost)));
  /* eslint-enable */
};

// The purpose of this hook is to delay the moment the backdrop starts handling pointer events.
// This required for use cases in Hub, where the panel opens on click, but doubleclick needs to be handled as well.
var useDelayActivate = function useDelayActivate(isActiveOrShallTurnActive, shallDelay) {
  var _useState = useState(isActiveOrShallTurnActive),
    _useState2 = _slicedToArray(_useState, 2),
    active = _useState2[0],
    setActive = _useState2[1];
  useEffect(function () {
    if (isActiveOrShallTurnActive && !active) {
      if (!shallDelay) {
        setActive(true);
        return;
      }
      var handle = window.setTimeout(function () {
        setActive(true);
      }, 200);
      return function () {
        window.clearTimeout(handle);
      };
    }
    if (!isActiveOrShallTurnActive && active) {
      setActive(false);
    }
  }, [active, isActiveOrShallTurnActive, shallDelay]);
  return isActiveOrShallTurnActive ? active : false;
};
var styled$f = createDefaultStyle({
  minHeight: '100%',
  height: '100%',
  overflowX: 'hidden',
  position: 'relative',
  main: {
    height: '100%',
    overflowY: 'auto'
  },
  backdrop: _objectSpread$8({
    pointerEvents: 'none',
    zIndex: popover,
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    height: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'stretch',
    backgroundColor: Color('#000').alpha(0.67).rgb().string()
  }, transition('background-color')),
  void: {
    visibility: 'hidden',
    pointerEvents: 'none'
  },
  panel: _objectSpread$8(_objectSpread$8({}, transition(['transform'])), {}, {
    transform: 'translateX(0)'
  }),
  '&backdropActive': {
    main: {
      overflowY: 'hidden'
    },
    backdrop: {
      pointerEvents: 'auto'
    }
  },
  '&fadeOutBackdrop': {
    backdrop: {
      backgroundColor: Color('#000').alpha(0).rgb().string()
    }
  },
  '&slideOutRight': {
    panel: {
      transform: 'translateX(100%)'
    }
  },
  '&slideOutLeft': {
    panel: {
      transform: 'translateX(-100%)'
    }
  },
  '&atLeft': {
    backdrop: {
      flexDirection: 'row-reverse'
    }
  }
}, function (_ref2) {
  var panel = _ref2.panel,
    at = _ref2.at,
    noBackdrop = _ref2.noBackdrop;
  return {
    '&fadeOutBackdrop': !panel || noBackdrop,
    '&atLeft': at === 'left',
    '&atRight': at !== 'left',
    '&slideOutRight': !panel && at !== 'left',
    '&slideOutLeft': !panel && at === 'left'
  };
});
var OverlayPanelStructure = styled$f(OverlayPanel);function ownKeys$7(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$7(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$7(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$7(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var SLIDE_OUT_TRANSITION_TIME = 300;
var PushPanel = function PushPanel(_ref) {
  var panel = _ref.panel,
    panelGhost = _ref.panelGhost,
    flexMain = _ref.flexMain,
    flexPanel = _ref.flexPanel,
    minWidth = _ref.minWidth,
    maxWidth = _ref.maxWidth,
    resizable = _ref.resizable,
    onResize = _ref.onResize,
    children = _ref.children,
    at = _ref.at,
    style = _ref.style;
  var panelCollapsed = !panel;
  var _useState = useState(panelCollapsed),
    _useState2 = _slicedToArray(_useState, 2),
    mainTakesAll = _useState2[0],
    setMainTakesAll = _useState2[1];
  useEffect(function () {
    if (panelCollapsed) {
      // adjust main width after the panel has slid out
      var timeout = setTimeout(function () {
        setMainTakesAll(true);
      }, SLIDE_OUT_TRANSITION_TIME); // the slide out css transitions takes 300ms
      return function () {
        clearTimeout(timeout);
      };
    } else {
      // when sliding in, adjust main width right away
      setMainTakesAll(false);
    }
  }, [panelCollapsed]);
  return /*#__PURE__*/React__default.createElement("div", style, /*#__PURE__*/React__default.createElement("div", merge$1(style('main'), {
    flex: flexMain
  }), children), /*#__PURE__*/React__default.createElement(Resize$1, {
    style: style('panel'),
    at: at,
    resizable: !!resizable,
    onResize: onResize,
    flex: mainTakesAll ? '0' : flexPanel,
    minWidth: panelCollapsed ? 0 : minWidth,
    maxWidth: maxWidth
  }, panel || panelGhost));
};
var styled$e = createDefaultStyle({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'stretch',
  minHeight: '100%',
  height: '100%',
  overflowX: 'hidden',
  main: {
    height: '100%',
    overflowY: 'auto',
    position: 'relative',
    overflowX: 'hidden'
  },
  panel: _objectSpread$7(_objectSpread$7({}, transition(['transform'])), {}, {
    transform: 'translateX(0)'
  }),
  '&atLeft': {
    flexDirection: 'row-reverse'
  },
  '&slideOutRight': {
    panel: {
      transform: 'translateX(100%)'
    }
  }
}, function (_ref2) {
  var at = _ref2.at,
    panel = _ref2.panel;
  return {
    '&atLeft': at === 'left',
    '&atRight': at !== 'left',
    '&slideOutRight': !panel && at !== 'left'
  };
});
var PushPanelStructure = styled$e(PushPanel);var _excluded$a = ["panel", "panelGhost", "children", "style", "onRequestClose"];
// ReplacePanel is just a special case of OverlayPanelStructure where the panel covers the entire content
var ReplacePanel = function ReplacePanel(_ref) {
  var panel = _ref.panel,
    panelGhost = _ref.panelGhost,
    children = _ref.children,
    style = _ref.style,
    onRequestClose = _ref.onRequestClose,
    rest = _objectWithoutProperties(_ref, _excluded$a);
  return /*#__PURE__*/React__default.createElement(OverlayPanelStructure, _extends({}, rest, {
    noBackdrop: true,
    panel: panel,
    panelGhost: panelGhost,
    style: style,
    resizable: false,
    delayBackdropActivation: false,
    maxWidth: Infinity,
    minWidth: 0,
    flexPanel: "1",
    flexMain: "0",
    onResize: _noop,
    onRequestClose: onRequestClose
  }), children);
};
var ReplacePanelStructure = ReplacePanel;var _excluded$9 = ["children", "panel", "xs", "sm", "md", "lg", "at", "flexPanel", "flexMain", "minWidth", "maxWidth", "resizable", "onResize", "onRequestClose", "noBackdrop", "delayBackdropActivation"];
var ResponsivePanel = function ResponsivePanel(_ref) {
  var children = _ref.children,
    panel = _ref.panel,
    xs = _ref.xs,
    sm = _ref.sm,
    md = _ref.md,
    lg = _ref.lg,
    _ref$at = _ref.at,
    at = _ref$at === void 0 ? 'right' : _ref$at,
    _ref$flexPanel = _ref.flexPanel,
    flexPanel = _ref$flexPanel === void 0 ? '2 2 200px' : _ref$flexPanel,
    _ref$flexMain = _ref.flexMain,
    flexMain = _ref$flexMain === void 0 ? 3 : _ref$flexMain,
    _ref$minWidth = _ref.minWidth,
    minWidth = _ref$minWidth === void 0 ? 0 : _ref$minWidth,
    _ref$maxWidth = _ref.maxWidth,
    maxWidth = _ref$maxWidth === void 0 ? Infinity : _ref$maxWidth,
    _ref$resizable = _ref.resizable,
    resizable = _ref$resizable === void 0 ? false : _ref$resizable,
    _onResize = _ref.onResize,
    onRequestClose = _ref.onRequestClose,
    noBackdrop = _ref.noBackdrop,
    delayBackdropActivation = _ref.delayBackdropActivation,
    rest = _objectWithoutProperties(_ref, _excluded$9);
  var behavior = useBehavior(xs, sm, md, lg);
  var _useState = useState(panel),
    _useState2 = _slicedToArray(_useState, 2),
    panelGhost = _useState2[0],
    setPanelGhost = _useState2[1];
  useEffect(function () {
    if (panel) {
      setPanelGhost(panel);
    } else {
      var timeout = setTimeout(function () {
        setPanelGhost(null);
      }, 300); // the slide out css transitions takes 300ms

      return function () {
        clearTimeout(timeout);
      };
    }
  }, [panel]);
  if (behavior === 'push') {
    return /*#__PURE__*/React__default.createElement(PushPanelStructure, _extends({}, rest, {
      panel: panel,
      panelGhost: !panel && panelGhost,
      at: at,
      flexPanel: flexPanel,
      flexMain: flexMain,
      minWidth: minWidth,
      maxWidth: maxWidth,
      resizable: resizable,
      onResize: function onResize(newWidth) {
        if (_onResize) {
          _onResize(newWidth);
        }
      }
    }), children);
  }
  if (behavior === 'overlay') {
    return /*#__PURE__*/React__default.createElement(OverlayPanelStructure, _extends({}, rest, {
      panel: panel,
      panelGhost: !panel && panelGhost,
      at: at,
      flexMain: flexMain,
      flexPanel: flexPanel,
      minWidth: minWidth,
      maxWidth: maxWidth,
      delayBackdropActivation: !!delayBackdropActivation,
      noBackdrop: !!noBackdrop,
      resizable: resizable,
      onResize: function onResize(newWidth) {
        if (_onResize) {
          _onResize(newWidth);
        }
      },
      onRequestClose: onRequestClose
    }), children);
  }
  return /*#__PURE__*/React__default.createElement(ReplacePanelStructure, _extends({}, rest, {
    panel: panel,
    panelGhost: !panel && panelGhost,
    at: at,
    onRequestClose: onRequestClose
  }), children);
};
var useBehavior = function useBehavior(xs, sm, md, lg) {
  var isXs = useMedia({
    maxWidth: xsMax
  });
  var isSm = useMedia({
    minWidth: smMin,
    maxWidth: smMax
  });
  var isMd = useMedia({
    minWidth: mdMin,
    maxWidth: mdMax
  });
  if (isXs) {
    return xs || sm || md || lg || 'replace';
  }
  if (isSm) {
    return sm || md || lg || 'overlay';
  }
  if (isMd) {
    return md || lg || 'overlay';
  }
  // isLg (> 1200)
  return lg || 'push';
};
var ResponsivePanel$1 = ResponsivePanel;var _excluded$8 = ["children", "spacing", "direction", "style", "className", "classNames"];
function Stack(_ref) {
  var children = _ref.children,
    spacing = _ref.spacing,
    _ref$direction = _ref.direction,
    direction = _ref$direction === void 0 ? 'vertical' : _ref$direction,
    style = _ref.style,
    className = _ref.className,
    classNames = _ref.classNames,
    rest = _objectWithoutProperties(_ref, _excluded$8);
  var styles = useStyles(defaultStyles$2, {
    style: style,
    className: className,
    classNames: classNames
  }, _defineProperty({}, "&".concat(direction), true));
  var correctedIndex = 0;
  return /*#__PURE__*/React__default.createElement("div", _extends({}, styles, rest), Children.map(children, function (child) {
    if (! /*#__PURE__*/isValidElement(child) && typeof child !== 'string') {
      return null;
    }
    var index = correctedIndex;
    correctedIndex++;
    if (direction === 'vertical') {
      return /*#__PURE__*/React__default.createElement(Box, {
        marginTop: index === 0 ? 'none' : spacing
      }, child);
    }
    return /*#__PURE__*/React__default.createElement(Box, {
      marginLeft: index === 0 ? 'none' : spacing
    }, child);
  }));
}
var defaultStyles$2 = {
  '&horizontal': {
    display: 'flex'
  }
};function ownKeys$6(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$6(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$6(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$6(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var ModalBase = function ModalBase(_ref) {
  var style = _ref.style,
    children = _ref.children,
    header = _ref.header,
    footer = _ref.footer;
  return /*#__PURE__*/React__default.createElement("div", _extends({}, style, {
    role: "dialog"
  }), header && /*#__PURE__*/React__default.createElement("div", style('header'), header), /*#__PURE__*/React__default.createElement("div", style('content'), children), footer && /*#__PURE__*/React__default.createElement("div", style('footer'), footer));
};
var styled$d = createDefaultStyle(function () {
  return _objectSpread$6(_objectSpread$6(_objectSpread$6({
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: 'white',
    maxHeight: '100%',
    borderRadius: 2
  }, modal$1), xs({
    width: "calc(100vw - ".concat(xlarge$1, "px)")
  })), {}, {
    header: {
      display: 'flex',
      flexShrink: '0',
      paddingLeft: large$1,
      paddingRight: small$1,
      paddingTop: small$1,
      paddingBottom: small$1
    },
    content: {
      paddingLeft: large$1,
      paddingRight: large$1,
      paddingTop: medium,
      paddingBottom: medium,
      overflowY: 'auto',
      overflowX: 'auto',
      flex: '1 1 auto'
    },
    '&isIE11': {
      // Not my best work, I would rather use flex: 1 1 auto but ie11 has a flexbox issue,
      // good luck trying to solve it https://github.com/philipwalton/flexbugs
      // sorry for the magic numbers, it is the height of the header and footer,
      content: {
        maxHeight: "calc(100vh - ".concat(xxxxlarge, "px -  ").concat(xxxxlarge, "px - 103px)")
      },
      '&hasFooter': {
        content: {
          maxHeight: "calc(100vh - ".concat(xxxxlarge, "px -  ").concat(xxxxlarge, "px - 103px - 72px)")
        }
      }
    },
    footer: {
      flexShrink: 0,
      display: 'flex',
      justifyContent: 'flex-end',
      paddingLeft: small$1,
      paddingRight: small$1,
      paddingTop: small$1,
      paddingBottom: small$1
    }
  });
}, function (_ref2) {
  var footer = _ref2.footer;
  return {
    '&hasFooter': footer,
    '&isIE11': isIE11OrLower
  };
});
var ModalBase$1 = styled$d(ModalBase);function ownKeys$5(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$5(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$5(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$5(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var SlideTransition = function SlideTransition(_ref) {
  var style = _ref.style,
    children = _ref.children;
  return /*#__PURE__*/React__default.createElement("div", style, /*#__PURE__*/React__default.createElement("div", style('slideContent'), children));
};
var styled$c = createDefaultStyle(function (_ref2) {
  var width = _ref2.width,
    height = _ref2.height,
    duration = _ref2.duration;
  return {
    overflow: 'hidden',
    slideContent: _objectSpread$5({}, transition(['transform'], 'ease', "".concat(duration, "ms"))),
    '&down': _objectSpread$5(_objectSpread$5({
      height: 0
    }, transition(['height'], 'ease', "".concat(duration, "ms"))), {}, {
      slideContent: {
        transform: 'translateY(-100%)'
      },
      '&entering': {
        height: height,
        slideContent: {
          transform: 'translateY(0)'
        }
      },
      '&entered': {
        overflow: 'visible',
        height: height,
        slideContent: {
          transform: 'translateY(0)'
        }
      },
      '&exiting': {
        height: 0
      }
    }),
    '&up': _objectSpread$5(_objectSpread$5({
      height: 0
    }, transition(['height'], 'ease', "".concat(duration, "ms"))), {}, {
      slideContent: {
        transform: 'translateY(100%)'
      },
      '&entering': {
        height: height,
        slideContent: {
          transform: 'translateY(0)'
        }
      },
      '&entered': {
        overflow: 'visible',
        height: height,
        slideContent: {
          transform: 'translateY(0)'
        }
      },
      '&exiting': {
        height: 0
      }
    }),
    '&left': _objectSpread$5(_objectSpread$5({
      width: 0
    }, transition(['width'], 'ease', "".concat(duration, "ms"))), {}, {
      slideContent: {
        transform: 'translateX(100%)'
      },
      '&entering': {
        width: width,
        slideContent: {
          transform: 'translateX(0)'
        }
      },
      '&entered': {
        overflow: 'visible',
        width: width,
        slideContent: {
          transform: 'translateX(0)'
        }
      },
      '&exiting': {
        width: 0
      }
    }),
    '&right': _objectSpread$5(_objectSpread$5({
      width: 0
    }, transition(['width'], 'ease', "".concat(duration, "ms"))), {}, {
      slideContent: {
        transform: 'translateX(-100%)'
      },
      '&entering': {
        width: width,
        slideContent: {
          transform: 'translateX(0)'
        }
      },
      '&entered': {
        overflow: 'visible',
        width: width,
        slideContent: {
          transform: 'translateX(0)'
        }
      },
      '&exiting': {
        width: 0
      }
    })
  };
}, function (_ref3) {
  var _ref4;
  var state = _ref3.state,
    direction = _ref3.direction;
  return _ref4 = {}, _defineProperty(_ref4, "&".concat(state), true), _defineProperty(_ref4, "&".concat(direction), true), _ref4;
});
var SlideTransition$1 = styled$c(SlideTransition);var _excluded$7 = ["children", "style", "up", "down", "left", "right", "onEnter", "onExit"];
var ANIMATION_DURATION$4 = 300;
var getDirection = function getDirection(props) {
  return ['up', 'down', 'left', 'right'].find(function (direction) {
    return props[direction];
  }) || 'down';
};
var SlideAnimation = function SlideAnimation(_ref) {
  var children = _ref.children,
    style = _ref.style,
    up = _ref.up,
    down = _ref.down,
    left = _ref.left,
    right = _ref.right,
    _onEnter = _ref.onEnter,
    _onExit = _ref.onExit,
    rest = _objectWithoutProperties(_ref, _excluded$7);
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    dimensions = _useState2[0],
    setDimensions = _useState2[1];
  return /*#__PURE__*/React__default.createElement(Transition, _extends({}, rest, {
    unmountOnExit: true,
    timeout: ANIMATION_DURATION$4,
    onEnter: function onEnter(node, isAppearing) {
      setDimensions({
        height: node.scrollHeight,
        width: node.scrollWidth
      });
      if (_onEnter) {
        _onEnter(node, isAppearing);
      }
    },
    onExit: function onExit(node) {
      setDimensions({
        height: node.scrollHeight,
        width: node.scrollWidth
      });
      if (_onExit) {
        _onExit(node);
      }
    }
  }), function (state) {
    return /*#__PURE__*/React__default.createElement(SlideTransition$1, {
      state: state,
      width: dimensions.width,
      height: dimensions.height,
      style: style,
      duration: ANIMATION_DURATION$4,
      direction: getDirection({
        up: up,
        down: down,
        left: left,
        right: right
      })
    }, children);
  });
};
var SlideAnimation$1 = SlideAnimation;function ownKeys$4(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$4(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$4(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$4(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function FadeTransition(_ref) {
  var style = _ref.style,
    children = _ref.children;
  return /*#__PURE__*/React__default.createElement("div", style, children);
}
var styled$b = createDefaultStyle(function (_ref2) {
  var duration = _ref2.duration;
  return _objectSpread$4(_objectSpread$4({}, transition(['opacity'], 'ease-in-out', "".concat(duration, "ms"))), {}, {
    opacity: 0,
    '&entered': {
      opacity: 1
    }
  });
}, function (_ref3) {
  var state = _ref3.state;
  return _defineProperty({}, "&".concat(state), true);
});
var FadeTransition$1 = styled$b(FadeTransition);var _excluded$6 = ["children", "style"];
var ANIMATION_DURATION$3 = 150;
function FadeAnimation(_ref) {
  var children = _ref.children,
    style = _ref.style,
    rest = _objectWithoutProperties(_ref, _excluded$6);
  return /*#__PURE__*/React__default.createElement(Transition, _extends({}, rest, {
    timeout: ANIMATION_DURATION$3
  }), function (state) {
    return /*#__PURE__*/React__default.createElement(FadeTransition$1, {
      state: state,
      style: style,
      duration: ANIMATION_DURATION$3
    }, children);
  });
}function ownKeys$3(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$3(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$3(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$3(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function DropTransition(_ref) {
  var style = _ref.style,
    children = _ref.children;
  return /*#__PURE__*/React__default.createElement("div", style, children);
}
var styled$a = createDefaultStyle(function (_ref2) {
  var duration = _ref2.duration;
  return _objectSpread$3(_objectSpread$3({}, transition(['opacity', 'transform'], 'ease-in-out', "".concat(duration, "ms"))), {}, {
    opacity: 0,
    transform: 'translateY(-88px)',
    '&entering': {
      opacity: 1,
      transform: 'translateY(0px)'
    },
    '&exiting': {
      opacity: 1,
      transform: 'translateY(0px)'
    },
    '&entered': {
      opacity: 1,
      // css transforms mess with position fixed, so clear it once the animation has finished
      transform: 'none'
    }
  });
}, function (_ref3) {
  var state = _ref3.state;
  return _defineProperty({}, "&".concat(state), true);
});
var DropTransition$1 = styled$a(DropTransition);var _excluded$5 = ["children", "style"];
var ANIMATION_DURATION$2 = 240;
function DropAnimation(_ref) {
  var children = _ref.children,
    style = _ref.style,
    rest = _objectWithoutProperties(_ref, _excluded$5);
  return /*#__PURE__*/React__default.createElement(Transition, _extends({}, rest, {
    timeout: ANIMATION_DURATION$2
  }), function (state) {
    return /*#__PURE__*/React__default.createElement(DropTransition$1, {
      state: state,
      style: style,
      duration: ANIMATION_DURATION$2
    }, children);
  });
}function ownKeys$2(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$2(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function ScaleTransition(_ref) {
  var style = _ref.style,
    children = _ref.children;
    _ref.state;
  return /*#__PURE__*/React__default.createElement("div", style, children);
}
var styled$9 = createDefaultStyle(function (_ref2) {
  var duration = _ref2.duration;
  return _objectSpread$2(_objectSpread$2({}, transition(['opacity', 'transform'], 'ease-in-out', "".concat(duration, "ms"))), {}, {
    opacity: 0.5,
    transform: 'scale(0.75)',
    '&entering': {
      opacity: 1,
      transform: 'scale(1)'
    },
    '&exiting': {
      opacity: 1,
      transform: 'scale(1)'
    },
    '&entered': {
      opacity: 1,
      // css transforms mess with position fixed, so clear it once the animation has finished
      transform: 'none'
    }
  });
}, function (_ref3) {
  var state = _ref3.state;
  return _defineProperty({}, "&".concat(state), true);
});
var ScaleTransition$1 = styled$9(ScaleTransition);var _excluded$4 = ["children", "style"];
var ANIMATION_DURATION$1 = 150;
function ScaleAnimation(_ref) {
  var children = _ref.children,
    style = _ref.style,
    rest = _objectWithoutProperties(_ref, _excluded$4);
  return /*#__PURE__*/React__default.createElement(Transition, _extends({}, rest, {
    timeout: ANIMATION_DURATION$1
  }), function (state) {
    return /*#__PURE__*/React__default.createElement(ScaleTransition$1, {
      state: state,
      style: style,
      duration: ANIMATION_DURATION$1
    }, children);
  });
}function ShakeTransition(_ref) {
  var style = _ref.style,
    children = _ref.children;
  return /*#__PURE__*/React__default.createElement("div", style, children);
}
var styled$8 = createDefaultStyle(function (_ref2) {
  var duration = _ref2.duration;
  return {
    '&entered': {
      animation: "signavio-ui-shake ".concat(duration, "ms cubic-bezier(.38,.06,.24,.98) both")
    }
  };
}, function (_ref3) {
  var state = _ref3.state;
  return _defineProperty({}, "&".concat(state), true);
});
var ShakeTransition$1 = styled$8(ShakeTransition);var _excluded$3 = ["children", "style", "in", "onEntered"];
var ANIMATION_DURATION = 750;
function ShakeAnimation(_ref) {
  var children = _ref.children,
    style = _ref.style,
    inProp = _ref.in,
    onEntered = _ref.onEntered,
    rest = _objectWithoutProperties(_ref, _excluded$3);
  useOnEntered(inProp, onEntered, ANIMATION_DURATION);
  return /*#__PURE__*/React__default.createElement(Transition, _extends({}, rest, {
    in: inProp,
    timeout: {
      appear: ANIMATION_DURATION,
      enter: 0
    }
  }), function (state) {
    return /*#__PURE__*/React__default.createElement(ShakeTransition$1, {
      state: state,
      style: style,
      duration: ANIMATION_DURATION
    }, children);
  });
}
var useOnEntered = function useOnEntered(inProp, callback, timeout) {
  var handler = useRef(callback);
  useEffect(function () {
    handler.current = callback;
  }, [callback]);
  useEffect(function () {
    if (inProp) {
      var timeoutRef = setTimeout(function () {
        if (handler.current) {
          handler.current();
        }
      }, timeout);
      return function () {
        clearTimeout(timeoutRef);
      };
    }
  }, [inProp, timeout]);
};var useInDelay = function useInDelay(inValue, delay) {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    delayedIn = _useState2[0],
    setDelayedIn = _useState2[1];
  useEffect(function () {
    if (!inValue) {
      setDelayedIn(false);
      return;
    }
    var timeout = setTimeout(function () {
      setDelayedIn(true);
    }, delay);
    return function () {
      clearTimeout(timeout);
    };
  }, [inValue, delay]);
  return delayedIn;
};
var useInDelay$1 = useInDelay;var Backdrop = function Backdrop(_ref) {
  var style = _ref.style,
    children = _ref.children,
    open = _ref.open,
    onRequestClose = _ref.onRequestClose,
    onClosed = _ref.onClosed;
  useBodyScrollBlock(open !== null && open !== void 0 ? open : true);
  useEscToClose(onRequestClose);
  var _useState = useState(open !== null && open !== void 0 ? open : true),
    _useState2 = _slicedToArray(_useState, 2),
    showBackdrop = _useState2[0],
    setShowBackdrop = _useState2[1];
  useEffect(function () {
    if (open) {
      setShowBackdrop(true);
    }
  }, [open]);
  var portalHost = usePortal(showBackdrop);
  var trapFocus = useFocusTrap();
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    hostForDescendentPortals = _useState4[0],
    setHostForDescendentPortals = _useState4[1];
  var ref = useCallback(function (node) {
    trapFocus(node);
    setHostForDescendentPortals(node);
  }, [trapFocus]);
  if (!showBackdrop) {
    return null;
  }
  return /*#__PURE__*/createPortal( /*#__PURE__*/React__default.createElement("div", _extends({}, style, {
    ref: ref,
    "data-testid": "focus-trap"
  }), /*#__PURE__*/React__default.createElement(FadeAnimation, {
    in: open !== null && open !== void 0 ? open : true,
    appear: true,
    style: style('animation'),
    onExited: function onExited() {
      setShowBackdrop(false);
      if (onClosed) {
        onClosed();
      }
    }
  }, /*#__PURE__*/React__default.createElement("div", _extends({}, style('backdrop'), {
    role: "button",
    onMouseDown: function onMouseDown(event) {
      if (event.target === event.currentTarget) {
        // only request close when the user clicked on the backdrop
        // surface, not when the user clicked somewhere inside
        // the children or on a portal element inside of the modal
        onRequestClose();
      }
    },
    tabIndex: -1
  }), !!hostForDescendentPortals && /*#__PURE__*/React__default.createElement(PortalContext.Provider, {
    value: hostForDescendentPortals
  }, children)))), portalHost);
};
var useBodyScrollBlock = function useBodyScrollBlock(open) {
  useEffect(function () {
    if (open) {
      document.body && document.body.classList.add('noScroll');
      return function () {
        document.body && document.body.classList.remove('noScroll');
      };
    }
  }, [open]);
};
var useEscToClose = function useEscToClose(onRequestClose) {
  useEffect(function () {
    var handleKeyDown = function handleKeyDown(event) {
      if (event.keyCode === 27) {
        onRequestClose();
      }
    };
    document.addEventListener('keydown', handleKeyDown, false);
    return function () {
      document.removeEventListener('keydown', handleKeyDown, false);
    };
  }, [onRequestClose]);
};
var useFocusTrap = function useFocusTrap() {
  var focusTrap = useRef();
  var trap = useCallback(function (node) {
    if (focusTrap.current) {
      focusTrap.current.deactivate();
    }
    if (node) {
      focusTrap.current = createFocusTrap(node, {
        initialFocus: function initialFocus() {
          if (node.contains(document.activeElement)) {
            return document.activeElement;
          }
          return node;
        },
        fallbackFocus: function fallbackFocus() {
          return node;
        },
        escapeDeactivates: false,
        /**
         * Click outside should not be trapped
         * for example trapping it prevents controls of SAP Companion to be triggered
         */
        allowOutsideClick: true
      });
      focusTrap.current.activate();
    }
  }, []);
  return trap;
};
var styled$7 = createDefaultStyle({
  position: 'fixed',
  top: 0,
  left: 0,
  bottom: 0,
  right: 0,
  zIndex: modal$2,
  height: '100%',
  animation: {
    height: 'inherit'
  },
  backdrop: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.66)',
    paddingTop: xxxxlarge,
    paddingBottom: xxxxlarge,
    paddingRight: medium,
    paddingLeft: medium
  }
});
var Backdrop$1 = styled$7(Backdrop);/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */
/* eslint-disable require-jsdoc, valid-jsdoc */
var MapShim = function () {
  if (typeof Map !== 'undefined') {
    return Map;
  }
  /**
   * Returns index in provided array that matches the specified key.
   *
   * @param {Array<Array>} arr
   * @param {*} key
   * @returns {number}
   */
  function getIndex(arr, key) {
    var result = -1;
    arr.some(function (entry, index) {
      if (entry[0] === key) {
        result = index;
        return true;
      }
      return false;
    });
    return result;
  }
  return (/** @class */function () {
      function class_1() {
        this.__entries__ = [];
      }
      Object.defineProperty(class_1.prototype, "size", {
        /**
         * @returns {boolean}
         */
        get: function get() {
          return this.__entries__.length;
        },
        enumerable: true,
        configurable: true
      });
      /**
       * @param {*} key
       * @returns {*}
       */
      class_1.prototype.get = function (key) {
        var index = getIndex(this.__entries__, key);
        var entry = this.__entries__[index];
        return entry && entry[1];
      };
      /**
       * @param {*} key
       * @param {*} value
       * @returns {void}
       */
      class_1.prototype.set = function (key, value) {
        var index = getIndex(this.__entries__, key);
        if (~index) {
          this.__entries__[index][1] = value;
        } else {
          this.__entries__.push([key, value]);
        }
      };
      /**
       * @param {*} key
       * @returns {void}
       */
      class_1.prototype.delete = function (key) {
        var entries = this.__entries__;
        var index = getIndex(entries, key);
        if (~index) {
          entries.splice(index, 1);
        }
      };
      /**
       * @param {*} key
       * @returns {void}
       */
      class_1.prototype.has = function (key) {
        return !!~getIndex(this.__entries__, key);
      };
      /**
       * @returns {void}
       */
      class_1.prototype.clear = function () {
        this.__entries__.splice(0);
      };
      /**
       * @param {Function} callback
       * @param {*} [ctx=null]
       * @returns {void}
       */
      class_1.prototype.forEach = function (callback, ctx) {
        if (ctx === void 0) {
          ctx = null;
        }
        for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
          var entry = _a[_i];
          callback.call(ctx, entry[1], entry[0]);
        }
      };
      return class_1;
    }()
  );
}();

/**
 * Detects whether window and document objects are available in current environment.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;

// Returns global object of a current environment.
var global$1 = function () {
  if (typeof global !== 'undefined' && global.Math === Math) {
    return global;
  }
  if (typeof self !== 'undefined' && self.Math === Math) {
    return self;
  }
  if (typeof window !== 'undefined' && window.Math === Math) {
    return window;
  }
  // eslint-disable-next-line no-new-func
  return Function('return this')();
}();

/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */
var requestAnimationFrame$1 = function () {
  if (typeof requestAnimationFrame === 'function') {
    // It's required to use a bounded function because IE sometimes throws
    // an "Invalid calling object" error if rAF is invoked without the global
    // object on the left hand side.
    return requestAnimationFrame.bind(global$1);
  }
  return function (callback) {
    return setTimeout(function () {
      return callback(Date.now());
    }, 1000 / 60);
  };
}();

// Defines minimum timeout before adding a trailing call.
var trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */
function throttle(callback, delay) {
  var leadingCall = false,
    trailingCall = false,
    lastCallTime = 0;
  /**
   * Invokes the original callback function and schedules new invocation if
   * the "proxy" was called during current request.
   *
   * @returns {void}
   */
  function resolvePending() {
    if (leadingCall) {
      leadingCall = false;
      callback();
    }
    if (trailingCall) {
      proxy();
    }
  }
  /**
   * Callback invoked after the specified delay. It will further postpone
   * invocation of the original function delegating it to the
   * requestAnimationFrame.
   *
   * @returns {void}
   */
  function timeoutCallback() {
    requestAnimationFrame$1(resolvePending);
  }
  /**
   * Schedules invocation of the original function.
   *
   * @returns {void}
   */
  function proxy() {
    var timeStamp = Date.now();
    if (leadingCall) {
      // Reject immediately following calls.
      if (timeStamp - lastCallTime < trailingTimeout) {
        return;
      }
      // Schedule new call to be in invoked when the pending one is resolved.
      // This is important for "transitions" which never actually start
      // immediately so there is a chance that we might miss one if change
      // happens amids the pending invocation.
      trailingCall = true;
    } else {
      leadingCall = true;
      trailingCall = false;
      setTimeout(timeoutCallback, delay);
    }
    lastCallTime = timeStamp;
  }
  return proxy;
}

// Minimum delay before invoking the update of observers.
var REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
// Check if MutationObserver is available.
var mutationObserverSupported = typeof MutationObserver !== 'undefined';
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */
var ResizeObserverController = /** @class */function () {
  /**
   * Creates a new instance of ResizeObserverController.
   *
   * @private
   */
  function ResizeObserverController() {
    /**
     * Indicates whether DOM listeners have been added.
     *
     * @private {boolean}
     */
    this.connected_ = false;
    /**
     * Tells that controller has subscribed for Mutation Events.
     *
     * @private {boolean}
     */
    this.mutationEventsAdded_ = false;
    /**
     * Keeps reference to the instance of MutationObserver.
     *
     * @private {MutationObserver}
     */
    this.mutationsObserver_ = null;
    /**
     * A list of connected observers.
     *
     * @private {Array<ResizeObserverSPI>}
     */
    this.observers_ = [];
    this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
    this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
  }
  /**
   * Adds observer to observers list.
   *
   * @param {ResizeObserverSPI} observer - Observer to be added.
   * @returns {void}
   */
  ResizeObserverController.prototype.addObserver = function (observer) {
    if (!~this.observers_.indexOf(observer)) {
      this.observers_.push(observer);
    }
    // Add listeners if they haven't been added yet.
    if (!this.connected_) {
      this.connect_();
    }
  };
  /**
   * Removes observer from observers list.
   *
   * @param {ResizeObserverSPI} observer - Observer to be removed.
   * @returns {void}
   */
  ResizeObserverController.prototype.removeObserver = function (observer) {
    var observers = this.observers_;
    var index = observers.indexOf(observer);
    // Remove observer if it's present in registry.
    if (~index) {
      observers.splice(index, 1);
    }
    // Remove listeners if controller has no connected observers.
    if (!observers.length && this.connected_) {
      this.disconnect_();
    }
  };
  /**
   * Invokes the update of observers. It will continue running updates insofar
   * it detects changes.
   *
   * @returns {void}
   */
  ResizeObserverController.prototype.refresh = function () {
    var changesDetected = this.updateObservers_();
    // Continue running updates if changes have been detected as there might
    // be future ones caused by CSS transitions.
    if (changesDetected) {
      this.refresh();
    }
  };
  /**
   * Updates every observer from observers list and notifies them of queued
   * entries.
   *
   * @private
   * @returns {boolean} Returns "true" if any observer has detected changes in
   *      dimensions of it's elements.
   */
  ResizeObserverController.prototype.updateObservers_ = function () {
    // Collect observers that have active observations.
    var activeObservers = this.observers_.filter(function (observer) {
      return observer.gatherActive(), observer.hasActive();
    });
    // Deliver notifications in a separate cycle in order to avoid any
    // collisions between observers, e.g. when multiple instances of
    // ResizeObserver are tracking the same element and the callback of one
    // of them changes content dimensions of the observed target. Sometimes
    // this may result in notifications being blocked for the rest of observers.
    activeObservers.forEach(function (observer) {
      return observer.broadcastActive();
    });
    return activeObservers.length > 0;
  };
  /**
   * Initializes DOM listeners.
   *
   * @private
   * @returns {void}
   */
  ResizeObserverController.prototype.connect_ = function () {
    // Do nothing if running in a non-browser environment or if listeners
    // have been already added.
    if (!isBrowser || this.connected_) {
      return;
    }
    // Subscription to the "Transitionend" event is used as a workaround for
    // delayed transitions. This way it's possible to capture at least the
    // final state of an element.
    document.addEventListener('transitionend', this.onTransitionEnd_);
    window.addEventListener('resize', this.refresh);
    if (mutationObserverSupported) {
      this.mutationsObserver_ = new MutationObserver(this.refresh);
      this.mutationsObserver_.observe(document, {
        attributes: true,
        childList: true,
        characterData: true,
        subtree: true
      });
    } else {
      document.addEventListener('DOMSubtreeModified', this.refresh);
      this.mutationEventsAdded_ = true;
    }
    this.connected_ = true;
  };
  /**
   * Removes DOM listeners.
   *
   * @private
   * @returns {void}
   */
  ResizeObserverController.prototype.disconnect_ = function () {
    // Do nothing if running in a non-browser environment or if listeners
    // have been already removed.
    if (!isBrowser || !this.connected_) {
      return;
    }
    document.removeEventListener('transitionend', this.onTransitionEnd_);
    window.removeEventListener('resize', this.refresh);
    if (this.mutationsObserver_) {
      this.mutationsObserver_.disconnect();
    }
    if (this.mutationEventsAdded_) {
      document.removeEventListener('DOMSubtreeModified', this.refresh);
    }
    this.mutationsObserver_ = null;
    this.mutationEventsAdded_ = false;
    this.connected_ = false;
  };
  /**
   * "Transitionend" event handler.
   *
   * @private
   * @param {TransitionEvent} event
   * @returns {void}
   */
  ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
    var _b = _a.propertyName,
      propertyName = _b === void 0 ? '' : _b;
    // Detect whether transition may affect dimensions of an element.
    var isReflowProperty = transitionKeys.some(function (key) {
      return !!~propertyName.indexOf(key);
    });
    if (isReflowProperty) {
      this.refresh();
    }
  };
  /**
   * Returns instance of the ResizeObserverController.
   *
   * @returns {ResizeObserverController}
   */
  ResizeObserverController.getInstance = function () {
    if (!this.instance_) {
      this.instance_ = new ResizeObserverController();
    }
    return this.instance_;
  };
  /**
   * Holds reference to the controller's instance.
   *
   * @private {ResizeObserverController}
   */
  ResizeObserverController.instance_ = null;
  return ResizeObserverController;
}();

/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */
var defineConfigurable = function defineConfigurable(target, props) {
  for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
    var key = _a[_i];
    Object.defineProperty(target, key, {
      value: props[key],
      enumerable: false,
      writable: false,
      configurable: true
    });
  }
  return target;
};

/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */
var getWindowOf = function getWindowOf(target) {
  // Assume that the element is an instance of Node, which means that it
  // has the "ownerDocument" property from which we can retrieve a
  // corresponding global object.
  var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
  // Return the local global object if it's not possible extract one from
  // provided element.
  return ownerGlobal || global$1;
};

// Placeholder of an empty content rectangle.
var emptyRect = createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */
function toFloat(value) {
  return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */
function getBordersSize(styles) {
  var positions = [];
  for (var _i = 1; _i < arguments.length; _i++) {
    positions[_i - 1] = arguments[_i];
  }
  return positions.reduce(function (size, position) {
    var value = styles['border-' + position + '-width'];
    return size + toFloat(value);
  }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */
function getPaddings(styles) {
  var positions = ['top', 'right', 'bottom', 'left'];
  var paddings = {};
  for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
    var position = positions_1[_i];
    var value = styles['padding-' + position];
    paddings[position] = toFloat(value);
  }
  return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */
function getSVGContentRect(target) {
  var bbox = target.getBBox();
  return createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */
function getHTMLElementContentRect(target) {
  // Client width & height properties can't be
  // used exclusively as they provide rounded values.
  var clientWidth = target.clientWidth,
    clientHeight = target.clientHeight;
  // By this condition we can catch all non-replaced inline, hidden and
  // detached elements. Though elements with width & height properties less
  // than 0.5 will be discarded as well.
  //
  // Without it we would need to implement separate methods for each of
  // those cases and it's not possible to perform a precise and performance
  // effective test for hidden elements. E.g. even jQuery's ':visible' filter
  // gives wrong results for elements with width & height less than 0.5.
  if (!clientWidth && !clientHeight) {
    return emptyRect;
  }
  var styles = getWindowOf(target).getComputedStyle(target);
  var paddings = getPaddings(styles);
  var horizPad = paddings.left + paddings.right;
  var vertPad = paddings.top + paddings.bottom;
  // Computed styles of width & height are being used because they are the
  // only dimensions available to JS that contain non-rounded values. It could
  // be possible to utilize the getBoundingClientRect if only it's data wasn't
  // affected by CSS transformations let alone paddings, borders and scroll bars.
  var width = toFloat(styles.width),
    height = toFloat(styles.height);
  // Width & height include paddings and borders when the 'border-box' box
  // model is applied (except for IE).
  if (styles.boxSizing === 'border-box') {
    // Following conditions are required to handle Internet Explorer which
    // doesn't include paddings and borders to computed CSS dimensions.
    //
    // We can say that if CSS dimensions + paddings are equal to the "client"
    // properties then it's either IE, and thus we don't need to subtract
    // anything, or an element merely doesn't have paddings/borders styles.
    if (Math.round(width + horizPad) !== clientWidth) {
      width -= getBordersSize(styles, 'left', 'right') + horizPad;
    }
    if (Math.round(height + vertPad) !== clientHeight) {
      height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
    }
  }
  // Following steps can't be applied to the document's root element as its
  // client[Width/Height] properties represent viewport area of the window.
  // Besides, it's as well not necessary as the <html> itself neither has
  // rendered scroll bars nor it can be clipped.
  if (!isDocumentElement(target)) {
    // In some browsers (only in Firefox, actually) CSS width & height
    // include scroll bars size which can be removed at this step as scroll
    // bars are the only difference between rounded dimensions + paddings
    // and "client" properties, though that is not always true in Chrome.
    var vertScrollbar = Math.round(width + horizPad) - clientWidth;
    var horizScrollbar = Math.round(height + vertPad) - clientHeight;
    // Chrome has a rather weird rounding of "client" properties.
    // E.g. for an element with content width of 314.2px it sometimes gives
    // the client width of 315px and for the width of 314.7px it may give
    // 314px. And it doesn't happen all the time. So just ignore this delta
    // as a non-relevant.
    if (Math.abs(vertScrollbar) !== 1) {
      width -= vertScrollbar;
    }
    if (Math.abs(horizScrollbar) !== 1) {
      height -= horizScrollbar;
    }
  }
  return createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
var isSVGGraphicsElement = function () {
  // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
  // interface.
  if (typeof SVGGraphicsElement !== 'undefined') {
    return function (target) {
      return target instanceof getWindowOf(target).SVGGraphicsElement;
    };
  }
  // If it's so, then check that element is at least an instance of the
  // SVGElement and that it has the "getBBox" method.
  // eslint-disable-next-line no-extra-parens
  return function (target) {
    return target instanceof getWindowOf(target).SVGElement && typeof target.getBBox === 'function';
  };
}();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
function isDocumentElement(target) {
  return target === getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */
function getContentRect(target) {
  if (!isBrowser) {
    return emptyRect;
  }
  if (isSVGGraphicsElement(target)) {
    return getSVGContentRect(target);
  }
  return getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */
function createReadOnlyRect(_a) {
  var x = _a.x,
    y = _a.y,
    width = _a.width,
    height = _a.height;
  // If DOMRectReadOnly is available use it as a prototype for the rectangle.
  var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
  var rect = Object.create(Constr.prototype);
  // Rectangle's properties are not writable and non-enumerable.
  defineConfigurable(rect, {
    x: x,
    y: y,
    width: width,
    height: height,
    top: y,
    right: x + width,
    bottom: height + y,
    left: x
  });
  return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */
function createRectInit(x, y, width, height) {
  return {
    x: x,
    y: y,
    width: width,
    height: height
  };
}

/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */
var ResizeObservation = /** @class */function () {
  /**
   * Creates an instance of ResizeObservation.
   *
   * @param {Element} target - Element to be observed.
   */
  function ResizeObservation(target) {
    /**
     * Broadcasted width of content rectangle.
     *
     * @type {number}
     */
    this.broadcastWidth = 0;
    /**
     * Broadcasted height of content rectangle.
     *
     * @type {number}
     */
    this.broadcastHeight = 0;
    /**
     * Reference to the last observed content rectangle.
     *
     * @private {DOMRectInit}
     */
    this.contentRect_ = createRectInit(0, 0, 0, 0);
    this.target = target;
  }
  /**
   * Updates content rectangle and tells whether it's width or height properties
   * have changed since the last broadcast.
   *
   * @returns {boolean}
   */
  ResizeObservation.prototype.isActive = function () {
    var rect = getContentRect(this.target);
    this.contentRect_ = rect;
    return rect.width !== this.broadcastWidth || rect.height !== this.broadcastHeight;
  };
  /**
   * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
   * from the corresponding properties of the last observed content rectangle.
   *
   * @returns {DOMRectInit} Last observed content rectangle.
   */
  ResizeObservation.prototype.broadcastRect = function () {
    var rect = this.contentRect_;
    this.broadcastWidth = rect.width;
    this.broadcastHeight = rect.height;
    return rect;
  };
  return ResizeObservation;
}();
var ResizeObserverEntry = /** @class */function () {
  /**
   * Creates an instance of ResizeObserverEntry.
   *
   * @param {Element} target - Element that is being observed.
   * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
   */
  function ResizeObserverEntry(target, rectInit) {
    var contentRect = createReadOnlyRect(rectInit);
    // According to the specification following properties are not writable
    // and are also not enumerable in the native implementation.
    //
    // Property accessors are not being used as they'd require to define a
    // private WeakMap storage which may cause memory leaks in browsers that
    // don't support this type of collections.
    defineConfigurable(this, {
      target: target,
      contentRect: contentRect
    });
  }
  return ResizeObserverEntry;
}();
var ResizeObserverSPI = /** @class */function () {
  /**
   * Creates a new instance of ResizeObserver.
   *
   * @param {ResizeObserverCallback} callback - Callback function that is invoked
   *      when one of the observed elements changes it's content dimensions.
   * @param {ResizeObserverController} controller - Controller instance which
   *      is responsible for the updates of observer.
   * @param {ResizeObserver} callbackCtx - Reference to the public
   *      ResizeObserver instance which will be passed to callback function.
   */
  function ResizeObserverSPI(callback, controller, callbackCtx) {
    /**
     * Collection of resize observations that have detected changes in dimensions
     * of elements.
     *
     * @private {Array<ResizeObservation>}
     */
    this.activeObservations_ = [];
    /**
     * Registry of the ResizeObservation instances.
     *
     * @private {Map<Element, ResizeObservation>}
     */
    this.observations_ = new MapShim();
    if (typeof callback !== 'function') {
      throw new TypeError('The callback provided as parameter 1 is not a function.');
    }
    this.callback_ = callback;
    this.controller_ = controller;
    this.callbackCtx_ = callbackCtx;
  }
  /**
   * Starts observing provided element.
   *
   * @param {Element} target - Element to be observed.
   * @returns {void}
   */
  ResizeObserverSPI.prototype.observe = function (target) {
    if (!arguments.length) {
      throw new TypeError('1 argument required, but only 0 present.');
    }
    // Do nothing if current environment doesn't have the Element interface.
    if (typeof Element === 'undefined' || !(Element instanceof Object)) {
      return;
    }
    if (!(target instanceof getWindowOf(target).Element)) {
      throw new TypeError('parameter 1 is not of type "Element".');
    }
    var observations = this.observations_;
    // Do nothing if element is already being observed.
    if (observations.has(target)) {
      return;
    }
    observations.set(target, new ResizeObservation(target));
    this.controller_.addObserver(this);
    // Force the update of observations.
    this.controller_.refresh();
  };
  /**
   * Stops observing provided element.
   *
   * @param {Element} target - Element to stop observing.
   * @returns {void}
   */
  ResizeObserverSPI.prototype.unobserve = function (target) {
    if (!arguments.length) {
      throw new TypeError('1 argument required, but only 0 present.');
    }
    // Do nothing if current environment doesn't have the Element interface.
    if (typeof Element === 'undefined' || !(Element instanceof Object)) {
      return;
    }
    if (!(target instanceof getWindowOf(target).Element)) {
      throw new TypeError('parameter 1 is not of type "Element".');
    }
    var observations = this.observations_;
    // Do nothing if element is not being observed.
    if (!observations.has(target)) {
      return;
    }
    observations.delete(target);
    if (!observations.size) {
      this.controller_.removeObserver(this);
    }
  };
  /**
   * Stops observing all elements.
   *
   * @returns {void}
   */
  ResizeObserverSPI.prototype.disconnect = function () {
    this.clearActive();
    this.observations_.clear();
    this.controller_.removeObserver(this);
  };
  /**
   * Collects observation instances the associated element of which has changed
   * it's content rectangle.
   *
   * @returns {void}
   */
  ResizeObserverSPI.prototype.gatherActive = function () {
    var _this = this;
    this.clearActive();
    this.observations_.forEach(function (observation) {
      if (observation.isActive()) {
        _this.activeObservations_.push(observation);
      }
    });
  };
  /**
   * Invokes initial callback function with a list of ResizeObserverEntry
   * instances collected from active resize observations.
   *
   * @returns {void}
   */
  ResizeObserverSPI.prototype.broadcastActive = function () {
    // Do nothing if observer doesn't have active observations.
    if (!this.hasActive()) {
      return;
    }
    var ctx = this.callbackCtx_;
    // Create ResizeObserverEntry instance for every active observation.
    var entries = this.activeObservations_.map(function (observation) {
      return new ResizeObserverEntry(observation.target, observation.broadcastRect());
    });
    this.callback_.call(ctx, entries, ctx);
    this.clearActive();
  };
  /**
   * Clears the collection of active observations.
   *
   * @returns {void}
   */
  ResizeObserverSPI.prototype.clearActive = function () {
    this.activeObservations_.splice(0);
  };
  /**
   * Tells whether observer has active observations.
   *
   * @returns {boolean}
   */
  ResizeObserverSPI.prototype.hasActive = function () {
    return this.activeObservations_.length > 0;
  };
  return ResizeObserverSPI;
}();

// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */
var ResizeObserver = /** @class */function () {
  /**
   * Creates a new instance of ResizeObserver.
   *
   * @param {ResizeObserverCallback} callback - Callback that is invoked when
   *      dimensions of the observed elements change.
   */
  function ResizeObserver(callback) {
    if (!(this instanceof ResizeObserver)) {
      throw new TypeError('Cannot call a class as a function.');
    }
    if (!arguments.length) {
      throw new TypeError('1 argument required, but only 0 present.');
    }
    var controller = ResizeObserverController.getInstance();
    var observer = new ResizeObserverSPI(callback, controller, this);
    observers.set(this, observer);
  }
  return ResizeObserver;
}();
// Expose public methods of ResizeObserver.
['observe', 'unobserve', 'disconnect'].forEach(function (method) {
  ResizeObserver.prototype[method] = function () {
    var _a;
    return (_a = observers.get(this))[method].apply(_a, arguments);
  };
});
var index = function () {
  // Export existing implementation if available.
  if (typeof global$1.ResizeObserver !== 'undefined') {
    return global$1.ResizeObserver;
  }
  return ResizeObserver;
}();function Modal(_ref) {
  var _document$body;
  var header = _ref.header,
    children = _ref.children,
    footer = _ref.footer,
    style = _ref.style,
    open = _ref.open,
    onRequestClose = _ref.onRequestClose,
    onClosed = _ref.onClosed,
    _ref$fitToBody = _ref.fitToBody,
    fitToBody = _ref$fitToBody === void 0 ? true : _ref$fitToBody;
  var _useState = useState((_document$body = document.body) === null || _document$body === void 0 ? void 0 : _document$body.offsetWidth),
    _useState2 = _slicedToArray(_useState, 2),
    modalWidth = _useState2[0],
    setModalWidth = _useState2[1];
  var resizeObserver = useRef(new index(function (entries) {
    var bodyEntry = entries[0];
    if (!bodyEntry || !fitToBody) return;
    setModalWidth(bodyEntry.contentRect.width);
  }));
  useEffect(function () {
    var _resizeObserver$curre;
    if (!fitToBody || !document.body) return;
    (_resizeObserver$curre = resizeObserver.current) === null || _resizeObserver$curre === void 0 ? void 0 : _resizeObserver$curre.observe(document.body);
    return function () {
      var _resizeObserver$curre2;
      if (!document.body) return;
      // eslint-disable-next-line react-hooks/exhaustive-deps
      (_resizeObserver$curre2 = resizeObserver.current) === null || _resizeObserver$curre2 === void 0 ? void 0 : _resizeObserver$curre2.unobserve(document.body);
    };
  }, [fitToBody]);
  var backdropStyle = fitToBody && modalWidth ? {
    width: "".concat(modalWidth, "px")
  } : undefined;

  // since the backdrop is faded in, we need a small delay so that the drop animation is actually noticeable
  var delayOpen = useInDelay$1(open !== null && open !== void 0 ? open : true, 150);
  return /*#__PURE__*/React__default.createElement(Backdrop$1, {
    open: open,
    onRequestClose: onRequestClose,
    onClosed: onClosed,
    style: backdropStyle
  }, /*#__PURE__*/React__default.createElement(DropAnimation, {
    appear: true,
    in: delayOpen,
    style: style('animation')
  }, /*#__PURE__*/React__default.createElement(ModalBase$1, {
    style: style,
    header: header,
    footer: footer
  }, children)));
}
var styled$6 = createDefaultStyle({
  width: width.modal,
  animation: {
    maxHeight: '100%',
    height: '100%'
  },
  '&fullscreen': {
    flex: 1,
    width: '100%',
    animation: {
      display: 'flex',
      flex: 1,
      width: '100%'
    }
  },
  '&fullheight': {
    flex: 1,
    animation: {
      display: 'flex',
      flex: 1
    }
  }
}, function (_ref2) {
  var fullscreen = _ref2.fullscreen,
    fullheight = _ref2.fullheight;
  return {
    '&fullscreen': fullscreen,
    '&fullheight': fullheight
  };
});
var Modal$1 = styled$6(Modal);function Dialog(_ref) {
  var header = _ref.header,
    footer = _ref.footer,
    style = _ref.style,
    children = _ref.children,
    open = _ref.open;
    _ref.fullscreen;
    _ref.fullheight;
    var onClosed = _ref.onClosed;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    shake = _useState2[0],
    setShake = _useState2[1];
  // since the backdrop is faded in, we need a small delay so that the scale animation is actually noticeable
  var delayOpen = useInDelay$1(open !== null && open !== void 0 ? open : true, 150);
  return /*#__PURE__*/React__default.createElement(Backdrop$1, {
    open: open,
    onRequestClose: function onRequestClose() {
      return setShake(true);
    },
    onClosed: onClosed
  }, /*#__PURE__*/React__default.createElement(ScaleAnimation, {
    appear: true,
    in: delayOpen,
    style: style('animation')
  }, /*#__PURE__*/React__default.createElement(ShakeAnimation, {
    in: shake,
    style: style('animation'),
    onEntered: function onEntered() {
      return setShake(false);
    }
  }, /*#__PURE__*/React__default.createElement(ModalBase$1, {
    style: style,
    header: header,
    footer: footer
  }, children))));
}
var styled$5 = createDefaultStyle({
  width: width.dialog,
  header: {
    paddingBottom: medium,
    minHeight: 76
  },
  animation: {
    maxHeight: '100%',
    height: '100%'
  },
  '&fullscreen': {
    flex: 1,
    width: '100%',
    animation: {
      display: 'flex',
      flex: 1,
      width: '100%'
    }
  },
  '&fullheight': {
    flex: 1,
    animation: {
      display: 'flex',
      flex: 1
    }
  }
}, function (_ref2) {
  var fullscreen = _ref2.fullscreen,
    fullheight = _ref2.fullheight;
  return {
    '&fullscreen': fullscreen,
    '&fullheight': fullheight
  };
});
var Dialog$1 = styled$5(Dialog);var ToastContext = /*#__PURE__*/createContext([function () {
  throw new Error('Cannot register toast outside of a provider.');
}, function () {
  throw new Error('Cannot unregister toast outside of a provider.');
}, Object.freeze({})]);
var ToastContext$1 = ToastContext;function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function ToastsContainer(_ref) {
  var style = _ref.style,
    children = _ref.children;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    toasts = _useState2[0],
    setToasts = _useState2[1];
  var _useState3 = useState(Object.freeze({})),
    _useState4 = _slicedToArray(_useState3, 2),
    portals = _useState4[0],
    setPortals = _useState4[1];
  var registerToast = useCallback(function () {
    var id = createId();
    setToasts(function (toastIds) {
      return [].concat(_toConsumableArray(toastIds), [id]);
    });
    return id;
  }, []);
  var unregisterToast = useCallback(function (id) {
    setToasts(function (toastIds) {
      return toastIds.filter(function (toastId) {
        return toastId !== id;
      });
    });
  }, []);
  return /*#__PURE__*/React__default.createElement(ToastContext$1.Provider, {
    value: [registerToast, unregisterToast, portals]
  }, /*#__PURE__*/React__default.createElement("div", style, /*#__PURE__*/React__default.createElement("div", style('host'), toasts.map(function (id) {
    return /*#__PURE__*/React__default.createElement("div", _extends({}, style('toast'), {
      key: id,
      ref: function ref(node) {
        if (!portals[id] && node) {
          setPortals(function (portals) {
            return _objectSpread$1(_objectSpread$1({}, portals), {}, _defineProperty({}, id, node));
          });
        }
      }
    }));
  }))), children);
}
var createId = function createId() {
  return Math.floor(Math.random() * new Date().getTime()).toString(36);
};
var styled$4 = createDefaultStyle({
  host: {
    position: 'absolute',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    left: 0,
    right: 0,
    zIndex: toast,
    marginLeft: small$1,
    marginRight: small$1,
    pointerEvents: 'none' // the container might overlay interactive elements
  },

  toast: _objectSpread$1({
    width: '100%',
    maxWidth: 784,
    marginTop: small$1,
    pointerEvents: 'auto'
  }, sm({
    width: '100%'
  }))
});
var ToastsContainer$1 = styled$4(ToastsContainer);function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function Toast(_ref) {
  var icon = _ref.icon,
    children = _ref.children,
    action = _ref.action,
    style = _ref.style,
    className = _ref.className,
    classNames = _ref.classNames,
    autoCloseAfter = _ref.autoCloseAfter,
    onClose = _ref.onClose;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    showToast = _useState2[0],
    setShowToast = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    hover = _useState4[0],
    setHover = _useState4[1];
  var _useToastPortal = useToastPortal(),
    _useToastPortal2 = _slicedToArray(_useToastPortal, 2),
    portal = _useToastPortal2[0],
    unregisterToast = _useToastPortal2[1];
  var styles = useStyles(defaultStyles$1, {
    className: className,
    style: style,
    classNames: classNames
  });
  useEffect(function () {
    if (portal && showToast == null) {
      setShowToast(true);
    }
  }, [showToast, portal]);
  useEffect(function () {
    var timeout;
    if (autoCloseAfter && !hover) {
      timeout = setTimeout(function () {
        setShowToast(false);
      }, autoCloseAfter);
    }
    return function () {
      if (timeout) {
        clearTimeout(timeout);
      }
    };
  }, [autoCloseAfter, hover]);
  if (!portal) {
    return null;
  }
  return /*#__PURE__*/createPortal( /*#__PURE__*/React__default.createElement(SlideAnimation$1, {
    down: true,
    in: !!showToast,
    onExited: function onExited() {
      unregisterToast();
      if (onClose) {
        onClose();
      }
    },
    style: styles
  }, /*#__PURE__*/React__default.createElement("div", _extends({
    "data-testid": "toast-component"
  }, styles('toast'), {
    onMouseEnter: function onMouseEnter() {
      return setHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setHover(false);
    }
  }), icon && /*#__PURE__*/React__default.createElement(Glyph, {
    style: styles('icon')
  }, icon), /*#__PURE__*/React__default.createElement("div", styles('content'), children), typeof action === 'function' ? action(function () {
    return setShowToast(false);
  }) : action)), portal);
}
var useToastPortal = function useToastPortal(autoCloseAfter) {
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    toastId = _useState6[0],
    setToastId = _useState6[1];
  var _useContext = useContext(ToastContext$1),
    _useContext2 = _slicedToArray(_useContext, 3),
    registerToast = _useContext2[0],
    unregisterToast = _useContext2[1],
    portals = _useContext2[2];
  useEffect(function () {
    var id = registerToast();
    setToastId(id);
    return function () {
      return void unregisterToast(id);
    };
  }, [registerToast, unregisterToast]);
  var unregisterCallback = useCallback(function () {
    if (toastId) {
      unregisterToast(toastId);
    }
  }, [toastId, unregisterToast]);
  if (!toastId) {
    return [null, unregisterCallback];
  }
  return [portals[toastId], unregisterCallback];
};
var defaultStyles$1 = _objectSpread(_objectSpread({
  borderRadius: 2
}, menu), {}, {
  toast: {
    paddingLeft: medium,
    display: 'flex',
    alignItems: 'flex-start'
  },
  content: {
    flex: 1,
    paddingTop: xxsmall,
    paddingBottom: xxsmall,
    paddingRight: small$1
  },
  icon: {
    marginRight: small$1,
    marginTop: xxsmall
  }
});var Title = function Title(_ref) {
  var title = _ref.title,
    style = _ref.style;
  if (!title) {
    return null;
  }
  return /*#__PURE__*/React__default.createElement("div", style('title'), title);
};
var Hint = function Hint(_ref2) {
  var icon = _ref2.icon,
    children = _ref2.children,
    title = _ref2.title,
    style = _ref2.style;
  return /*#__PURE__*/React__default.createElement("div", _extends({
    "data-testid": "hint-component"
  }, style), /*#__PURE__*/React__default.createElement("div", style('icon'), _isString(icon) ? /*#__PURE__*/React__default.createElement(Glyph, null, icon) : icon), /*#__PURE__*/React__default.createElement("div", style('content'), /*#__PURE__*/React__default.createElement(Title, {
    style: style,
    title: title
  }), /*#__PURE__*/React__default.createElement("div", style('body'), children)));
};
var styled$3 = createDefaultStyle({
  display: 'flex',
  overflow: 'hidden',
  paddingTop: small,
  paddingBottom: small,
  paddingRight: normal,
  paddingLeft: normal,
  lineHeight: body.lineHeight,
  fontSize: body.fontSize,
  icon: {
    marginRight: small,
    fontSize: size$1.normal
  },
  title: {
    fontWeight: weight.bold,
    paddingBottom: xsmall
  },
  content: {
    display: 'flex',
    flexDirection: 'column'
  }
});
var Hint$1 = styled$3(Hint);var TableContext = /*#__PURE__*/createContext({
  compact: false
});var _excluded$2 = ["children", "style", "compact", "fullWidth"];
function Table(_ref) {
  var children = _ref.children,
    style = _ref.style,
    compact = _ref.compact;
    _ref.fullWidth;
    var rest = _objectWithoutProperties(_ref, _excluded$2);
  return /*#__PURE__*/React__default.createElement(TableContext.Provider, {
    value: {
      compact: !!compact
    }
  }, /*#__PURE__*/React__default.createElement("table", _extends({}, rest, style), children));
}
var styled$2 = createDefaultStyle({
  borderStyle: 'none',
  borderSpacing: 0,
  borderCollapse: 'collapse',
  fontSize: size$1.button,
  lineHeight: '20px',
  textAlign: 'left',
  fontFeatureSettings: 'tnum',
  fontVariantNumeric: 'tabular-nums',
  '&fullWidth': {
    width: '100%'
  }
}, function (_ref2) {
  var fullWidth = _ref2.fullWidth;
  return {
    '&fullWidth': fullWidth
  };
});
var Table$1 = styled$2(Table);function withTableContext(Component) {
  return function (props) {
    return /*#__PURE__*/React__default.createElement(TableContext.Consumer, null, function (_ref) {
      var compact = _ref.compact;
      return /*#__PURE__*/React__default.createElement(Component, _extends({}, props, {
        compact: compact
      }));
    });
  };
}var _excluded$1 = ["children", "style", "compact", "align"];
function HeaderCell(_ref) {
  var children = _ref.children,
    style = _ref.style;
    _ref.compact;
    _ref.align;
    var rest = _objectWithoutProperties(_ref, _excluded$1);
  return /*#__PURE__*/React__default.createElement("th", _extends({}, rest, style), children);
}
var styled$1 = createDefaultStyle({
  paddingLeft: small$1,
  paddingRight: small$1,
  borderStyle: 'solid',
  borderWidth: '0 1px 1px 0',
  height: tableRow.normal,
  verticalAlign: 'top',
  fontWeight: weight.normal,
  '&compact': {
    paddingLeft: xxsmall,
    paddingRight: xxsmall
  },
  '&rightAligned': {
    textAlign: 'right'
  },
  ':last-child': {
    borderRightWidth: 0
  }
}, function (_ref2) {
  var compact = _ref2.compact,
    align = _ref2.align;
  return {
    '&compact': compact,
    '&rightAligned': align === 'right'
  };
});
var enhance$1 = compose(withTableContext, styled$1);
var HeaderCell$1 = enhance$1(HeaderCell);var _excluded = ["children", "style", "compact", "align", "backgroundColor"];
function Cell(_ref) {
  var children = _ref.children,
    style = _ref.style;
    _ref.compact;
    _ref.align;
    var backgroundColor = _ref.backgroundColor,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React__default.createElement("td", _extends({}, rest, inline(style, {
    backgroundColor: backgroundColor
  })), children);
}
var styled = createDefaultStyle({
  paddingLeft: small$1,
  paddingRight: small$1,
  height: tableRow.normal,
  borderStyle: 'solid',
  borderTopWidth: 0,
  borderRightWidth: 0,
  borderBottomWidth: 1,
  borderLeftWidth: 0,
  verticalAlign: 'top',
  '&compact': {
    paddingLeft: xxsmall,
    paddingRight: xxsmall,
    height: tableRow.compact
  },
  '&rightAligned': {
    textAlign: 'right'
  }
}, function (_ref2) {
  var compact = _ref2.compact,
    align = _ref2.align;
  return {
    '&compact': compact,
    '&rightAligned': align === 'right'
  };
});
var enhance = compose(withTableContext, styled);
var Cell$1 = enhance(Cell);var defaultMaxWidth = 300;
function Tag(_ref) {
  var children = _ref.children,
    showDot = _ref.showDot,
    dotBackgroundColor = _ref.dotBackgroundColor,
    dotBorderColor = _ref.dotBorderColor,
    style = _ref.style,
    _ref$active = _ref.active,
    active = _ref$active === void 0 ? false : _ref$active,
    className = _ref.className,
    classNames = _ref.classNames,
    _ref$small = _ref.small,
    small = _ref$small === void 0 ? false : _ref$small,
    _ref$interactive = _ref.interactive,
    interactive = _ref$interactive === void 0 ? false : _ref$interactive,
    title = _ref.title,
    icon = _ref.icon,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    onDismiss = _ref.onDismiss,
    _onClick = _ref.onClick;
  var _useState = useState(function () {
      return _uniqueId('tag-');
    }),
    _useState2 = _slicedToArray(_useState, 1),
    id = _useState2[0];
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    parentWidth = _useState4[0],
    setParentWidth = _useState4[1];
  function isInteractive() {
    return (interactive || !!_onClick) && !disabled;
  }
  var styles = useStyles(defaultStyles, {
    className: className,
    classNames: classNames,
    style: style
  }, {
    '&small': small,
    '&narrow': parentWidth < defaultMaxWidth,
    '&interactive': isInteractive()
  });
  var measuredTagRef = useCallback(function (node) {
    if (node !== null) {
      var _node$parentNode, _node$parentNode$getB;
      setParentWidth(((_node$parentNode = node.parentNode) === null || _node$parentNode === void 0 ? void 0 : (_node$parentNode$getB = _node$parentNode.getBoundingClientRect()) === null || _node$parentNode$getB === void 0 ? void 0 : _node$parentNode$getB.width) || defaultMaxWidth);
    }
  }, []);
  return /*#__PURE__*/React__default.createElement("div", _extends({}, inline(styles, {
    maxWidth: "min(100%, ".concat(defaultMaxWidth, "px)")
  }), {
    role: "button",
    tabIndex: isInteractive() ? 0 : -1,
    "aria-labelledby": id,
    "aria-pressed": active,
    "aria-disabled": disabled,
    ref: measuredTagRef,
    onClick: function onClick(event) {
      if (_onClick && !disabled) {
        _onClick(event);
      }
    },
    onKeyDown: function onKeyDown(event) {
      if (disabled || !_onClick) {
        return;
      }
      if (event.key === 'Enter' || event.key === ' ') {
        if (_onClick) {
          event.preventDefault();
          _onClick(event);
        }
      }
    }
  }), showDot && /*#__PURE__*/React__default.createElement("div", inline(styles('dot'), {
    backgroundColor: dotBackgroundColor,
    borderColor: dotBorderColor
  })), /*#__PURE__*/React__default.createElement("div", _extends({}, styles('content'), {
    title: title
  }), icon && /*#__PURE__*/React__default.createElement("div", styles('icon'), /*#__PURE__*/React__default.createElement(Glyph, null, icon)), title && /*#__PURE__*/React__default.createElement("div", _extends({}, styles('title'), {
    title: title
  }), title), /*#__PURE__*/React__default.createElement("label", _extends({}, styles('label'), {
    id: id,
    title: typeof children === 'string' ? children : title
  }), children)), !disabled && onDismiss && /*#__PURE__*/React__default.createElement("button", _extends({
    "data-testid": "tag-button"
  }, styles('action'), {
    onClick: onDismiss
  }), /*#__PURE__*/React__default.createElement(Glyph, null, "reset")));
}
var borderWidth = 1;
var lineHeight = 20;
var defaultStyles = {
  display: 'inline-flex',
  alignItems: 'center',
  verticalAlign: 'middle',
  maxWidth: defaultMaxWidth,
  cursor: 'default',
  outline: 0,
  lineHeight: "".concat(lineHeight, "px"),
  borderWidth: borderWidth,
  borderStyle: 'solid',
  borderRadius: xsmall$1 + 2 * borderWidth,
  paddingTop: xxxsmall - borderWidth,
  paddingRight: xsmall$1,
  paddingBottom: xxxsmall - borderWidth,
  paddingLeft: xsmall$1,
  fontSize: size$1.small,
  dot: {
    width: xsmall$1,
    minWidth: xsmall$1,
    height: xsmall$1,
    marginLeft: -xxxsmall,
    marginRight: xxsmall,
    borderWidth: 1,
    borderStyle: 'solid',
    borderRadius: '50%'
  },
  action: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'transparent',
    marginLeft: xxsmall,
    marginRight: -xxsmall,
    cursor: 'pointer',
    borderWidth: 0,
    borderRadius: '50%',
    overflow: 'hidden',
    color: 'inherit',
    width: lineHeight - xxxsmall,
    height: lineHeight - xxxsmall,
    lineHeight: 1
  },
  content: {
    display: 'flex',
    flexBasis: 'auto',
    flexGrow: 1,
    flexShrink: 1,
    minWidth: 0
  },
  label: {
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden'
  },
  title: {
    fontWeight: weight.bold,
    marginRight: xxxsmall,
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden'
  },
  icon: {
    marginRight: xxxsmall,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  '&small': {
    paddingTop: 0,
    paddingRight: xxsmall,
    paddingBottom: 0,
    paddingLeft: xxsmall,
    borderRadius: xxsmall + 2 * borderWidth,
    lineHeight: "".concat(lineHeight - 2 * borderWidth, "px"),
    action: {
      marginRight: -xxsmall + 1
    }
  },
  '&interactive': {
    cursor: 'pointer'
  },
  '&narrow': {
    maxWidth: '100%'
  }
};export{Article,Body,Box,Button,Caption,Cell$1 as Cell,DateInput$1 as Date,DateCombo,DatePicker$1 as DatePicker,DateTime$1 as DateTime,DateTimeLocal,Dialog$1 as Dialog,DropAnimation,DropZone$1 as DropZone,Dropdown$1 as Dropdown,DropdownSelect$1 as DropdownSelect,DurationInput$1 as DurationInput,Email,EmailInput$1 as EmailInput,FadeAnimation,FileSelect$1 as File,Glyph,HeaderCell$1 as HeaderCell,Hint$1 as Hint,HomeGlyph,IconButton,Input$1 as Input,keycodes as KEYCODES,Modal$1 as Modal,ModalBase$1 as ModalBase,Number$1 as Number,NumberInput$1 as NumberInput,Option$1 as Option,ResponsivePanel$1 as PanelStructure,Percentage$1 as Percentage,ScaleAnimation,Select$1 as Select,ShakeAnimation,SlideAnimation$1 as SlideAnimation,Stack,StrongCaption,Table$1 as Table,Tag,Text,TextInput$1 as TextInput,Textarea$1 as Textarea,Time$1 as Time,Title1,Title2,Title3,Title4,Toast,ToastContext$1 as ToastContext,ToastsContainer$1 as ToastsContainer,Url,UrlInput$1 as UrlInput,accessInstanceMember$1 as accessInstanceMember,border,createApplyDiscard,createNullableText as createNullable,createSyncBlur,createSyncFocus,createValueMapper,createDefaultStyle as defaultStyle,detectBrowser,disableIf$1 as disableIf,index$1 as dropdownEnhancers,font,formatUri$1 as formatUri,fuzzySearch,hideClearInIE,isNumber,media,merge$1 as merge,omitProps,onBlurWithRelatedTarget$1 as onBlurWithRelatedTarget,padding,parseNumberString,sanitizeNumberInput,semicontrollable$1 as semicontrollable,sequence,shadow,size,spacing,stickWidgetToInput$1 as stickWidgetToInput,transition,enhance$8 as triggerOnCompleteOnBlur,triggerOnCompleteOnChange,triggerOnCompleteOnEnter$1 as triggerOnCompleteOnEnter,uncontrollable,useInDelay$1 as useInDelay,usePortal,warn$1 as warn,withAsyncHandlers$1 as withAsyncHandlers,withTableContext,wrapOnComplete$1 as wrapOnComplete,zIndex};//# sourceMappingURL=core.esm.js.map
